const dict = {
  uk: {
    nav: {
      profile: 'Профіль',
      overview: 'Огляд',
      users: 'Користувачі',
      finance: 'Фінанси',
      pricing: 'Ціни',
      products: 'Товари',
      programs: 'Програми',
      studyPlan: 'План навчання',
      reviews: 'Відгуки',
      settings: 'Налаштування',
      lessons: 'Уроки',
      sessions: 'Заняття',
      teacherLeaves: 'Відпустки',
      trialForms: 'Пробні заняття',
      clubs: 'Клуби',
      courses: 'Курси',
      offers: 'Пропозиції',
      promoCodes: 'Промокоди',
      stickers: 'Стікери',
      books: 'Книги',
      kenSkins: 'Скіни Кена',
      chat: 'Чат',
      aiLesson: 'AI урок',
      more: 'Більше',
      readerTitle: 'Reader — застосунок для читання',
    },
    aiLesson: {
      title: 'Налаштування AI',
      description: 'Обери презентації і слайди, які AI завжди використовуватиме як стильові референси. Їх не треба обирати заново при кожній генерації.',
      templatesHeading: 'Шаблони-референси',
      empty: 'Поки що немає шаблонів.',
      add: 'Додати шаблон',
      save: 'Зберегти',
      delete: 'Видалити',
      confirmDelete: 'Видалити цей шаблон?',
      loadError: 'Не вдалося завантажити шаблони',
      saveError: 'Не вдалося зберегти шаблон',
      deleteError: 'Не вдалося видалити шаблон',
    },
    overview: {
      students: 'Учні',
      teachers: 'Вчителі',
      admins: 'Адміни',
      lessonsHeld: 'Уроків проведено',
      revenue: 'Дохід',
      thisMonth: '+{{count}} цього місяця',
      revenueThisMonth: '+{{amount}} цього місяця',
      loadError: 'Помилка завантаження',
      birthdays: 'Дні народження',
      birthdayToday: 'Сьогодні',
      birthdayTomorrow: 'Завтра',
      birthdayIntro: 'день народження у',
      promoCode: 'Промокод',
      promoCodeMeta: '(1 заняття клубу, 60 днів)',
      kenSkin: 'Скін Кена',
      bundlePending: 'Подарунковий набір буде надіслано наступним годинним запуском планувальника.',
      recentActivity: 'Остання активність',
      activityLoadError: 'Не вдалося завантажити активність: {{error}}',
      loading: 'Завантаження…',
      noActivity: 'Поки що немає активності',
      records: 'записів',
      record: 'запис',
      justNow: 'щойно',
      minutesAgo: '{{count}} хв тому',
      hoursAgo: '{{count}} год тому',
      daysAgo: '{{count}} дн тому',
    },
    profileTab: {
      title: 'Мій профіль',
      personalInfo: 'Особиста інформація',
      permissions: 'Мої дозволи',
      superAdmin: 'Головний адміністратор',
      superAdminDesc: 'Повний доступ до всіх функцій платформи',
      noPermissions: 'Немає призначених дозволів',
      changePassword: 'Змінити пароль',
      currentPassword: 'Поточний пароль',
      newPassword: 'Новий пароль',
      confirmPassword: 'Підтвердіть пароль',
      passwordMismatch: 'Паролі не співпадають',
      passwordTooShort: 'Новий пароль має містити мінімум 8 символів',
      passwordChangeError: 'Помилка зміни пароля',
      connectionError: 'Помилка з\'єднання',
      passwordChanged: 'Пароль успішно змінено',
      submitPassword: 'Змінити пароль',
      timezone: 'Часовий пояс',
      saved: 'Збережено',
      timezoneHelp: 'Цей часовий пояс використовується для відображення розкладу та часу подій.',
      theme: 'Тема оформлення',
      themeLight: 'Світла',
      themeDark: 'Темна',
      themeHelp: 'Вибір теми зберігається лише в цьому браузері.',
      email: 'Email',
      nickname: 'Нікнейм',
      telegramTitle: 'Telegram сповіщення',
      telegramHelp: 'Отримуйте в Telegram сповіщення про події з вкладок адмін-панелі, до яких у вас є доступ.',
      telegramConnect: 'Підключити Telegram',
      telegramConnected: 'Telegram підключено',
      telegramDisconnect: 'Відключити',
      telegramOpenLink: 'Відкрити бот у Telegram',
      telegramLinkHint: 'Посилання дійсне 15 хв. Відкрийте його на пристрої з Telegram і натисніть Start.',
      telegramError: 'Не вдалося виконати запит',
    },
    settingsTab: {
      title: 'Налаштування системи',
      general: 'Загальні налаштування',
      registration: 'Реєстрація нових користувачів',
      moderation: 'Модерація контенту',
      emailNotifications: 'Email сповіщення',
      enabled: 'Увімкнено',
      disabled: 'Вимкнено',
      platformTimezone: 'Часовий пояс платформи',
      platformTimezoneHelp: 'Цей часовий пояс використовується для відображення часу у відгуках, звітах та зверненнях до техпідтримки',
      timezoneSearchPlaceholder: 'Пошук країни або міста...',
      timezoneNotFound: 'Часовий пояс не знайдено',
      bankRequisites: 'Реквізити для оплати',
      bankRequisitesHelp: 'Ці реквізити побачать учні при поповненні балансу',
      cardNumber: 'Номер картки',
      cardholderName: 'Ім\'я отримувача (латиницею)',
      bankName: 'Назва банку',
      bankNamePlaceholder: 'ПриватБанк / Monobank',
      additionalInfo: 'Додаткова інформація',
      additionalInfoPlaceholder: 'Призначення платежу, примітки для учнів...',
      saveRequisites: 'Зберегти реквізити',
      integrations: 'Інтеграції',
      livekit: 'LiveKit (відеодзвінки)',
      apiKeyConfigured: 'API ключ налаштовано',
      stripe: 'Stripe (платежі)',
      notConfigured: 'Не налаштовано',
      configure: 'Налаштувати',
      saveChanges: 'Зберегти зміни',
    },
    matchingWeights: {
      title: 'Ваги матчингу програм',
      help: 'Ваги (у %) для автоматичного підбору програми студенту. Сума повинна = 100.',
      sum: 'Сума: {{sum}}%',
      sumError: 'Сума ваг повинна = 100 (зараз {{sum}})',
      saveError: 'Не вдалося зберегти',
      saveWeights: 'Зберегти ваги',
      weightLevel: 'Рівень',
      weightAge: 'Вік',
      weightTopics: 'Теми',
      weightLearningGoal: 'Мета вивчення',
      weightFrequency: 'Частота',
      weightEnglishType: 'Тип англійської',
    },
    homework: {
      title: 'Домашні завдання',
      subtitle: 'Створюйте інтерактивні завдання та прив\'язуйте їх до уроків',
      createButton: 'Створити завдання',
      loading: 'Завантаження домашніх завдань...',
      exercisesCount: '{{count}} вправ',
      points: 'Балів: {{count}}',
      words: 'Слів: {{count}}',
      updated: 'Оновлено: {{date}}',
      previewAsStudent: 'Переглянути як учень',
      edit: 'Редагувати',
      delete: 'Видалити',
      deleteTitle: 'Видалити завдання?',
      deleteMessage: 'Видалити домашнє завдання?',
      empty: 'Немає домашніх завдань',
      emptyDesc: 'Створіть перше інтерактивне завдання для учнів',
    },
    repetitionGames: {
      title: 'Ігри на повторення',
      subtitle: 'Створюйте ігрові вправи для повторення пройденого матеріалу',
      createButton: 'Додати гру',
      empty: 'Немає ігор на повторення',
      emptyDesc: 'Натисни «Додати гру» щоб створити першу',
      preview: 'Переглянути',
      bind: 'Прив’язати до уроку',
      unbind: 'Відв’язати',
      bindTitle: 'Прив’язати гру до уроків',
      bindNoPrograms: 'Немає програм для прив’язки',
      boundToCount_one: 'у {{count}} уроці',
      boundToCount_few: 'у {{count}} уроках',
      boundToCount_many: 'у {{count}} уроках',
      boundToCount_other: 'у {{count}} уроках',
    },
    moduleTests: {
      title: 'Модульні тести',
      subtitle: 'Створюйте підсумкові тести для модулів програми, щоб перевірити засвоєння матеріалу',
      createButton: 'Створити тест',
      loading: 'Завантаження модульних тестів...',
      exercises: '{{count}} завдань',
      points: 'Балів: {{count}}',
      passingScore: 'Прохідний: {{score}}%',
      timeLimit: 'Ліміт: {{minutes}} хв',
      updated: 'Оновлено: {{date}}',
      previewAsStudent: 'Переглянути як учень',
      deleteTitle: 'Видалити тест?',
      deleteMessage: 'Видалити модульний тест? Цю дію не можна скасувати.',
      empty: 'Немає модульних тестів',
      emptyDesc: 'Створіть перший підсумковий тест для модуля програми',
    },
    programs: {
      subTabs: {
        programs: 'Програми',
        presentations: 'Презентації',
        homework: 'Домашні завдання',
        repetitionGames: 'Ігри на повторення',
        moduleTests: 'Модульний тест',
      },
      title: 'Навчальні програми',
      subtitle: 'Створюйте програми з послідовних уроків для учнів',
      createButton: 'Створити програму',
      copySuffix: '(копія)',
      moduleAndLessonCount: '{{modules}} модулів · {{lessons}} уроків',
      duplicate: 'Дублювати',
      deleteTitle: 'Видалити програму?',
      deleteMessage: 'Видалити програму? Це не вплине на існуючі призначення.',
      deleteErrorTitle: 'Не вдалось видалити програму',
      deleteErrorMessage: 'Невідома помилка. Можливо, на програму посилаються заплановані уроки або інші записи.',
      empty: 'Немає програм',
      emptyDesc: 'Створіть першу навчальну програму для учнів',
    },
    stickersAndFrames: {
      stickers: 'Стікери',
      frames: 'Рамки',
      photos: 'Фото',
    },
    imageCropper: {
      size: 'Розмір: {{w}} × {{h}} px',
      loading: 'Завантаження...',
      reset: 'Скинути',
      cancel: 'Скасувати',
      apply: 'Застосувати',
      cropFailed: 'Не вдалося обрізати зображення. Спробуйте перезавантажити файл.',
    },
    stickers: {
      title: 'Стікери',
      subtitle: 'Керування стікерами для редактора презентацій',
      addSticker: 'Додати стікер',
      newSticker: 'Новий стікер',
      editSticker: 'Редагування стікера',
      imageLabel: 'Зображення стікера',
      dropRelease: 'Відпустіть для завантаження',
      dropPrompt: 'Перетягніть або натисніть',
      allowedTypes: 'PNG, GIF, WebP (до 5MB)',
      crop: 'Обрізати',
      stickerName: 'Назва стікера',
      stickerNamePlaceholder: 'Наприклад: Pizza',
      tags: 'Теги для пошуку',
      tagPlaceholder: 'Введіть тег і натисніть Enter',
      tagHelp: 'Додайте кілька тегів різними мовами для кращого пошуку (pizza, піца, їжа)',
      searchPlaceholder: 'Пошук за назвою або тегом...',
      allStickers: 'Всі стікери ({{count}})',
      foundStickers: 'Знайдено ({{count}})',
      empty: 'Немає стікерів',
      emptyHint: 'Натисніть "Додати стікер" щоб створити перший',
      noSearchResults: 'Нічого не знайдено',
      noSearchResultsHint: 'Спробуйте змінити пошуковий запит',
      loadError: 'Не вдалося завантажити стікери',
      formatError: 'Дозволені формати: JPEG, PNG, GIF, WebP',
      sizeError: 'Максимальний розмір файлу: 5MB',
      nameRequired: 'Введіть назву стікера',
      imageRequired: 'Завантажте зображення стікера',
      tagRequired: 'Додайте хоча б один тег для пошуку',
      created: 'Стікер створено',
      updated: 'Стікер оновлено',
      deleted: 'Стікер видалено',
      saveError: 'Не вдалося зберегти стікер',
      deleteError: 'Не вдалося видалити стікер',
      deleteTitle: 'Видалити стікер?',
      deleteMessage: 'Ви впевнені, що хочете видалити стікер "{{name}}"?',
    },
    frames: {
      title: 'Рамки',
      subtitle: 'Декоративні рамки (телефон, TV, планшет) для редактора презентацій. Всередину можна вставити фото або відео.',
      addFrame: 'Додати рамку',
      newFrame: 'Нова рамка',
      editFrame: 'Редагування рамки',
      imageLabel: 'Зображення рамки (SVG з прозорою зоною екрана)',
      dropRelease: 'Відпустіть для завантаження',
      dropPrompt: 'Перетягніть або натисніть',
      allowedTypes: 'SVG, PNG, WebP (до 5MB)',
      crop: 'Обрізати',
      previewHelp: 'Червона рамка показує де буде відео/фото. Налаштуй числа справа.',
      frameName: 'Назва рамки',
      frameNamePlaceholder: 'Наприклад: iPhone',
      screenAreaLabel: 'Зона екрана (% від розміру рамки)',
      xLeft: 'X (зліва)',
      yTop: 'Y (зверху)',
      width: 'Ширина',
      height: 'Висота',
      radius: 'Закруглення',
      defaultsNote: 'Дефолт для типового смартфона: X=8, Y=6, W=84, H=88, R=6',
      allFrames: 'Всі рамки ({{count}})',
      screenSize: 'екран {{width}}×{{height}}%',
      empty: 'Немає рамок',
      emptyHint: 'Натисніть "Додати рамку" щоб створити першу',
      loadError: 'Не вдалося завантажити рамки',
      nameRequired: 'Введіть назву рамки',
      imageRequired: 'Завантажте зображення рамки',
      formatError: 'Дозволені формати: SVG, PNG, WebP, JPEG',
      sizeError: 'Максимальний розмір файлу: 5MB',
      created: 'Рамку створено',
      updated: 'Рамку оновлено',
      deleted: 'Рамку видалено',
      saveError: 'Не вдалося зберегти рамку',
      deleteError: 'Не вдалося видалити рамку',
      deleteTitle: 'Видалити рамку?',
      deleteMessage: 'Ви впевнені, що хочете видалити рамку "{{name}}"?',
      success: 'Успіх',
      shapeLabel: 'Форма зони',
      shapeRect: 'Прямокутник',
      shapePerspective: 'Перспектива (4 кути)',
      shapeHelp: 'Перспектива — для рамок, намальованих під кутом (наприклад, фоторамка на підставці).',
      cornersHint: 'Перетягуй кутові точки на прев\'ю, щоб зображення точно вписалося в рамку.',
      cornerTL: 'Верх-ліво',
      cornerTR: 'Верх-право',
      cornerBR: 'Низ-право',
      cornerBL: 'Низ-ліво',
    },
    photos: {
      title: 'Фото',
      subtitle: 'Керування фото для редактора презентацій',
      addPhoto: 'Додати фото',
      newPhoto: 'Нове фото',
      editPhoto: 'Редагування фото',
      imageLabel: 'Зображення фото',
      dropRelease: 'Відпустіть для завантаження',
      dropPrompt: 'Перетягніть або натисніть',
      allowedTypes: 'PNG, GIF, WebP, JPEG (до 5MB)',
      crop: 'Обрізати',
      photoName: 'Назва фото',
      photoNamePlaceholder: 'Наприклад: Pizza',
      tags: 'Теги для пошуку',
      tagPlaceholder: 'Введіть тег і натисніть Enter',
      tagHelp: 'Додайте кілька тегів різними мовами для кращого пошуку (pizza, піца, їжа)',
      searchPlaceholder: 'Пошук за назвою або тегом...',
      allPhotos: 'Всі фото ({{count}})',
      foundPhotos: 'Знайдено ({{count}})',
      empty: 'Немає фото',
      emptyHint: 'Натисніть "Додати фото" щоб створити перше',
      noSearchResults: 'Нічого не знайдено',
      noSearchResultsHint: 'Спробуйте змінити пошуковий запит',
      loadError: 'Не вдалося завантажити фото',
      formatError: 'Дозволені формати: JPEG, PNG, GIF, WebP',
      sizeError: 'Максимальний розмір файлу: 5MB',
      nameRequired: 'Введіть назву фото',
      imageRequired: 'Завантажте зображення фото',
      tagRequired: 'Додайте хоча б один тег для пошуку',
      created: 'Фото створено',
      updated: 'Фото оновлено',
      deleted: 'Фото видалено',
      saveError: 'Не вдалося зберегти фото',
      deleteError: 'Не вдалося видалити фото',
      deleteTitle: 'Видалити фото?',
      deleteMessage: 'Ви впевнені, що хочете видалити фото "{{name}}"?',
    },
    addAdmin: {
      title: 'Додати адміністратора',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      email: 'Email',
      phone: 'Телефон',
      firstNamePlaceholder: 'Олександр',
      lastNamePlaceholder: 'Коваленко',
      emailPlaceholder: 'admin@example.com',
      phonePlaceholder: '+380 67 123 4567',
      permissions: 'Дозволи',
      selectAll: 'Вибрати всі',
      clearAll: 'Очистити',
      pickAtLeastOne: 'Виберіть хоча б один дозвіл',
      info: '* Після збереження адміністратор отримає email з кодом реєстрації, який він використає для створення акаунту.',
      saveAndSend: 'Зберегти та надіслати',
      saving: 'Збереження...',
      createError: 'Помилка створення запрошення',
      invitationSent: 'Запрошення надіслано!',
      emailSentTo: 'Лист з кодом реєстрації надіслано на адресу:',
      registrationCodeNote: 'Код реєстрації (SMTP не налаштовано):',
      assignedPermissions: 'Призначені дозволи:',
    },
    addTeacher: {
      title: 'Додати викладача',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      firstNamePlaceholder: 'Марія',
      lastNamePlaceholder: 'Коваленко',
      emailPlaceholder: 'teacher@example.com',
      phonePlaceholder: '+380 67 123 4567',
      info: '* Після збереження викладач отримає email з кодом реєстрації, який він використає для створення акаунту.',
      sessionExpired: 'Сесія закінчилась. Будь ласка, оновіть сторінку та увійдіть знову.',
      refreshPage: 'Оновити сторінку',
    },
    grantStars: {
      title: 'Додати зірки',
      user: 'Користувач',
      childBadge: 'дитина',
      starsCount: 'Кількість зірок',
      messageOptional: 'Повідомлення (опціонально)',
      messagePlaceholder: 'Повідомлення для користувача...',
      searchPlaceholder: 'Пошук за ім\'ям, нікнеймом або email...',
      nothingFound: 'Нічого не знайдено',
      noStudents: 'Немає учнів',
      submit: 'Додати зірки',
      submitting: 'Нарахування...',
      error: 'Помилка при нарахуванні зірок',
      connectionError: 'Помилка з\'єднання з сервером',
      successTitle: 'Зірки додано!',
      newBalance: 'Новий баланс: {{count}} зірок',
      currentStars: 'Зірок: {{count}}',
      currentStarsLoading: 'Зірок: ...',
    },
    deductStars: {
      title: 'Зняти зірки',
      submit: 'Зняти зірки',
      submitting: 'Зняття...',
      error: 'Помилка при знятті зірок',
      successTitle: 'Зірки знято!',
    },
    tabs: {
      booksTitle: 'Книги',
      booksSubtitle: 'Бібліотека Reader-застосунку',
      booksRefresh: 'Оновити',
      booksAdd: 'Додати книгу',
      booksEmpty: 'Книг ще немає. Натисніть "Додати книгу", щоб почати.',
      booksDeleteConfirm: 'Видалити книгу?',
      booksRetranslateConfirm: 'Перекласти всі слова книги "{{title}}" заново? Це займе кілька хвилин.',
      booksDict: 'Словник книги',
      booksRetranslate: 'Перекласти заново',
      booksColCover: 'Обкладинка',
      booksColTitle: 'Назва / Автор',
      booksColLevel: 'Рівень',
      booksColGenre: 'Жанр',
      booksColChapters: 'Розділів',
      booksColWords: 'Слів',
      booksColStatus: 'Статус',
      booksColActions: 'Дії',
      booksAddModal: 'Додати книгу',
      booksEditModal: 'Редагувати книгу',
      booksStatusPending: 'Очікує',
      booksStatusProcessing: 'Обробка',
      booksStatusReady: 'Готова',
      booksStatusFailed: 'Помилка',
      clubsScheduled: 'Заплановані клуби',
      clubsHistory: 'Історія клубів',
      clubsPricing: 'Цiни на клуби',
      clubsActiveSubscriptions: 'Активні підписки ({{count}})',
      clubsBookings: 'Бронювання клубів ({{count}})',
      clubsPresentations: 'Презентації для клубів',
      clubsUploadPresentation: 'Завантажити презентацію',
      coursesTitle: 'Курси',
      coursesEmpty: 'Курсів поки немає',
      coursesStartTest: 'Початковий тест',
      coursesStudentView: 'Що бачить студент',
      coursesProgressTable: 'Таблиця прогресу',
      coursesYourProgress: 'Ваш прогрес',
      coursesMaterials: 'Матеріали курсу',
      coursesAddQuestions: 'Додайте питання до тесту',
      coursesExercise: 'Вправа',
      coursesNotes: 'Конспект',
      coursesVideo: 'Відео',
      financeTopups: 'Поповнення балансу',
      financeReceipt: 'Квитанція',
      financeDecline: 'Відхилення платежу',
      financePayouts: 'Зарплата викладачів',
      financePayoutTitle: 'Виплата зарплати',
      financeIncome: 'Прибуток та транзакції',
      financeByServiceType: 'Списання за типами послуг',
      financeTransactionHistory: 'Історія транзакцій',
      financePenaltyList: 'Список штрафів',
      financeTopFined: 'Викладачі з найбільшою сумою штрафів',
      financeCancelPenalty: 'Скасувати штраф?',
      kenSkinsTitle: 'Скіни Кена',
      kenSkinsEdit: 'Редагувати скін',
      kenSkinsNew: 'Новий скін',
      pricingTitle: 'Ціни та тарифи',
      lessonsTitle: 'Уроки',
      lessonsScheduled: 'Заплановані уроки',
      lessonsHistory: 'Історія уроків',
      lessonsSpecial: 'Особливі заняття',
      penaltiesTitle: 'Штрафи',
      presentationsTitle: 'Презентації',
      presentationsCreate: 'Створити презентацію',
      productsTitle: 'Товари',
      promoCodesTitle: 'Промокоди',
      reviewsTitle: 'Відгуки та звернення',
      scheduleTitle: 'Розклад',
      specialLessonsTitle: 'Особливі заняття',
      specialOffersTitle: 'Спеціальні пропозиції',
      teacherLeavesTitle: 'Відпустки викладачів',
      paymentsTitle: 'Платежі',
      bookDictionary: 'Словник книги',
      replenishTitle: 'Поповнити баланс',
      deductTitle: 'Списати з балансу',
      replenishSuccess: 'Баланс поповнено!',
      deductSuccess: 'Баланс списано!',
      currencyUnit: 'грн',
      newBalanceUah: 'Новий баланс: {{amount}} грн',
      amount: 'Сума (грн)',
      amountPlaceholder: '100',
      messageOptional: 'Повідомлення (опціонально)',
      messagePlaceholder: 'Повідомлення для користувача...',
      messageHelp: 'Це повідомлення з\'явиться як спливаюче вікно для користувача',
      replenishSubmit: 'Поповнити баланс',
      replenishSubmitting: 'Поповнення...',
      deductSubmit: 'Списати з балансу',
      deductSubmitting: 'Списання...',
      replenishError: 'Помилка при поповненні балансу',
      deductError: 'Помилка при знятті коштів',
      balance: 'Баланс',
      insufficientTitle: 'Недостатньо коштів на балансі',
      insufficientCurrent: 'Поточний баланс: {{amount}} грн.',
      insufficientAfter: 'Після зняття буде {{amount}} грн (мінус).',
      insufficientPrompt: 'Все одно зняти кошти?',
      insufficientConfirm: 'Підтвердити',
    },
    users: {
      title: 'Користувачі платформи',
      searchPlaceholder: 'Пошук за іменем, email...',
      subTabs: {
        students: 'Студенти',
        teachers: 'Викладачі',
        admins: 'Адміни',
      },
      showArchived: 'Показати архівних',
      studentsRegistered: 'Зареєстровані студенти ({{count}})',
      telegramConnected: 'Telegram підключено',
      studentsRegisteredFiltered: 'Зареєстровані студенти ({{filtered}} з {{total}})',
      teachersRegistered: 'Зареєстровані викладачі ({{count}})',
      teachersRegisteredFiltered: 'Зареєстровані викладачі ({{filtered}} з {{total}})',
      adminsRegistered: 'Зареєстровані адміністратори ({{count}})',
      adminsRegisteredFiltered: 'Зареєстровані адміністратори ({{filtered}} з {{total}})',
      addTeacher: '+ Додати викладача',
      addAdmin: '+ Додати адміністратора',
      loadingInvitations: 'Завантаження запрошень...',
      pendingRegistration: 'Очікують реєстрації ({{count}})',
      colName: 'Ім\'я',
      colNickname: 'Нікнейм',
      colEmail: 'Email',
      colType: 'Тип',
      colBalance: 'Баланс',
      colStars: 'Зірочки',
      colLessons: 'Уроків',
      colStatus: 'Статус',
      colActions: 'Дії',
      colPhone: 'Телефон',
      colLevel: 'Рівень',
      colAuthor: 'Автор методики',
      colPermissions: 'Дозволи',
      colTimeLeft: 'Залишилось',
      accountChild: 'Дитина',
      accountAdult: 'Дорослий',
      statusArchived: 'Архівований',
      statusVerified: 'Верифіковано',
      statusUnverified: 'Неверифіковано',
      statusActive: 'Активний',
      unarchive: 'Розархівувати',
      archive: 'Архівувати',
      viewSchedule: 'Переглянути розклад',
      deleteUnverified: 'Видалити незавершену реєстрацію',
      resend: 'Надіслати повторно',
      cancelInvite: 'Скасувати запрошення',
      authorMethodBadge: 'Автор методики',
      pricePlaceholder: 'Ціна',
      priceTitle: 'Ціна індивідуального заняття (грн)',
      priceCurrency: 'грн',
      priceValidation: 'Введіть коректну ціну індивідуального заняття',
      superBadge: 'Super',
      fullAccess: 'Повний доступ',
      lessThanHour: 'менше години',
      dayShort: '{{count}} дн.',
      hourShort: '{{count}} год.',
      studentsNotFound: 'Студентів не знайдено',
      teachersNotFound: 'Викладачів не знайдено',
      adminsNotFound: 'Адміністраторів не знайдено',
      studentsNotFoundQuery: 'За запитом "{{query}}" студентів не знайдено',
      teachersNotFoundQuery: 'За запитом "{{query}}" викладачів не знайдено',
      adminsNotFoundQuery: 'За запитом "{{query}}" адміністраторів не знайдено',
      cancelInviteTitle: 'Скасувати запрошення?',
      cancelInviteMessage: 'Ви впевнені, що хочете скасувати запрошення для {{name}} ({{email}})? Код реєстрації стане недійсним.',
      cancelInviteConfirm: 'Скасувати запрошення',
      cancelInviteBack: 'Ні, залишити',
      deleteUnverifiedTitle: 'Видалити незавершену реєстрацію?',
      deleteUnverifiedMessage: 'Видалити запис «{{name}}» ({{email}})? Користувач не підтвердив пошту. Дію не можна скасувати.',
      deleteUnverifiedConfirm: 'Видалити',
      balanceUnit: 'грн',
      report: {
        title: 'Звіт по учню',
        download: 'Скачати звіт',
        forStudent: 'Звіт для: {{name}}',
        presets: 'Швидкий вибір',
        presetThisMonth: 'Цей місяць',
        presetLastMonth: 'Минулий місяць',
        presetLast3: 'Останні 3 міс.',
        presetLast6: 'Останні 6 міс.',
        presetAllTime: 'Весь час',
        startDate: 'Від',
        endDate: 'До',
        language: 'Мова звіту',
        languageUk: 'Українська',
        languageEn: 'English',
        generating: 'Формуємо...',
        errorDates: 'Оберіть коректні дати',
        errorOrder: 'Дата "Від" має бути раніше за "До"',
        errorGenerate: 'Не вдалося сформувати звіт. Спробуйте ще раз.',
      },
      freeze: {
        autoFrozenBadge: 'Заморожено',
        autoFrozenTooltip: 'Навчання автоматично заморожено через 3 заняття підряд, скасовані через нестачу коштів.',
        unfreezeAction: 'Розморозити навчання',
        unfreezeTitle: 'Розморозити навчання?',
        unfreezeMessage: 'Розморозити навчання учня «{{name}}»? Після розморозки заплановані заняття будуть видалені — учню треба буде обрати новий час.',
        unfreezeConfirm: 'Розморозити',
        unfreezeFailed: 'Не вдалося розморозити. Спробуйте ще раз.',
      },
    },
    teacherSchedule: {
      title: 'Розклад викладача',
      close: 'Закрити',
      prevDay: 'Попередній день',
      nextDay: 'Наступний день',
      pastDate: 'Минула дата',
      customSchedule: 'Індивідуальний розклад на цю дату',
      legendAvailable: 'Не робочі',
      legendWorking: 'Робочі години',
      legendBusy: 'Зайнято',
      legendPast: 'Минуло',
      tooltipBusyWith: 'Зайнято: {{name}}',
      daySunday: 'Неділя',
      dayMonday: 'Понеділок',
      dayTuesday: 'Вівторок',
      dayWednesday: 'Середа',
      dayThursday: 'Четвер',
      dayFriday: 'П\'ятниця',
      daySaturday: 'Субота',
      monJan: 'січ.',
      monFeb: 'лют.',
      monMar: 'бер.',
      monApr: 'квіт.',
      monMay: 'трав.',
      monJun: 'черв.',
      monJul: 'лип.',
      monAug: 'серп.',
      monSep: 'вер.',
      monOct: 'жовт.',
      monNov: 'лист.',
      monDec: 'груд.',
    },
    common: {
      configuring: 'Налаштовуємо…',
      close: 'Закрити',
      cancel: 'Скасувати',
      save: 'Зберегти',
      saving: 'Збереження...',
      saved: 'Збережено',
      edit: 'Редагувати',
      delete: 'Видалити',
      loading: 'Завантаження...',
      error: 'Помилка',
      success: 'Успіх',
    },
    lessons: {
      daysOfWeek: {
        long: ['Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота', 'Неділя'],
        short: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
      },
    },
    specialLessons: {
      subTabCategories: 'Категорії',
      subTabPrograms: 'Призначення програмам',
      subTabRepetition: 'Уроки повторення',
      errorTitle: 'Помилка',
      successTitle: 'Успіх',
      categoryRequired: 'Назва категорії обов\'язкова',
      categoryUpdated: 'Категорію оновлено',
      categoryCreated: 'Категорію створено',
      sub: {
        categories: {
          addBtn: 'Додати категорію',
          editTitle: 'Редагувати категорію',
          newTitle: 'Нова категорія',
          nameEnLabel: 'Назва (EN)',
          nameEnPlaceholder: 'Birthday',
          nameUkLabel: 'Назва (UA)',
          nameUkPlaceholder: 'День народження',
          iconLabel: 'Іконка',
          iconNone: 'Без іконки',
          sortOrderLabel: 'Порядок сортування',
          descriptionLabel: 'Опис',
          descriptionPlaceholder: 'Опис категорії...',
          save: 'Зберегти',
          cancel: 'Скасувати',
          empty: 'Ще немає категорій. Додайте першу!',
          statusActive: 'Активна',
          statusInactive: 'Неактивна',
          confirmDeleteTitle: 'Видалити категорію?',
          confirmDeleteMessage: 'Ви впевнені, що хочете видалити категорію "{{name}}"?',
          deletedSuccess: 'Категорію видалено',
          iconLabels: {
            cake: 'Торт',
            ghost: 'Привид',
            gift: 'Подарунок',
            egg: 'Яйце',
            sparkles: 'Блискітки',
            heart: 'Серце',
            star: 'Зірка',
            tree: 'Ялинка',
            sun: 'Сонце',
            snowflake: 'Сніжинка',
          },
        },
        programs: {
          heading: 'Спеціальні уроки для програм',
          selectProgramLabel: 'Оберіть програму',
          selectProgramPlaceholder: '-- Оберіть програму --',
          noLevel: 'Без рівня',
          addBtn: 'Додати спеціальний урок',
          formTitle: 'Додати спеціальний урок',
          presentationLabel: 'Презентація (type=special)',
          selectPresentationPlaceholder: '-- Оберіть презентацію --',
          slidesCount: '{{count}} слайдів',
          noSpecialPresentations: 'Немає презентацій з типом "special". Створіть їх у редакторі презентацій.',
          categoryLabel: 'Категорія',
          selectCategoryPlaceholder: '-- Оберіть категорію --',
          homeworkLabel: 'Домашнє завдання (необов\'язково)',
          noHomework: '-- Без домашнього --',
          titleLabel: 'Назва (необов\'язково)',
          titlePlaceholder: 'Використовуватиметься назва презентації, якщо не вказано',
          add: 'Додати',
          cancel: 'Скасувати',
          empty: 'До цієї програми ще не додано спеціальних уроків.',
          homeworkPrefix: 'ДЗ',
          selectRequired: 'Оберіть презентацію та категорію',
          addSuccess: 'Спеціальний урок додано до програми',
          confirmRemoveTitle: 'Видалити прив\'язку?',
          confirmRemoveMessage: 'Ви впевнені, що хочете видалити "{{title}}" з цієї програми?',
          removeSuccess: 'Прив\'язку видалено',
        },
        repetition: {
          heading: 'Уроки повторення для програм',
          intro: 'Уроки повторення дозволяють вчителю призначити урок для повторення матеріалу замість звичайного уроку. При цьому всі наступні уроки зсуваються, і пропущений урок переноситься в кінець.',
          selectProgramLabel: 'Оберіть програму',
          selectProgramPlaceholder: '-- Оберіть програму --',
          noLevel: 'Без рівня',
          addBtn: 'Додати урок повторення',
          formTitle: 'Додати урок повторення',
          presentationLabel: 'Презентація',
          selectPresentationPlaceholder: '-- Оберіть презентацію --',
          slidesCount: '{{count}} слайдів',
          noPresentations: 'Немає доступних презентацій.',
          titleLabel: 'Назва (необов\'язково)',
          titlePlaceholder: 'Використовуватиметься назва презентації, якщо не вказано',
          homeworkLabel: 'Домашнє завдання (необов\'язково)',
          noHomework: '-- Без домашнього --',
          add: 'Додати',
          cancel: 'Скасувати',
          empty: 'До цієї програми ще не додано уроків повторення.',
          homeworkPrefix: 'ДЗ',
          selectRequired: 'Оберіть презентацію',
          addSuccess: 'Урок повторення додано до програми',
          confirmRemoveTitle: 'Видалити прив\'язку?',
          confirmRemoveMessage: 'Ви впевнені, що хочете видалити "{{title}}" з уроків повторення?',
          removeSuccess: 'Прив\'язку видалено',
        },
      },
    },
    presentations: {
      requestEditTitle: 'Запросити доступ до редагування',
      requestPresentation: 'Презентація:',
      requestHelp: 'Вчителю прийде сповіщення; він/вона вирішить, на скільки часу надати доступ.',
      requestMessagePlaceholder: 'Поясніть, навіщо потрібен доступ (необов\'язково)',
      cancel: 'Скасувати',
      sendRequest: 'Надіслати запит',
      sendError: 'Не вдалося надіслати запит',
      newBase: 'Нова презентація',
      copySuffix: '(копія)',
      duplicateSuffix: '(дублікат)',
      loadError: 'Не вдалося завантажити презентацію',
      upload: 'Завантажити',
      create: 'Створити',
      slidesCount: '{{count}} слайдів',
      updated: 'Оновлено: {{when}}',
      deletedByTeacher: 'Видалено вчителем',
      deletedByTeacherOn: 'Видалено {{when}}',
      accessUntil: 'Доступ до {{when}}',
      accessPermanent: 'Безстроковий доступ',
      save: 'Зберегти',
      rename: 'Перейменувати',
      needAccess: 'Презентація іншого вчителя — потрібен доступ',
      edit: 'Редагувати',
      awaiting: 'Очікує',
      requestAccessTooltip: 'Запросити доступ до редагування',
      access: 'Доступ',
      preview: 'Перегляд',
      loadingList: 'Завантаження презентацій...',
      emptyTitle: 'Немає презентацій',
      emptyDesc: 'Створіть першу презентацію',
      deleteTitle: 'Видалити презентацію?',
      deleteMessage: 'Ви впевнені, що хочете видалити цю презентацію?',
      uploadTitle: 'Завантажити презентацію',
      uploadHelp: 'Завантажте PDF файл або експортуйте презентацію з Canva, PowerPoint як зображення. Кожна сторінка PDF або зображення стане окремим слайдом.',
      nameLabel: 'Назва презентації',
      namePlaceholder: 'Завантажена презентація',
      slidesImages: 'Зображення слайдів',
      dropHere: 'Відпустіть файли тут',
      selectedCount: '{{count}} файлів вибрано',
      moreFiles: 'та ще {{count}}...',
      dragOrClick: 'Перетягніть файли сюди або натисніть для вибору',
      allowedTypes: 'PDF, PNG, JPG, WebP (до 50MB для PDF)',
      selectFilesError: 'Виберіть файли для завантаження',
      defaultTitle: 'Завантажена презентація',
      uploadError: 'Помилка завантаження',
      uploadPresentationError: 'Помилка завантаження презентації',
      uploading: 'Завантаження...',
      searchPlaceholder: 'Пошук за назвою презентації...',
      noSearchResults: 'Немає презентацій за цим запитом',
      loadMore: 'Завантажити ще',
      loadingMore: 'Завантаження...',
      shownOfTotal: 'Показано {{shown}} з {{total}}',
      loadListError: 'Не вдалося завантажити презентації',
      loadListErrorHint: 'Перевірте з\'єднання та спробуйте ще раз',
      retry: 'Спробувати ще раз',
    },
    promoCodes: {
      usageOncePerUser: 'Один раз на юзера',
      usageSingleUse: 'Одна активація загалом',
      rewardBalance: 'Кошти',
      rewardFreeLessons: 'Безкошт. заняття',
      rewardClubLessons: 'Безкошт. клуб',
      subtitle: 'Безкоштовні заняття для студентів',
      createBtn: 'Створити промокод',
      searchPlaceholder: 'Пошук за кодом…',
      onlyActive: 'Тільки активні',
      colCode: 'Код',
      colLessons: 'Занять',
      colType: 'Тип',
      colRedemptions: 'Активацій',
      colExpires: 'Термін',
      colCreated: 'Створено',
      colStatus: 'Статус',
      colActions: 'Дії',
      loading: 'Завантаження…',
      empty: 'Промокодів немає',
      statusActive: 'Активний',
      statusInactive: 'Неактивний',
      delete: 'Видалити',
      deactivate: 'Деактивувати',
      deleteTitle: 'Видалити промокод?',
      deactivateTitle: 'Деактивувати промокод?',
      deleteConfirmUsed: 'Промокод {{code}} вже активований ({{count}}). Його буде деактивовано, а не видалено.',
      deleteConfirm: 'Ви впевнені, що хочете видалити промокод {{code}}?',
      deleteError: 'Помилка видалення',
      updateError: 'Помилка оновлення',
      paginationRange: '{{from}}–{{to}} з {{total}}',
      back: 'Назад',
      next: 'Далі',
      createTitle: 'Створити промокод',
      codeLabel: 'Код',
      generate: 'Згенерувати',
      lessonsCount: 'Кількість занять',
      rewardTypeLabel: 'Тип винагороди',
      rewardBalanceTitle: 'Кошти на баланс',
      rewardBalanceDesc: 'Нарахує N × ціна заняття грн на баланс. Можна витратити на будь-що (заняття, магазин, підписки).',
      rewardFreeLessonsTitle: 'Безкоштовні заняття',
      rewardFreeLessonsDesc: 'Нарахує N безкоштовних занять — списання за наступні N занять пройде автоматично без грошей на балансі.',
      rewardClubLessonsTitle: 'Безкоштовні заняття клубу',
      rewardClubLessonsDesc: 'Нарахує N безкоштовних заняття клубу — списання за наступні N відвідувань клубу пройде автоматично без грошей на балансі.',
      usageTypeLabel: 'Тип використання',
      usageOncePerUserTitle: 'Один раз на юзера',
      usageOncePerUserDesc: 'Кожен користувач може активувати цей код лише раз',
      usageSingleUseTitle: 'Одна активація загалом',
      usageSingleUseDesc: 'Тільки перший, хто введе код, отримає бонус',
      validUntilLabel: 'Термін дії',
      validUntilHint: '(опціонально)',
      validityForever: 'Назавжди',
      validityRange: 'Обмежений термін',
      validFromLabel: 'Діє з',
      validToLabel: 'Діє до',
      validRangeError: 'Дата початку має бути раніше дати закінчення',
      descriptionLabel: 'Опис',
      descriptionHint: '(для адміна)',
      descriptionPlaceholder: 'Наприклад: літня кампанія 2026',
      cancel: 'Скасувати',
      creating: 'Створення…',
      create: 'Створити',
      codeMinError: 'Код має містити щонайменше 3 символи',
      lessonsMinError: 'Кількість занять має бути ≥ 1',
      createError: 'Помилка створення',
      redemptionsTitle: 'Активації',
      redemptionsLoading: 'Завантаження…',
      redemptionsEmpty: 'Активацій ще немає',
      redemptionUser: 'Користувач',
      redemptionLessons: 'Занять',
      redemptionAmount: 'Сума',
      redemptionDate: 'Дата',
    },
    kenSkins: {
      subtitle: 'Каталог частин аватара. Керуй тим, що дитина може відкрити безкоштовно, а що — за зірки, гроші чи за завдання.',
      addSkin: 'Додати скін',
      loading: 'Завантаження…',
      emptyCategory: 'Немає скінів у цій категорії',
      unlockFree: 'Безкоштовно',
      unlockPoints: 'За зірки',
      unlockMoney: 'За гроші',
      unlockTask: 'За завдання',
      unlockTaskShort: 'Завдання',
      stars: '{{count}} зірок',
      uah: '{{count}} грн',
      edit: 'Редагувати',
      delete: 'Видалити',
      categoryLabel: 'Категорія',
      assetKeyLabel: 'Asset key',
      assetKeyHint: '(файл PNG)',
      nameUkLabel: 'Назва (UA)',
      descriptionLabel: 'Опис',
      unlockLabel: 'Як розблокувати',
      pricePointsLabel: 'Ціна в зірках',
      priceUahLabel: 'Ціна в грн',
      taskTypeLabel: 'Тип завдання',
      taskParamsLabel: 'Параметри',
      taskParamsHint: '(JSON, напр. {"book_id":5})',
      taskDescLabel: 'Опис для дитини',
      taskDescHint: '(що треба зробити)',
      taskDescPlaceholder: 'Прочитай книгу «Гаррі Поттер»',
      previewTitle: 'Прев\'ю в гардеробі',
      previewHint: 'Обрізка плитки в кастомайзері. Пусті поля = дефолт для категорії ({{scale}}× · Y {{offsetY}}%).',
      previewNeedAsset: 'вкажи asset_key',
      tileImageLabel: 'Фото в гардеробі',
      tileImageHint: 'Як скін виглядає в сітці вибору. Якщо не задано — використовується файл за asset_key.',
      overlayImageLabel: 'Фото на Кені',
      overlayImageHint: 'Як скін накладається на кенгуру. Якщо не задано — використовується файл за asset_key.',
      uploadImage: 'Завантажити',
      uploading: 'Завантаження…',
      removeImage: 'Прибрати',
      uploadError: 'Не вдалось завантажити зображення',
      zoom: 'Zoom (×)',
      offsetX: 'Зсув X (%)',
      offsetY: 'Зсув Y (%)',
      sortOrder: 'Порядок сортування',
      activeLabel: 'Активний (видно в кастомайзері)',
      cancel: 'Скасувати',
      save: 'Зберегти',
      taskManual: 'Ручне надання адміном',
      taskReadBook: 'Прочитати книгу',
      taskJoinClub: 'Записатись у клуб',
      taskShop: 'Купити товар у магазині',
      taskTest: 'Скласти тест',
      taskInvite: 'Запросити друга',
      errorTitle: 'Помилка',
      loadError: 'Не вдалося завантажити скіни',
      formValidation: 'Заповніть asset_key і назву',
      jsonInvalid: 'task_config має бути валідним JSON',
      saveError: 'Помилка збереження',
      saveFail: 'Не вдалося зберегти',
      deleteTitle: 'Видалити скін?',
      deleteMessage: 'Видалити «{{name}}»? Учні, які вже його розблокували, втратять доступ.',
      deleteFail: 'Не вдалося видалити',
    },
    pricing: {
      loadError: 'Не вдалось завантажити налаштування',
      loadErrorPage: 'Не вдалось завантажити поточні ціни. Спробуй оновити сторінку.',
      saveError: 'Не вдалось зберегти',
      saveErrorGeneric: 'Не вдалось зберегти зміну',
      validationBadNumber: '"{{label}}": введи коректне число (≥ 0)',
      validationMax: '"{{label}}": максимум {{max}}',
      validationMin: '"{{label}}": мінімум {{min}}',
      description: 'Зміни застосовуються одразу після збереження для всіх нових покупок та бронювань. Ціни в існуючих абонементах і вже сплачених заняттях не перераховуються.',
      matrixColLessonType: 'Тип заняття',
      matrixHint: 'Підказка: Intern — пробний період (перше заняття безкоштовне). Зазвичай для нього виставляють 0, а вищі рівні — за зростанням.',
      saved: 'Збережено',
      save: 'Зберегти',
      saveRow: 'Зберегти рядок',
      saving: 'Збереження...',
      currency: 'грн',
      units: {
        uah: 'грн',
        percent: '%',
        days: 'днів',
      },
      sections: {
        lessons: {
          title: 'Заняття',
          description: 'Базова вартість занять (UAH). Якщо у курсу не задано власної ціни, використовується ця.',
        },
        clubs: {
          title: 'Клуби та абонементи',
          description: 'Базова ціна сесії та знижки на абонементи на 4 і 8 занять. Діє 30 днів з моменту покупки.',
        },
        ai: {
          title: 'AI-підписка (Ken)',
          description: 'Підписка на практику з Кеном: безкоштовний пробний період, потім місячна плата з балансу.',
        },
        teacherRates: {
          title: 'Ставки вчителів',
          description: 'Скільки вчитель отримує за одне заняття, залежно від його рівня. Intern — це новий вчитель на пробному періоді (перше заняття безкоштовно). Далі: Junior → Middle → Senior → Lead.',
        },
        penalties: {
          title: 'Штрафи вчителям',
          description: 'Сума, яку вчитель сплачує, якщо не прийшов на заняття (teacher no-show). Утримується з виплати вчителя.',
        },
        referral: {
          title: 'Реферальні бонуси',
          description: 'Коли запрошений учень поповнює баланс на вказану суму протягом N днів з моменту реєстрації — і він, і запрошувач отримують бонус.',
        },
      },
      fields: {
        lesson_price_individual: 'Індивідуальне заняття',
        lesson_price_group: 'Групове заняття',
        lesson_price_club: 'Сесія клубу (одинична)',
        club_session_base_price: 'Базова ціна сесії в абонементі',
        club_subscription_discount_4: 'Знижка на пакет 4 занять',
        club_subscription_discount_8: 'Знижка на пакет 8 занять',
        ai_subscription_price_uah: 'Ціна підписки',
        ai_subscription_duration_days: 'Тривалість підписки',
        ai_trial_days: 'Безкоштовний пробний період',
        teacher_cancelled_late_percent: 'Оплата при пізньому скасуванні',
        penalty_individual_no_show: 'Неявка на індивідуальне заняття',
        penalty_group_no_show: 'Неявка на групове заняття',
        penalty_club_no_show: 'Неявка на сесію клубу',
        referral_min_topup: 'Мінімальна сума поповнення запрошеного',
        referral_bonus_amount: 'Бонус для обох (запрошеному та запрошувачу)',
        referral_window_days: 'Період активації з моменту реєстрації',
        rateTypeIndividual: 'Індивідуальне заняття',
        rateTypeGroup: 'Групове заняття',
        rateTypeClub: 'Сесія клубу',
      },
      requisites: {
        title: 'Реквізити для оплати',
        notFilled: 'Не заповнено',
        help: 'Ці реквізити побачать учні при поповненні балансу.',
        cardNumber: 'Номер картки',
        cardholderName: 'Ім\'я отримувача (латиницею)',
        bankName: 'Назва банку',
        additionalInfo: 'Додаткова інформація',
        additionalInfoPlaceholder: 'Призначення платежу, примітки для учнів...',
      },
    },
    schedule: {
      addLesson: 'Додати урок',
      editLesson: 'Редагувати урок',
      newLesson: 'Додати новий урок',
      student: 'Учень',
      selectStudent: 'Оберіть учня',
      teacher: 'Вчитель',
      selectTeacher: 'Оберіть вчителя',
      dateTime: 'Дата та час',
      duration: 'Тривалість (хвилин)',
      minutes: '{{count}} хвилин',
      lessonType: 'Тип уроку',
      typeIndividual: 'Індивідуальний',
      typeTrial: 'Пробний',
      typeGroup: 'Груповий',
      program: 'Програма (необов\'язково)',
      noProgram: 'Без програми',
      programLesson: 'Урок з програми',
      selectLesson: 'Оберіть урок',
      cancel: 'Скасувати',
      saveChanges: 'Зберегти зміни',
      requiredFieldsError: 'Будь ласка, заповніть всі обов\'язкові поля',
      error: 'Помилка',
      totalLessons: 'Всього уроків',
      individualLessons: 'Індивідуальних',
      trialLessons: 'Пробних',
      groupLessons: 'Групових',
      colDateTime: 'Дата та час',
      colStudent: 'Учень',
      colTeacher: 'Вчитель',
      colType: 'Тип',
      colProgramLesson: 'Програма / Урок',
      colDuration: 'Тривалість',
      colActions: 'Дії',
      minutesShort: 'хв',
      edit: 'Редагувати',
      delete: 'Видалити',
      empty: 'Немає запланованих уроків',
      addFirst: 'Додати перший урок',
      deleteTitle: 'Видалити урок?',
      deleteMessage: 'Ви впевнені, що хочете видалити цей урок?',
    },
    penalties: {
      lessonTypes: {
        individual: 'Індивідуальний',
        group: 'Груповий',
        club: 'Клуб',
      },
      statsTotal: 'Всього штрафів',
      statsActive: 'Активних',
      statsWaived: 'Скасовано',
      statsActiveAmount: 'Сума активних',
      currency: 'грн',
      filters: 'Фільтри:',
      allTeachers: 'Всі викладачі',
      allStatuses: 'Всі статуси',
      statusPending: 'Активні',
      statusWaived: 'Скасовані',
      allTypes: 'Всі типи',
      typeIndividual: 'Індивідуальні',
      typeGroup: 'Групові',
      typeClub: 'Клуби',
      resetFilters: 'Скинути фільтри',
      colDate: 'Дата',
      colTeacher: 'Викладач',
      colType: 'Тип',
      colReason: 'Причина',
      colStatus: 'Статус',
      colAmount: 'Сума',
      colActions: 'Дії',
      loading: 'Завантаження...',
      empty: 'Штрафів не знайдено',
      studentLabel: 'Студент: {{name}}',
      statusActive: 'Активний',
      statusWaivedBadge: 'Скасовано',
      waive: 'Скасувати',
      showing: 'Показано {{from}} - {{to}} з {{total}}',
      back: 'Назад',
      next: 'Далі',
      topTitle: 'Викладачі з найбільшою сумою штрафів',
      penaltyCount: '({{count}} штрафів)',
      confirmTitle: 'Скасувати штраф?',
      confirmMessage: 'Ви впевнені, що хочете скасувати штраф',
      confirmForTeacher: 'для викладача',
      reasonLabel: 'Причина скасування *',
      reasonPlaceholder: 'Вкажіть причину скасування штрафу...',
      cancel: 'Відміна',
      waiving: 'Скасування...',
      waivePenalty: 'Скасувати штраф',
      waiveReasonRequired: 'Вкажіть причину скасування штрафу',
      waiveError: 'Помилка при скасуванні штрафу',
    },
    payments: {
      statusPending: 'Очікує',
      statusApproved: 'Підтверджено',
      statusRejected: 'Відхилено',
      pendingCount: '{{count}} очікує',
      requisites: 'Реквізити',
      addRequisites: 'Додати реквізити',
      filterPending: 'Очікують',
      filterApproved: 'Підтверджені',
      filterRejected: 'Відхилені',
      filterAll: 'Всі',
      loading: 'Завантаження...',
      emptyPending: 'Немає платежів на перевірці',
      empty: 'Немає платежів',
      colStudent: 'Учень',
      colAmount: 'Сума',
      colDate: 'Дата',
      colReceipt: 'Квитанція',
      colStatus: 'Статус',
      colActions: 'Дії',
      currencyUnit: 'грн',
      editAmount: 'Редагувати суму',
      adjustedNote: '(скориговано: {{amount}} грн)',
      view: 'Переглянути',
      approve: 'Підтвердити',
      reject: 'Відхилити',
      receiptTitle: 'Квитанція',
      declineTitle: 'Відхилення платежу',
      declineHelp: 'Вкажіть причину відхилення. Учень побачить цю інформацію.',
      declinePlaceholder: 'Причина відхилення...',
      cancel: 'Скасувати',
      requisitesTitle: 'Реквізити для оплати',
      requisitesHelp: 'Ці реквізити побачать учні при поповненні балансу',
      cardNumber: 'Номер картки',
      cardholderName: 'Ім\'я отримувача (латиницею)',
      bankName: 'Назва банку',
      additionalInfo: 'Додаткова інформація',
      additionalInfoPlaceholder: 'Призначення платежу, примітки для учнів...',
      saved: 'Збережено',
      saving: 'Збереження...',
      save: 'Зберегти',
    },
    sessions: {
      title: 'Заняття',
      tabActive: 'Активні',
      tabScheduled: 'Заплановані',
      tabHistory: 'Історія',
      selectDate: 'Дата',
      emptyScheduled: 'На цей день немає запланованих занять.',
      live: 'НАЖИВО',
      inProgress: 'Йде зараз',
      inRoom: 'у кімнаті',
      stillInRoom: 'ще в кімнаті',
      noSessions: 'Заходів не було.',
      teacher: 'Вчитель',
      student: 'Учень',
      presentation: 'Презентація',
      noPresentation: 'не призначена',
      joinedAt: 'Приєднався',
      leftAt: 'Вийшов',
      minutesShort: 'хв',
      eventTimeline: 'Хронологія подій',
      eventJoined: 'приєднався',
      eventLeft: 'вийшов',
      eventHeartbeat: 'онлайн',
      showTimeline: 'Показати хронологію',
      hideTimeline: 'Приховати хронологію',
      loading: 'Завантаження…',
      loadingEvents: 'Завантаження подій…',
      loadError: 'Не вдалося завантажити заняття',
      emptyActive: 'Зараз немає активних занять.',
      emptyHistory: 'Немає історії занять.',
      noEvents: 'Подій немає.',
      refresh: 'Оновити',
      reschedule: 'Перенести',
      cancel: 'Скасувати',
      cancelConfirmTitle: 'Скасувати заняття?',
      cancelConfirmMessage: 'Ви впевнені, що хочете скасувати це заняття? Залежно від правил, учню буде повернено оплату, перенесено її на наступне заняття або нараховано пізнє скасування.',
      cancelReason: 'Скасовано адміністратором',
      cancelError: 'Не вдалося скасувати заняття',
      cancelConfirmBtn: 'Скасувати заняття',
      recordLesson: 'Записати заняття',
      recordLessonHint: 'Запис зберігається у Google Drive і доступний у вкладці «Історія».',
      recordToggleError: 'Не вдалося змінити налаштування запису',
      watchRecording: 'Переглянути запис',
      watchRecordingPart: 'Запис — частина {{n}}',
      recordingStatusStarting: 'Готується запис…',
      recordingStatusRecording: 'Йде запис',
      recordingStatusUploading: 'Завантаження у Drive…',
      recordingStatusFailed: 'Запис не вдався',
      recordingStatusWaiting: 'Запис очікує завершення заняття',
      groupAutoRecordHint: 'Групове заняття записується автоматично, якщо хтось з учнів групи не прийде.',
    },
    teacherLeaves: {
      types: {
        vacation: 'Відпустка',
        sick: 'Лікарняний',
        force_majeure: 'Форсмажор',
        day_off: 'Вихідний',
      },
      statuses: {
        approved: 'Схвалено',
        rejected: 'Відхилено',
        cancelled: 'Скасовано',
      },
      historyFilters: {
        all: 'Всі',
        approved: 'Схвалені',
        rejected: 'Відхилені',
        cancelled: 'Скасовані',
      },
      lessonOutcome: {
        substitute: 'Заміна: {{name}}',
        pause: 'Пауза',
        pending: 'Очікує рішення',
        completed: 'Проведено',
        cancelled: 'Скасовано',
      },
      hoursSpan: '1 дн., години',
      daysSpan: '{{count}} дн.',
      reasonPrefix: 'Причина відмови: {{reason}}',
      submitted: 'Подано: {{when}}',
      processed: 'Оброблено',
      approvedAt: 'Схвалено',
      rejectedAt: 'Відхилено',
      approveBtn: 'Схвалити',
      rejectBtn: 'Відхилити',
      rejectReasonPlaceholder: 'Причина відмови (опційно)',
      confirmReject: 'Підтвердити відмову',
      affectedLessonsPending: 'Уроки, які постраждають',
      affectedLessonsDecided: 'Уроки та рішення по них',
      loading: 'Завантаження…',
      noLessonsInPeriod: 'Уроків у цей період немає.',
      totalLabel: 'Всього:',
      substituteLabel: 'Заміна:',
      pauseLabel: 'Пауза:',
      pendingLabel: 'Очікує:',
      completedLabel: 'Проведено:',
      confirmApproveTitle: 'Схвалити відпустку?',
      confirmApproveMessage: 'Схвалити відпустку викладача {{name}}?',
      confirmApproveConfirm: 'Схвалити',
      pendingCount: '{{count}} в очікуванні',
      noRequests: 'Нових заявок немає.',
      historyTitle: 'Історія',
      historyEmpty: 'Історія порожня.',
    },
    bookDictionary: {
      tabWords: 'Слова',
      tabOccurrences: 'По входженнях',
      tabSentences: 'Речення',
      filterAll: 'Усі',
      filterPending: 'Не затверджені',
      filterVerified: 'Затверджені',
      filterMissingTranslation: 'Без перекладу',
      filterMissingIpa: 'Без транскрипції',
      filterMissingAudio: 'Без аудіо',
      resetAllTitle: 'Видалити всі overrides для цієї книги',
      resetAll: 'Скинути всі ({{count}})',
      searchWord: 'Пошук за словом...',
      searchInChapter: 'Пошук у розділі {{chapter}}...',
      searchSentence: 'Пошук за реченням (англ./укр.)...',
      noWordsForFilter: 'Жодного слова за обраним фільтром.',
      noOccurrencesForFilter: 'Жодного входження за обраним фільтром.',
      noSentencesForFilter: 'Жодного речення за обраним фільтром.',
      noOccurrencesBuilt: 'Для цієї книги ще не побудовано таблицю входжень. Спробуйте перезалити книгу або запустити «Оновити переклад».',
      chapterLabel: 'Розділ:',
      chapterOption: '{{index}}. {{title}} ({{total}} слів{{missing}})',
      chapterMissingSuffix: ', {{count}} без перекладу',
      chapterStats: 'У розділі: {{total}} слів · {{missing}} без перекладу · {{verified}} затверджено',
      chapterCol: 'Розділ {{chapter}}',
      noTranslation: 'без перекладу',
      listen: 'Прослухати',
      verifiedShort: 'Затв.',
      approve: 'Затвердити',
      approvedTip: 'Затверджено — натисніть, щоб скасувати',
      fieldTranslation: 'Переклад',
      fieldTranslationOccurrence: 'Переклад (тільки це входження)',
      fieldIpa: 'Транскрипція (IPA)',
      fieldPartOfSpeech: 'Частина мови',
      fieldAudio: 'Аудіо',
      fieldAudioUrl: 'URL аудіо',
      fieldSentenceUk: 'Переклад речення (укр.)',
      audioRemove: 'Прибрати',
      audioEmpty: 'аудіо немає',
      audioUpload: 'Завантажити mp3',
      overrideBadge: 'Override для цієї книги',
      overrideHint: 'Глобальний переклад (override буде створено при збереженні)',
      savedFlash: 'збережено',
      resetOverrideTip: 'Видалити override',
      resetOverride: 'Скинути',
      save: 'Зберегти',
      occurrenceScopeNote: 'Зміни застосуються тільки до цього конкретного входження',
      confirmResetAll: 'Скинути всі {{count}} overrides для цієї книги? Слова повернуться до глобального словника.',
      confirmResetWord: 'Скинути override для "{{word}}"? Слово повернеться до глобального перекладу.',
      confirmResetSentence: 'Скинути override? Речення повернеться до глобального перекладу.',
      paginationRange: '{{from}}–{{to}} з {{total}}',
    },
    clubsManager: {
      colName: 'Назва',
      colType: 'Тип',
      colLevels: 'Рівні',
      colDateTime: 'Дата та час',
      colTeacher: 'Вчитель',
      colSeats: 'Місця',
      colReserve: 'Резерв',
      colActions: 'Дії',
      queueBadge: '{{count}} в черзі',
      editTip: 'Редагувати',
      deleteTip: 'Видалити',
      tabScheduled: 'Заплановані клуби',
      tabHistory: 'Історія клубів',
      tabPresentations: 'Презентації',
      tabPricing: 'Ціни та підписки',
      tabBookings: 'Бронювання',
      createClub: 'Створити клуб',
      statScheduled: 'Заплановано',
      statReserve: 'В резерві',
      typeMovie: 'Movie Club',
      typeBook: 'Book Club',
      typeSpeaking: 'Speaking Club',
      typeGrammar: 'Grammar Club',
      typeGame: 'Game Club',
      emptyScheduled: 'Немає запланованих клубів',
      createFirstClub: 'Створити перший клуб',
      statHeldClubs: 'Проведено клубів',
      statTotalParticipants: 'Загалом учасників',
      statAvgOccupancy: 'Середня заповненість',
      emptyHistory: 'Історія клубів порожня',
      pricingSingle: 'Разове заняття (будь-який клуб)',
      pricingSub4Title: 'Абонемент на 4 заняття',
      pricingSub8Title: 'Абонемент на 8 занять',
      pricingSubDuration: 'Термін дії: 30 днів',
      currencyUah: 'грн',
      savePricing: 'Зберегти ціни',
      pricingSaved: 'Ціни оновлено!',
      activeSubscriptionsColStudent: 'Студент',
      activeSubscriptionsColClubType: 'Тип клубу',
      activeSubscriptionsColSessions: 'Сесії',
      activeSubscriptionsColTotal: 'Загальна вартість',
      activeSubscriptionsStatusActive: 'Активна',
      emptySubscriptions: 'Підписок поки немає',
      reservationsTitle: 'Резерви (черга)',
      reservationsColClub: 'Клуб',
      reservationsColClubDate: 'Дата клубу',
      reservationsColPosition: 'Позиція',
      reservationsColPayment: 'Оплата',
      reservationsColFrozen: 'Заморожено',
      paymentSubscription: 'Підписка',
      paymentBalance: 'Баланс',
      frozenSession: '1 сесія',
      emptyReservations: 'Активних резервів немає',
      bookingsColStatus: 'Статус',
      bookingsColAmount: 'Сума',
      bookingBooked: 'Заброньовано',
      bookingCancelled: 'Скасовано',
      bookingCancelledLate: 'Пізнє скасування',
      emptyBookings: 'Бронювань поки немає',
      uploadPdf: 'Завантажити PDF',
      createPresentation: 'Створити презентацію',
      slidesCount: '{{count}} слайдів',
      renameTip: 'Перейменувати',
      updatedOn: 'Оновлено: {{date}}',
      openInEditor: 'Відкрити в редакторі',
      edit: 'Редагувати',
      preview: 'Перегляд',
      duplicateTip: 'Дублювати',
      copySuffix: '(копія)',
      emptyPresentations: 'Презентацій поки немає',
      createFirstPresentation: 'Створити першу презентацію',
      editPresentation: 'Редагувати презентацію',
      newPresentation: 'Створити нову презентацію',
      presentationTitleLabel: 'Назва презентації',
      presentationTitlePlaceholder: 'Наприклад: Movie Club - Inception',
      presentationAfterCreateHint: 'Після створення ви зможете додати слайди до презентації в редакторі.',
      uploadTitle: 'Завантажити презентацію',
      uploadTitleDefault: 'Клубна презентація',
      uploadDropText: 'Перетягніть PDF або зображення сюди',
      uploadClickText: 'або натисніть для вибору файлів',
      uploadChoose: 'Вибрати файли',
      uploadHint: 'Підтримуються: PDF (до 50MB), PNG, JPEG, WebP (до 10MB кожен)',
      uploadClear: 'Очистити',
      imagesCount: '{{count}} зображень',
      uploading: 'Завантаження...',
      upload: 'Завантажити',
      editClub: 'Редагувати клуб',
      newClub: 'Створити новий клуб',
      formName: 'Назва',
      formType: 'Тип',
      formLevels: 'Рівні',
      formAudience: 'Аудиторія',
      audienceChild: 'Діти',
      audienceTeen: 'Підлітки',
      audienceAdult: 'Дорослі',
      formDescription: 'Опис',
      formImage: 'Фото клубу',
      formImageAspect: '(16:9)',
      formImageHint: 'Рекомендований формат 16:9 (напр. 1920x1080)',
      formImageReplace: 'Замінити',
      formImageDelete: 'Видалити фото',
      formImageCta: 'Натисніть, щоб завантажити',
      formImageFormats: 'JPEG, PNG, GIF, WebP до 10MB',
      formDateTime: 'Дата та час',
      formTeacher: 'Вчитель',
      teacherPlaceholderNoDate: 'Спочатку оберіть дату та час',
      teacherPlaceholderLoading: 'Завантаження...',
      teacherPlaceholderChoose: 'Оберіть вчителя',
      teacherLoadError: 'Помилка завантаження вчителів: {{error}}',
      teacherNoAvailable: 'Немає вчителів, доступних у цей час. Оберіть інший час або налаштуйте робочі години вчителів.',
      teacherPickDateFirst: 'Оберіть дату та час, щоб побачити доступних вчителів.',
      formMaxParticipants: 'Макс. учасників',
      formDuration: 'Тривалість (хв)',
      formPresentation: 'Презентація',
      formPresentationNone: 'Без презентації',
      formPresentationOption: '{{title}} ({{count}} слайдів)',
      formPresentationSearch: 'Пошук за назвою...',
      formPresentationNoResults: 'Нічого не знайдено',
      formPresentationLoading: 'Завантаження презентацій...',
      formPresentationEmpty: 'Немає доступних презентацій. Створіть презентацію у вкладці "Програми".',
      cancel: 'Скасувати',
      save: 'Зберегти',
      create: 'Створити',
      saveChanges: 'Зберегти зміни',
      levelPickRequired: 'Оберіть хоча б один рівень',
      requiredMark: '*',
      errorTitle: 'Помилка',
      successTitle: 'Успішно',
      errChooseTeacher: 'Оберіть вчителя для проведення клубу',
      errChooseLevel: 'Оберіть хоча б один рівень',
      errSaveClub: 'Помилка при збереженні клубу',
      errClubGeneric: 'Не вдалося зберегти клуб. Перевірте підключення до сервера.',
      errImageFormat: 'Дозволені формати: JPEG, PNG, GIF, WebP',
      errImageSize: 'Максимальний розмір файлу: 10MB',
      errImageUpload: 'Не вдалося завантажити зображення',
      errSelectFiles: 'Виберіть файли для завантаження',
      errUploadPresentation: 'Помилка завантаження презентації',
      errPresentationTitle: 'Введіть назву презентації',
      errSavePresentation: 'Помилка при збереженні презентації',
      errPresentationGeneric: 'Не вдалося зберегти презентацію',
      errDeletePresentation: 'Не вдалося видалити презентацію',
      confirmDeleteClubTitle: 'Видалити клуб?',
      confirmDeleteClubMessage: 'Видалити цей клуб?',
      confirmDeletePresTitle: 'Видалити презентацію?',
      confirmDeletePresMessage: 'Цю дію неможливо скасувати. Всі слайди будуть видалені.',
      presentationUpdated: 'Презентацію оновлено',
      presentationCreated: 'Презентацію створено',
      presentationDeleted: 'Презентацію видалено',
    },
    finance: {
      pendingBadge: '{{count}} очікує',
      replenishBalance: 'Поповнити баланс',
      deductFunds: 'Зняти кошти',
      grantStars: 'Додати зірки',
      deductStars: 'Зняти зірки',
      statusPending: 'Очікує',
      statusApproved: 'Підтверджено',
      statusRejected: 'Відхилено',
      filterPending: 'Очікують',
      filterApproved: 'Підтверджені',
      filterRejected: 'Відхилені',
      filterDirect: 'Прямі поповнення',
      filterDeductions: 'Зняття коштів',
      filterAll: 'Всі',
      loading: 'Завантаження...',
      emptyDeductions: 'Немає зняття коштів',
      emptyDeductionsHint: 'Тут відображатимуться зняття коштів, зроблені адміністратором напряму',
      emptyDirect: 'Немає прямих поповнень',
      emptyDirectHint: 'Тут відображатимуться поповнення балансу, зроблені адміністратором напряму',
      emptyPending: 'Немає платежів на перевірці',
      emptyPayments: 'Немає платежів',
      colStudent: 'Учень',
      colAmount: 'Сума',
      colDate: 'Дата',
      colAdmin: 'Адміністратор',
      colMessage: 'Повідомлення',
      colReceipt: 'Квитанція',
      colStatus: 'Статус',
      colActions: 'Дії',
      currencyUah: 'грн',
      showingRange: 'Показано {{from}} - {{to}} з {{total}}',
      prev: 'Назад',
      next: 'Далі',
      viewReceipt: 'Переглянути',
      editAmountTip: 'Редагувати суму',
      adjustedAmount: '(скориговано: {{amount}} грн)',
      approve: 'Підтвердити',
      reject: 'Відхилити',
      receiptTitle: 'Квитанція',
      rejectTitle: 'Відхилення платежу',
      rejectHint: 'Вкажіть причину відхилення. Учень побачить цю інформацію.',
      rejectPlaceholder: 'Причина відхилення...',
      cancel: 'Скасувати',
      months: [
        'Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень',
        'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'
      ],
      loadErrorStatus: 'Помилка завантаження: {{status}}',
      loadErrorConn: 'Помилка з\'єднання з сервером',
      salaryTotalEarned: 'Загальний заробіток',
      salaryPaid: 'Виплачено',
      salaryPending: 'Очікує виплати',
      salaryTeachers: 'Викладачів',
      salaryPeriodMonth: '{{month}} {{year}}',
      salaryPaidThisMonth: 'Цього місяця',
      salaryPendingHint: 'За проведені уроки',
      salaryWithEarnings: 'З заробітком',
      salaryColTeacher: 'Викладач',
      salaryColLessons: 'Уроки',
      salaryColEarned: 'Заробіток',
      salaryColPenalties: 'Штрафи',
      salaryColToPay: 'До виплати',
      salaryColStatus: 'Статус',
      salaryColActions: 'Дії',
      salaryHours: '{{count}} год',
      salaryStatusPaid: 'Виплачено',
      salaryStatusPartial: 'Частково',
      salaryStatusPending: 'Очікує',
      salaryPay: 'Виплатити',
      lessonsIndShort: '{{count}} інд.',
      lessonsGrpShort: '{{count}} гр.',
      lessonsClubShort: '{{count}} клуб',
      salaryEmpty: 'Немає даних про зарплати',
      salaryEmptyHint: 'За цей період немає проведених уроків',
      salaryExpandTitle: 'Показати історію заробітку',
      salaryCollapseTitle: 'Приховати історію заробітку',
      salaryBreakdownLessons: 'Уроки',
      salaryBreakdownPenalties: 'Штрафи',
      salaryBreakdownEmpty: 'Немає деталей за цей місяць',
      salaryBreakdownDate: 'Дата',
      salaryBreakdownStudent: 'Учень',
      salaryBreakdownType: 'Тип',
      salaryBreakdownStatus: 'Статус',
      salaryBreakdownAmount: 'Сума',
      salaryBreakdownReason: 'Причина',
      salaryLessonCatIndividual: 'Індивідуальний',
      salaryLessonCatGroup: 'Груповий',
      salaryLessonCatClub: 'Клуб',
      salaryLessonCatCancelledLate: 'Пізнє скасування',
      salaryLessonCatMissed: 'Учень не прийшов',
      salaryLessonCatTeacherShort: 'Викладач затримався',
      salaryLessonCatBothNoShow: 'Ніхто не з\'явився',
      salaryLoadErrorBreakdown: 'Не вдалося завантажити історію',
      salaryPenaltyStatusPending: 'Очікує',
      salaryPenaltyStatusDeducted: 'Утримано',
      salaryPenaltyStatusWaived: 'Списано',
      salaryBreakdownLoading: 'Завантаження...',
      payTitle: 'Виплата зарплати',
      payTeacherLabel: 'Викладач:',
      payAmount: 'Сума до виплати',
      payExpected: 'Очікується: {{amount}} грн',
      payMethod: 'Спосіб оплати',
      payMethodCash: 'Готівка',
      payMethodCard: 'Картка',
      payMethodBank: 'Банківський переказ',
      payNotes: 'Примітка',
      payNotesPlaceholder: 'Необов\'язково',
      payReceipt: 'Квитанція (скріншот переказу)',
      payReceiptUrlPlaceholder: 'URL зображення або завантажте файл',
      payUpload: 'Завантажити файл',
      payUploading: 'Завантаження...',
      payView: 'Переглянути',
      payErrImageUpload: 'Помилка завантаження зображення',
      payErrSalary: 'Помилка при виплаті зарплати',
      payConfirm: 'Підтвердити виплату',
      rangeAllTime: 'Весь час',
      rangeYear: 'Рік',
      rangeMonth: 'Місяць',
      statTopups: 'Поповнено',
      statCharged: 'Списано',
      statPeriodBalance: 'Баланс за період',
      statTotalBalances: 'Всього на балансах',
      statLessonsPurchases: 'Уроки, покупки',
      statPeriodBalanceHint: 'Поповнення - списання',
      statTotalBalancesHint: 'Поточний залишок учнів',
      statPeriodAllTime: 'За весь час',
      statPeriodYear: '{{year}} рік',
      chargesByServices: 'Списання за типами послуг',
      typeIndividual: 'Індивідуальні',
      typeGroup: 'Групові',
      typeClubs: 'Клуби',
      typeCourses: 'Курси',
      typeShop: 'Магазин',
      typeStars: 'Купівля зірочок',
      typeSubscription: 'Підписка',
      txCount: '{{count}} транзакцій',
      historyTitle: 'Історія транзакцій',
      typeAll: 'Всі типи',
      typeTopup: 'Поповнення',
      typeLessonPayment: 'Оплата уроків',
      typePurchases: 'Покупки',
      typeBonuses: 'Бонуси',
      typeRefunds: 'Повернення',
      typeShopPurchase: 'Покупка в магазині',
      typeClubPayment: 'Клуб (абонемент)',
      typeAiSubscription: 'Підписка',
      typeBonus: 'Бонус',
      typeRefund: 'Повернення',
      typeGroupLesson: 'Груповий урок',
      typeClubLesson: 'Клуб (заняття)',
      typeCourse: 'Курс',
      typeIndividualLesson: 'Індивідуальний урок',
      colType: 'Тип',
      colDescription: 'Опис',
      colReason: 'Причина',
      colLessonType: 'Тип',
      colTeacher: 'Викладач',
      colTeacherPayoutStatus: 'Статус',
      txEmpty: 'Транзакцій не знайдено',
      penTotalCount: 'Всього штрафів',
      penActive: 'Активних',
      penWaived: 'Скасовано',
      penActiveAmount: 'Сума активних',
      filtersLabel: 'Фільтри:',
      penAllTeachers: 'Всі викладачі',
      penAllStatuses: 'Всі статуси',
      penStatusPending: 'Активні',
      penStatusWaived: 'Скасовані',
      penTypeAll: 'Всі типи',
      penTypeIndividual: 'Індивідуальні',
      penTypeGroup: 'Групові',
      penTypeClub: 'Клуби',
      resetFilters: 'Скинути фільтри',
      penListTitle: 'Список штрафів',
      penColDate: 'Дата',
      penColTeacher: 'Викладач',
      penColLessonType: 'Тип',
      penColReason: 'Причина',
      penColStatus: 'Статус',
      penColActions: 'Дії',
      penColSum: 'Сума',
      penStudentLabel: 'Студент: {{name}}',
      penBadgeActive: 'Активний',
      penBadgeWaived: 'Скасовано',
      penEmpty: 'Штрафів не знайдено',
      penWaive: 'Скасувати',
      penTopTeachers: 'Викладачі з найбільшою сумою штрафів',
      penTopCount: '({{count}} штрафів)',
      penWaiveTitle: 'Скасувати штраф?',
      penWaiveConfirmMessage: 'Ви впевнені, що хочете скасувати штраф {{amount}} грн для викладача {{name}}?',
      penWaiveReasonLabel: 'Причина скасування *',
      penWaiveReasonPlaceholder: 'Вкажіть причину скасування штрафу...',
      penWaiveReasonRequired: 'Вкажіть причину скасування штрафу',
      penWaiveErr: 'Помилка при скасуванні штрафу',
      penDismiss: 'Відміна',
      penWaiving: 'Скасування...',
      penWaiveSubmit: 'Скасувати штраф',
      lessonIndividual: 'Індивідуальний',
      lessonGroup: 'Груповий',
      lessonClub: 'Клуб',
    },
    courses: {
      stepTypeVideo: 'Відео',
      stepTypeText: 'Конспект',
      stepTypeExercise: 'Вправа',
      exerciseTest: 'Тест (одна правильна)',
      exerciseMultiple: 'Multiple Choice (кілька правильних)',
      exerciseInput: 'Введення відповіді',
      exerciseMatching: 'Встановлення відповідності',
      levelA1: 'A1 - Початковий',
      levelA2: 'A2 - Елементарний',
      levelB1: 'B1 - Середній',
      levelB2: 'B2 - Вище середнього',
      levelC1: 'C1 - Просунутий',
      levelC2: 'C2 - Професійний',
      successTitle: 'Успішно',
      errorTitle: 'Помилка',
      courseCreated: 'Курс "{{name}}" створено',
      courseCreateError: 'Не вдалося створити курс: {{error}}',
      // Course listing
      subtitle: 'Управління навчальними курсами',
      createCourse: 'Створити курс',
      courseName: 'Назва курсу',
      courseNamePlaceholder: 'Введіть назву курсу...',
      searchCourses: 'Пошук курсів...',
      loadingCourses: 'Завантаження курсів...',
      emptyCreateFirst: 'Створіть перший курс, щоб почати',
      priceGrn: '{{price}} грн',
      duplicateCourse: 'Дублювати курс',
      deleteCourse: 'Видалити курс',
      published: 'Опубліковано',
      draft: 'Чернетка',
      // Course editor
      editingCourse: 'Редагування курсу',
      tabDetails: 'Деталі курсу',
      tabLanding: 'Початкова сторінка',
      tabMaterials: 'Матеріали курсу',
      courseCover: 'Обкладинка курсу',
      courseCoverAlt: 'Обкладинка курсу',
      remove: 'Видалити',
      change: 'Змінити',
      uploadImageHint: 'Натисніть, щоб завантажити зображення',
      uploadImageFormats: 'PNG, JPG до 5MB, формат 40:23',
      courseDescription: 'Опис курсу',
      courseDescriptionPlaceholder: 'Введіть опис курсу...',
      courseLevel: 'Рівень курсу',
      priceUAH: 'Ціна курсу (грн)',
      preview: 'Попередній перегляд',
      unpublish: 'Зняти з публікації',
      publish: 'Опублікувати курс',
      // Initial test section
      initialTest: 'Початковий тест',
      initialTestDescription: 'Тест для визначення початкового рівня студента підтягується автоматично з матеріалів курсу',
      testModeNMT: 'НМТ',
      testModeNormal: 'Звичайний',
      questionsCount: '{{count}} питань',
      pointsCount: '{{count}} балів',
      questionsPointsInfo: '{{questions}} питань · {{points}} балів',
      edit: 'Редагувати',
      testNotCreated: 'Тест не створено',
      createInitialTestPrompt: 'Створіть початковий тест для курсу',
      createTest: 'Створити тест',
      // Landing tab
      whatStudentSees: 'Що бачить студент',
      landingInfoDescription: 'Інформація, яка відображається на початковій сторінці курсу для студента',
      levelLabel: 'Рівень: {{level}}',
      notSpecified: 'Не вказано',
      courseProgress: 'Прогрес курсу',
      initialTestResult: 'Початковий результат тесту',
      notPassed: 'Не пройдено',
      blocksCount: 'Кількість блоків',
      totalLessonsCount: 'Загальна кількість уроків',
      progressTable: 'Таблиця прогресу',
      courseStructureDescription: 'Структура курсу, яку бачить студент з відміткою про проходження',
      colBlock: 'Блок',
      colLessons: 'Уроки',
      colStatus: 'Статус',
      lessonsCount: '{{count}} уроків',
      plusTest: '+ тест',
      notStarted: 'Не розпочато',
      addBlocksHint: 'Додайте блоки та уроки у вкладці "Матеріали курсу"',
      initialTestNMT: 'Початковий тест (НМТ)',
      initialTestOptional: 'Необов\'язково. Тест для визначення початкового рівня студентів.',
      withInitialTest: 'Створити тест',
      withoutInitialTest: 'Без тесту',
      noInitialTest: 'Курс без початкового тесту',
      changeInitialTestChoice: 'Змінити',
      deleteInitialTest: 'Видалити тест',
      deleteInitialTestTitle: 'Видалити початковий тест?',
      deleteInitialTestMessage: 'Усі питання буде видалено. Курс залишиться без початкового тесту.',
      create: 'Створити',
      // Materials tab / blocks
      addBlock: 'Додати блок',
      blockName: 'Назва блоку',
      blockNamePlaceholder: 'Введіть назву блоку...',
      save: 'Зберегти',
      cancel: 'Скасувати',
      editName: 'Редагувати назву',
      deleteBlock: 'Видалити блок',
      subBlocksCountOne: '{{count}} підблок',
      subBlocksCountFew: '{{count}} підблоки',
      subBlocksCountMany: '{{count}} підблоків',
      addLesson: 'Додати урок',
      addSubBlock: 'Додати підблок',
      subBlockName: 'Назва підблоку',
      subBlockNamePlaceholder: 'Введіть назву підблоку...',
      lessonName: 'Назва уроку',
      lessonNamePlaceholder: 'Введіть назву уроку...',
      subBlocksLabel: 'Підблоки',
      lessonsInBlockLabel: 'Уроки блоку',
      deleteSubBlock: 'Видалити підблок',
      noLessonsInSubBlock: 'У цьому підблоці ще немає уроків',
      deleteLesson: 'Видалити урок',
      stepsCount: '{{count}} кроків',
      questionsCountShort: '{{count}} питань',
      noLessonsInBlock: 'У цьому блоці ще немає уроків або підблоків',
      courseMaterialsTitle: 'Матеріали курсу',
      courseMaterialsWillBeHere: 'Тут будуть відображатися матеріали курсу',
      // Preview / lesson viewing
      previewCourse: 'Попередній перегляд курсу',
      studentCabinet: '• Кабінет студента',
      home: 'Головна',
      videoLabel: 'Відео',
      notesLabel: 'Конспект',
      exerciseLabel: 'Вправа',
      videoNotAdded: 'Відео не додано',
      videoUrlLabel: 'Відео: {{url}}',
      notesEmpty: 'Конспект порожній',
      optionN: 'Варіант {{n}}',
      enterYourAnswer: 'Введіть вашу відповідь...',
      correctAnswer: 'Правильна відповідь:',
      leftPart: 'Ліва частина {{n}}',
      rightPart: 'Права частина {{n}}',
      resultLabel: 'Результат:',
      tryAgain: 'Спробувати ще раз',
      checkAnswer: 'Перевірити відповідь',
      lessonNoMaterials: 'Цей урок ще не має матеріалів',
      prevStep: 'Попередній крок',
      nextStep: 'Наступний крок',
      yourProgress: 'Ваш прогрес',
      selectLesson: 'Оберіть урок для перегляду',
      loadingCourse: 'Завантаження курсу...',
      // Lesson/step editor
      editingTest: 'Редагування тесту',
      editingLesson: 'Редагування уроку',
      testQuestions: 'Питання тесту',
      lessonSteps: 'Кроки уроку',
      addQuestion: 'Додати питання',
      addStep: 'Додати крок',
      selectStepType: 'Оберіть тип кроку:',
      questionN: 'Питання {{n}}',
      questionNShort: 'Питання {{n}}',
      duplicateQuestion: 'Дублювати питання',
      deleteQuestion: 'Видалити питання',
      videoName: 'Назва відео',
      videoNamePlaceholder: 'Введіть назву відео...',
      video: 'Відео',
      videoUploaded: 'Відео завантажено',
      uploadVideo: 'Завантажити відео',
      videoFormats: 'MP4, WebM (до 500MB)',
      videoSaveError: 'Помилка при збереженні відео. Спробуйте ще раз.',
      notesText: 'Текст конспекту',
      notesTextPlaceholder: 'Введіть текст конспекту...',
      notesFormattingHint: 'Підтримується форматування: **жирний**, *курсив*, - списки',
      exerciseType: 'Тип вправи',
      exerciseContext: 'Матеріал для питань',
      exerciseContextHint: 'Додайте текст, зображення, аудіо чи відео, на основі яких студенти відповідатимуть на питання.',
      exerciseContextText: 'Текст',
      exerciseContextImage: 'Зображення',
      exerciseContextAudio: 'Аудіо',
      exerciseContextVideo: 'Відео',
      exerciseContextTextPlaceholder: 'Введіть текст (наприклад, статтю або діалог), на основі якого будуть питання...',
      exerciseContextUploadImage: 'Завантажити зображення',
      exerciseContextUploadAudio: 'Завантажити аудіо',
      exerciseContextImageUploaded: 'Зображення завантажено',
      exerciseContextAudioUploaded: 'Аудіо завантажено',
      exerciseContextRemove: 'Прибрати матеріал',
      enterQuestion: 'Введіть питання...',
      answerOptions: 'Варіанти відповідей',
      addOption: '+ Додати варіант',
      correctAnswerLabel: 'Правильна відповідь',
      enterCorrectAnswer: 'Введіть правильну відповідь...',
      matchingPairs: 'Пари для відповідності',
      leftPartLabel: 'Ліва частина',
      rightPartLabel: 'Права частина',
      addPair: '+ Додати пару',
      noQuestionsInTest: 'Цей тест ще не має питань',
      noStepsInLesson: 'Цей урок ще не має кроків',
      addFirstQuestion: 'Додати перше питання',
      addFirstStep: 'Додати перший крок',
      backToList: 'Назад до списку',
      // Initial test editor (NMT)
      initialTestModeLabel: 'Тест для визначення початкового рівня • Режим: {{mode}}',
      saveTest: 'Зберегти тест',
      testDisplayMode: 'Режим відображення тесту:',
      normalMode: 'Звичайний',
      normalModeDescription: 'Послідовний перегляд питань',
      nmtMode: 'НМТ',
      nmtModeDescription: 'Навігація по питаннях зверху',
      addQuestionLabel: 'Додати питання:',
      singleAnswer: 'Одна відповідь',
      multipleAnswers: 'Кілька відповідей',
      matching: 'Встановлення відповідності',
      fillBlank: 'Заповнити пропуск',
      readingWithText: 'Читання (з текстом)',
      withImages: 'З картинками',
      qTypeSingle: 'Одна відповідь',
      qTypeMultiple: 'Кілька відповідей',
      qTypeMatching: 'Відповідність',
      qTypeFillBlank: 'Заповнити пропуск',
      qTypeReading: 'Читання',
      qTypeImage: 'З картинками',
      pointsShort: 'балів',
      readingTextLabel: 'Текст для читання',
      readingTextPlaceholder: 'Введіть текст для читання...',
      imageForQuestion: 'Зображення до питання',
      optional: '(необов\'язково)',
      clickToUpload: 'Натисніть для завантаження',
      questionLabel: 'Питання',
      questionPlaceholder: 'Введіть текст питання...',
      optionLetter: 'Варіант {{letter}}',
      fillBlankHint: 'Використовуйте ___ у питанні для позначення пропуску',
      addQuestionsToTest: 'Додайте питання до тесту',
      selectQuestionTypeHint: 'Оберіть тип питання вище для створення тесту у форматі НМТ',
      // Delete confirmations
      deleteBlockTitle: 'Видалити блок?',
      deleteBlockMessage: 'Ви впевнені, що хочете видалити блок "{{name}}"? Всі уроки в цьому блоці також будуть видалені.',
      deleteCourseTitle: 'Видалити курс?',
      deleteCourseMessage: 'Ви впевнені, що хочете видалити курс "{{name}}"? Цю дію неможливо скасувати.',
      deleteLessonTitle: 'Видалити урок?',
      deleteLessonMessage: 'Ви впевнені, що хочете видалити урок "{{name}}"? Цю дію неможливо скасувати.',
      confirmDelete: 'Видалити',
      // Initial defaults
      initialTestDefault: 'Початковий тест',
      testDefault: 'Тест',
    },
    overviewMonths: {
      m0: 'Січень', m1: 'Лютий', m2: 'Березень', m3: 'Квітень', m4: 'Травень', m5: 'Червень',
      m6: 'Липень', m7: 'Серпень', m8: 'Вересень', m9: 'Жовтень', m10: 'Листопад', m11: 'Грудень',
    },
    lessonsTab: {
      subTabConsultations: 'Записи',
      subTabIndividual: 'Індивідуальні уроки',
      subTabGroup: 'Групові уроки',
      subTabCancelled: 'Скасовані (баланс)',
      cancelledTitle: 'Скасовані через баланс',
      cancelledSubtitle: 'Заняття, автоматично скасовані за 4 год до початку через недостатній баланс. Відновіть, щоб урок відбувся — баланс піде далі в мінус.',
      cancelledEmpty: 'Немає майбутніх занять, скасованих через баланс.',
      colLessonDate: 'Дата і час уроку',
      colBalance: 'Баланс учня',
      colReason: 'Причина',
      reasonInsufficientBalance: 'Недостатній баланс',
      reasonNegativeBalance: 'Борг (мінусовий баланс)',
      reasonCourseSuspended: 'Курс призупинено',
      restore: 'Відновити',
      restoreConfirmTitle: 'Відновити заняття?',
      restoreConfirmMessage: 'Відновити скасоване заняття {{student}} на {{date}}? Баланс учня піде далі в мінус коли урок буде завершено.',
      restoreSuccessMessage: 'Заняття відновлено. Учень і викладач отримали сповіщення.',
      restoreError: 'Не вдалося відновити заняття',
      manageLessonsTitle: 'Керування уроками серії',
      manageLessonsHint: 'Змініть час майбутнього уроку. Учень і викладач отримають сповіщення в застосунку та Telegram.',
      loadLessonsError: 'Не вдалося завантажити список уроків',
      seriesScheduleTitle: 'Поточний розклад серії',
      seriesScheduleHintDays: 'Змінюйте день і/або час для всіх майбутніх занять цього слоту, додавайте або прибирайте дні. Кількість уроків не зміниться — майбутні заняття буде перерозподілено за новим розкладом.',
      addDayBtn: 'Додати день',
      removeDayBtn: 'Прибрати',
      addDayHint: 'Новий день додасться до тижневого розкладу. Залишок уроків перерозподілиться — серія завершиться раніше.',
      addDayDayLabel: 'День тижня:',
      addDaySelectDay: 'Оберіть день',
      addDayTimeLabel: 'Час (робочі години вчителя):',
      addDaySaveBtn: 'Додати день',
      removeDayConfirmTitle: 'Прибрати день із розкладу?',
      removeDayConfirmMessage: 'Заняття по {{day}} о {{time}} більше не будуть у розкладі. Майбутні уроки перерозподіляться на інші дні — серія завершиться пізніше. Учень і викладач отримають сповіщення.',
      weeklySlotsSuccess: 'Розклад серії оновлено. Перенесено уроків: {{count}}. Останнє заняття: {{last}}. Учень і викладач отримали сповіщення.',
      weeklySlotsError: 'Не вдалося змінити дні серії',
      seriesScheduleHint: 'Змінюйте час одразу для всіх майбутніх занять серії в цей день тижня.',
      currentSlotTime: 'Час: {{time}}',
      changeSeriesTime: 'Змінити день / час',
      changeSlotSuccess: 'Розклад серії оновлено. Перенесено уроків: {{count}}. Учень і викладач отримали сповіщення.',
      changeSlotError: 'Не вдалося змінити розклад серії',
      changeTime: 'Змінити час',
      saveNewTime: 'Зберегти',
      changeTimeSuccess: 'Час уроку змінено. Учень і викладач отримали сповіщення.',
      changeTimeError: 'Не вдалося змінити час уроку',
      addExtraTitle: 'Додаткове заняття',
      addExtraHint: 'Додає одне разове заняття до серії. Програму буде продовжено на +1 урок, нумерація зсунеться відповідно.',
      addExtraBtn: 'Додати заняття',
      addExtraDateLabel: 'Дата:',
      addExtraTimeLabel: 'Виберіть вільний слот у розкладі вчителя:',
      addExtraLoadingSlots: 'Завантаження розкладу вчителя…',
      addExtraNoAvailability: 'У вчителя немає робочих годин у цей день.',
      addExtraSlotBusy: 'Слот зайнятий',
      addExtraFreeLabel: 'Безкоштовне заняття (не списувати з балансу учня)',
      addExtraSaveBtn: 'Додати',
      addExtraSuccess: 'Додаткове заняття додано. Учень і викладач отримали сповіщення.',
      addExtraError: 'Не вдалося додати заняття',
      notEditable: 'Не редагується',
      emptyLessons: 'Немає уроків у серії',
      lessonStatus_scheduled: 'Заплановано',
      lessonStatus_completed: 'Проведено',
      lessonStatus_cancelled: 'Скасовано',
      lessonStatus_pending: 'Очікує',
      lessonStatus_teacher_leave_skip: 'Пропущено (відпустка)',
      lessonStatus_vacation_skip: 'Пропущено (канікули)',
      consultationsTitle: 'Записи на консультацію',
      consultationsSubtitle: 'Заявки на пробні уроки та консультації',
      statAll: 'Всі',
      statNew: 'Нові',
      statContacted: 'Зв\'язались',
      statScheduled: 'Заплановано',
      statCompleted: 'Завершено',
      statNoResponse: 'Не відповідає',
      statusNew: 'Нова',
      statusContacted: 'Зв\'язались',
      statusScheduled: 'Заплановано',
      statusCompleted: 'Завершено',
      statusCancelled: 'Скасовано',
      statusNoResponse: 'Не відповідає',
      preferredTime: 'Бажаний час:',
      scheduledOn: 'Заплановано: {{date}} о {{time}}',
      teacherLabel: 'Вчитель: {{name}}',
      notesLabel: 'Примітки:',
      createdOn: 'Створено: {{when}}',
      titleMarkContacted: 'Позначити як «Зв\'язались»',
      titleAssignTeacher: 'Призначити вчителя',
      titleMarkCompleted: 'Позначити як завершено',
      titleNoResponse: 'Не відповідає',
      titleDelete: 'Видалити',
      emptyConsultations: 'Немає заявок на консультацію',
      emptyConsultationsHint: 'Нові заявки з форми запису з\'являться тут',
      assignTitle: 'Призначити вчителя',
      childLabel: 'Дитина: {{name}}',
      teacher: 'Вчитель',
      selectTeacher: 'Оберіть вчителя',
      date: 'Дата',
      time: 'Час',
      cancel: 'Скасувати',
      assignBtn: 'Призначити',
      individualTitle: 'Індивідуальні уроки',
      individualSubtitle: 'Керування серіями індивідуальних занять',
      createSeries: 'Створити серію',
      createTrial: 'Пробне заняття',
      modalCreateTrial: 'Створити пробне заняття',
      trialHint: 'Разове безкоштовне заняття для учня. Оплату вчителю оберіть нижче.',
      trialTeacherPaymentLabel: 'Оплата вчителю',
      trialTeacherPaidStandard: 'Звичайна ставка (як за індивідуальний урок)',
      trialTeacherPaidFree: 'Безкоштовно (урок не входить у ЗП)',
      trialPickDateFirst: 'Спочатку оберіть дату та час',
      trialTeacherHint: 'Показані лише вчителі, які працюють у цей час і не мають іншого заняття саме на цю дату',
      presentation: 'Презентація',
      searchPresentation: 'Пошук презентації...',
      untitledPresentation: 'Без назви',
      createTrialBtn: 'Створити пробне',
      trialCreatedMessage: 'Пробне заняття заплановано',
      createTrialError: 'Помилка створення пробного заняття',
      trialHomework: 'Домашнє завдання',
      trialHomeworkNone: 'Без домашнього завдання',
      trialHomeworkHint: 'Надішлеться автоматично після завершення уроку',
      trialGames: 'Ігри на повторення',
      trialGamesSearch: 'Пошук гри...',
      trialGamesNone: 'Ігри не знайдено',
      trialGamesAllAdded: 'Усі доступні ігри вже додані',
      trialGamesHint: 'Стануть доступні учню в обраному порядку після завершення уроку',
      trialGameUntitled: 'Без назви',
      trialGameMoveUp: 'Пересунути вгору',
      trialGameMoveDown: 'Пересунути вниз',
      trialGameRemove: 'Видалити',
      statActiveSeries: 'Активних серій',
      statPendingPayment: 'Очікують оплати',
      statTotalStudents: 'Всього студентів',
      statInvolvedTeachers: 'Вчителів задіяно',
      statPaused: 'На паузі',
      colStudent: 'Студент',
      colTeacher: 'Вчитель',
      colProgram: 'Програма',
      colSchedule: 'Розклад',
      colProgress: 'Прогрес',
      colStatus: 'Статус',
      colPayment: 'Оплата',
      colActions: 'Дії',
      paid: 'Оплачено',
      pending: 'Очікує',
      payFromBalance: 'Оплатити з балансу',
      confirmWithoutPayment: 'Підтвердити без оплати',
      cancelSeriesTitle: 'Скасувати серію?',
      cancelSeriesMessage: 'Скасувати цю серію уроків?',
      confirmSeriesPaid: 'Підтвердити серію з оплатою?',
      confirmSeriesFree: 'Підтвердити серію без оплати?',
      confirmSeriesPaidMessage: 'Оплата буде списана з балансу учня. Серія буде активована, уроки згенеровані в розклад.',
      confirmSeriesFreeMessage: 'Серія буде активована, уроки згенеровані в розклад. Оплата не буде списана з балансу учня.',
      seriesCreatedMessage: 'Серію створено! Згенеровано {{count}} уроків у розклад.',
      seriesConfirmedMessage: 'Серію підтверджено! Згенеровано {{count}} уроків.',
      awaitingPaymentTitle: 'Очікує оплати',
      awaitingPaymentMessage: 'Серію створено, але заняття НЕ додані в розклад!\n\nБаланс учня недостатній (потрібно {{price}} грн).\n\nУчню надіслано сповіщення про необхідність поповнення балансу. Серія буде скасована через 24 години без оплати.',
      createSeriesError: 'Помилка створення серії',
      confirmSeriesError: 'Помилка підтвердження серії',
      errorTitle: 'Помилка',
      successTitle: 'Успішно',
      emptySeries: 'Немає створених серій уроків',
      createFirstSeries: 'Створити першу серію',
      groupTitle: 'Групові уроки',
      groupSubtitle: 'Керування навчальними групами',
      createGroup: 'Створити групу',
      statForming: 'Формуються',
      statActive: 'Активних',
      statCompletedGroups: 'Завершених',
      statusActive: 'Активна',
      statusForming: 'Формується',
      statusPaused: 'Пауза',
      statusCompletedBadge: 'Завершено',
      statusCancelledBadge: 'Скасовано',
      groupProgram: 'Програма:',
      groupStart: 'Початок занять:',
      groupStudents: 'Студентів:',
      groupSchedule: 'Розклад:',
      groupTeacherLabel: 'Вчитель:',
      addStudentTitle: 'Додати студента',
      startGroupTitle: 'Запустити групу',
      cancelTitle: 'Скасувати',
      emptyGroups: 'Немає створених груп',
      createFirstGroup: 'Створити першу групу',
      cancelGroupTitle: 'Скасувати групу?',
      cancelGroupMessage: 'Скасувати цю групу?',
      startGroupConfirmTitle: 'Запустити групу?',
      startGroupConfirmMessage: 'Запустити групу та згенерувати уроки?',
      startGroupError: 'Помилка запуску групи',
      groupStarted: 'Групу запущено!',
      removeStudentTitle: 'Видалити студента?',
      removeStudentMessage: 'Видалити студента з групи?',
      addStudentError: 'Помилка додавання студента',
      createGroupError: 'Помилка створення групи',
      scheduleLabel: 'Розклад занять',
      addDay: 'Додати день',
      slotDuration: '(60 хв)',
      searchingTeachers: 'Пошук доступних вчителів...',
      noAvailableTeachers: 'Немає доступних вчителів на обраний час. Змініть розклад.',
      teacherHint: 'Показані тільки вчителі, доступні на обраний час',
      modalCreateSeries: 'Створити серію індивідуальних уроків',
      student: 'Студент',
      searchStudent: 'Пошук студента...',
      studentsNotFound: 'Студентів не знайдено. Спробуйте інший пошук.',
      program: 'Програма',
      selectProgram: 'Оберіть програму',
      programOption: '{{title}} — {{count}} уроків',
      startDate: 'Дата початку',
      lessonsCount: 'Кількість уроків',
      lessonsCountHint: 'Визначається програмою',
      customPrice: 'Ціна за заняття (грн)',
      customPricePlaceholder: 'За замовчуванням',
      customPriceHint: 'Якщо не вказано, використовується стандартна ціна з налаштувань. Вказана ціна буде фіксована для цієї програми та учня.',
      notes: 'Примітки',
      notesPlaceholder: 'Додаткова інформація...',
      addBackdated: 'Додати заднім числом',
      addBackdatedHint: 'Створити уроки з датою в минулому (для внесення вже проведених занять)',
      skipFirstLessonPrepayment: 'Не вимагати передоплату',
      skipFirstLessonPrepaymentHint: 'Уроки одразу з\'являються в розкладі без передоплати. Перший урок буде списаний після проведення, як і всі інші.',
      makeFirstLessonFree: 'Перше заняття безкоштовне',
      makeFirstLessonFreeHint: 'Перший урок серії — у подарунок. Кошти за нього не списуються ні до, ні після проведення. Наступні уроки оплачуються як зазвичай.',
      creating: 'Створення...',
      createSeriesBtn: 'Створити серію',
      modalCreateGroup: 'Створити групу',
      groupName: 'Назва групи',
      groupNamePlaceholder: 'Наприклад: Група B1 Вечірня',
      groupStartDate: 'Початок занять',
      groupStartDateHint: 'Заняття з\'являться в календарі учнів з цієї дати',
      maxStudents: 'Макс. студентів',
      studentsOptional: 'Учні (необов\'язково)',
      searchStudents: 'Пошук учнів...',
      studentsNotFoundShort: 'Учнів не знайдено',
      studentsHint: 'Ви можете додати учнів зараз або пізніше. Макс: {{max}} учнів',
      limitTitle: 'Обмеження',
      maxStudentsError: 'Максимальна кількість учнів у групі: {{max}}',
      createGroupBtn: 'Створити групу',
      addStudentModalTitle: 'Додати студента до групи',
      addStudentSearch: 'Пошук студента...',
      addStudentEmpty: 'Студентів не знайдено. Спробуйте інший пошуковий запит.',
      statusUpdated: 'Статус оновлено',
      statusUpdateError: 'Помилка оновлення статусу',
      deleteConsultationTitle: 'Видалити заявку?',
      deleteConsultationMessage: 'Цю дію неможливо скасувати.',
      consultationDeleted: 'Заявку видалено',
      assignTeacherError: 'Помилка призначення вчителя',
      assignFieldsError: 'Заповніть всі поля',
      assignSuccess: 'Вчителя призначено, консультація додана до розкладу',
      yearsShort: 'р.',
      atTime: 'о',
      expiresUntil: 'до',
      lessonsSuffix: 'уроків',
    },
    specialOffers: {
      newOffer: 'Нова пропозиція',
      editOffer: 'Редагувати пропозицію',
      tabActive: 'Активні',
      tabScheduled: 'Заплановані',
      tabArchive: 'Архів',
      tabStats: 'Аналітика',
      tabPromoCodes: 'Промокоди',
      offerTitle: 'Назва пропозиції',
      offerTitlePlaceholder: 'Наприклад: Знижка 20% на перший урок',
      description: 'Опис',
      descriptionPlaceholder: 'Детальний опис пропозиції...',
      image: 'Зображення',
      imageRecommended: 'Рекомендований розмір: 1920 × 1080 px (16:9)',
      dropRelease: 'Відпустіть для завантаження',
      imageSize: '1920 × 1080 px',
      ctaButton: 'Кнопка дії',
      ctaText: 'Текст кнопки',
      ctaAction: 'Дія кнопки',
      linkUrl: 'URL посилання',
      courseId: 'ID курсу',
      productIdOpt: 'ID товару (опційно)',
      selectClubs: 'Оберіть клуби',
      allClubs: 'Всі клуби',
      ctaLink: 'Посилання',
      ctaTopup: 'Поповнення балансу',
      ctaBookLesson: 'Бронювання уроку',
      ctaShop: 'Магазин',
      ctaCourse: 'Курс',
      ctaClub: 'Клуб',
      ctaFreeClub: 'Безкоштовний запис на клуб',
      ctaDiscountedClub: 'Запис на клуб зі знижкою',
      targetAll: 'Всі користувачі',
      targetSpecific: 'Конкретні користувачі',
      targetByLevel: 'За рівнем мови',
      targetNew: 'Нові користувачі',
      targetActive: 'Активні користувачі',
      targetInactive: 'Неактивні користувачі',
      targetHighSpenders: 'Ті, хто багато витрачає',
      targetProductPreference: 'За вподобаннями',
      targetNoClubSub: 'Ті, хто ще не придбав абонемент на клуби',
      deleteConfirmTitle: 'Видалити пропозицію?',
      deleteConfirmMessage: 'Ви впевнені, що хочете видалити "{{title}}"?',
      titleRequired: 'Введіть назву пропозиції',
      clubsRequired: 'Оберіть клуби для безкоштовного запису або виберіть "Всі клуби"',
      clubsDiscountedRequired: 'Оберіть клуби для запису зі знижкою або виберіть "Всі клуби"',
      discountTypeRequired: 'Оберіть тип знижки',
      discountValueRange: 'Введіть відсоток знижки від 1 до 99',
      levelRequired: 'Оберіть хоча б один рівень мови',
      uploadFailed: 'Не вдалося завантажити зображення',
      saveFailed: 'Не вдалося зберегти пропозицію',
      created: 'Пропозицію створено',
      updated: 'Пропозицію оновлено',
      deleted: 'Пропозицію видалено',
      deleteFailed: 'Не вдалося видалити',
      errorTitle: 'Помилка',
      successTitle: 'Успіх',
      previewTitleFallback: 'Назва пропозиції',
      previewDescFallback: 'Опис пропозиції',
      defaultCta: 'Дізнатися більше',
      loadingClubs: 'Завантаження клубів...',
      allAvailableClubs: 'Всі доступні клуби',
      clubsCountShort: '{{count}} клубів',
      noClubsAfter: 'Немає доступних клубів після {{date}}',
      freeLabel: 'Безкоштовно',
      selectedClubsCount: 'Обрано клубів: {{count}}',
      userCanChooseAnyFree: 'Користувач зможе обрати будь-який доступний клуб безкоштовно',
      userCanChooseAny: 'Користувач зможе обрати будь-який доступний клуб',
      discountType: 'Тип знижки',
      freeFullDiscount: 'Безкоштовно (100%)',
      percentDiscount: 'Відсоток знижки',
      percentDiscountShort: '% знижки',
      currencyUah: 'грн',
      countdownTimer: 'Таймер зворотного відліку',
      fixedDate: 'Фіксована дата',
      personalized: 'Персоналізований',
      minutesFromFirstView: 'хвилин від першого перегляду',
      effectsConfetti: 'Ефекти (конфеті)',
      confettiHint: 'При першому показі буде анімація конфеті',
      targetAudience: 'Цільова аудиторія',
      searchUsersPlaceholder: 'Пошук користувачів...',
      chooseLanguageLevels: 'Оберіть рівні мови:',
      chooseAtLeastOneLevel: 'Оберіть хоча б один рівень',
      selectedPrefix: 'Обрано:',
      uniqueUsers: 'Унікальних користувачів',
      viewsStat: 'Переглядів',
      modalViewsStat: 'Показів модалки',
      clicksStat: 'Кліків',
      ctrTotal: 'CTR (загальний)',
      ctrModal: 'CTR (модалка)',
      statsByDays: 'Статистика за днями',
      viewsLabel: 'Перегляди',
      clicksLabel: 'Кліки',
      chooseOfferForStats: 'Оберіть пропозицію для перегляду статистики',
      required: '*',
      registeredWithinLast: 'Зареєстровані за останні',
      daysUnit: 'днів',
      minimum: 'Мінімум',
      lessonsWithin30: 'уроків за 30 днів',
      inactiveMoreThan: 'Неактивні більше',
      spentMoreThan: 'Витратили більше',
      currency: 'грн',
      validityPeriod: 'Період дії',
      startLabel: 'Початок',
      endOptional: 'Кінець (опційно)',
      priority: 'Пріоритет',
      activeLabel: 'Активна',
      previewBtn: 'Попередній перегляд',
      saveChanges: 'Зберегти зміни',
      createBtn: 'Створити',
      emptyActive: 'Немає активних пропозицій',
      emptyScheduled: 'Немає запланованих пропозицій',
      emptyArchive: 'Архів порожній',
      startsAt: 'Старт: {{when}}',
      endsAt: 'До: {{when}}',
      offerActive: 'Активна',
      offerInactive: 'Неактивна',
      timerTag: 'Таймер',
      effectsTag: 'Ефекти',
      previewTooltip: 'Попередній перегляд',
      analyticsTooltip: 'Аналітика',
      editTooltip: 'Редагувати',
      deleteTooltip: 'Видалити',
      pickAnother: 'Обрати іншу пропозицію',
    },
    products: {
      catalog: 'Каталог',
      orders: 'Замовлення',
      newProduct: 'Новий товар',
      editProduct: 'Редагування товару',
      name: 'Назва товару',
      price: 'Ціна (грн)',
      sku: 'Код товару (SKU)',
      category: 'Категорія',
      catWorkbook: 'Воркбук',
      catFlashcards: 'Картки',
      catMerch: 'Мерч',
      topic: 'Тема / Призначення',
      noTopic: 'Без теми',
      description: 'Опис',
      availability: 'Наявність',
      inStock: 'В наявності',
      outOfStock: 'Немає в наявності',
      addImage: 'Додати',
      features: 'Характеристики',
      addFeature: 'Додати характеристику',
      productPerks: 'Особливості товару',
      productPerksHint: 'Список переваг, які відображаються на сторінці товару',
      addPerk: 'Додати особливість',
      colName: 'Назва',
      colDescription: 'Опис',
      colPrice: 'Ціна',
      colStatus: 'Статус',
      colActions: 'Дії',
      emptyProducts: 'Немає товарів',
      emptyProductsHint: 'Додайте перший товар до каталогу',
      ordersTitle: 'Замовлення',
      allStatuses: 'Всі статуси',
      statusNew: 'Нові',
      statusProcessing: 'В обробці',
      statusShipped: 'Відправлені',
      statusDelivered: 'Доставлені',
      statusCancelled: 'Скасовані',
      statusNewBadge: 'Новий',
      statusProcessingBadge: 'В обробці',
      statusShippedBadge: 'Відправлено',
      statusDeliveredBadge: 'Доставлено',
      statusCancelledBadge: 'Скасовано',
      statNew: 'Нових',
      statProcessing: 'В обробці',
      statShipped: 'Відправлено',
      statDelivered: 'Доставлено',
      statTotal: 'Всього',
      colCustomer: 'Клієнт',
      colDelivery: 'Адреса доставки',
      colProducts: 'Товари',
      colTotal: 'Сума',
      colDate: 'Дата',
      emptyOrders: 'Немає замовлень',
      emptyOrdersHint: 'Замовлення з магазину будуть відображатися тут',
      orderNumber: 'Замовлення #{{id}}',
      customerInfo: 'Інформація про клієнта',
      nameLabel: 'Ім\'я:',
      phoneLabel: 'Телефон:',
      cityLabel: 'Місто:',
      deliveryLabel: 'Доставка',
      deliveryMethod: 'Спосіб:',
      deliveryBranch: 'Адреса/Відділення:',
      novaPoshta: 'Нова Пошта',
      ukrPoshta: 'Укрпошта',
      pickup: 'Самовивіз',
      payment: 'Оплата',
      paidFromBalance: 'Оплачено з балансу',
      cashOnDelivery: 'Накладний платіж',
      paid: 'Оплачено',
      itemsLabel: 'Товари',
      total: 'Всього:',
      commentLabel: 'Коментар',
      inStockShort: 'В наявності',
      outOfStockShort: 'Немає',
      limitTitle: 'Обмеження',
      maxImages: 'Максимум {{max}} зображень',
      moreAllowed: 'Можна додати ще {{n}} зображень (максимум {{max}})',
      errorTitle: 'Помилка',
      successTitle: 'Успіх',
      formValidation: 'Заповніть назву та ціну товару',
      imageUploadError: 'Помилка завантаження зображення',
      saveError: 'Помилка збереження товару',
      deleteTitle: 'Видалити товар?',
      deleteMessage: 'Ви впевнені, що хочете видалити цей товар?',
      deleteError: 'Помилка видалення товару',
      statusUpdateError: 'Помилка оновлення статусу замовлення',
      loading: 'Завантаження...',
      productsHint: 'Управління товарами магазину: воркбуки, картки, мерч',
      addProduct: 'Додати товар',
      namePlaceholder: 'Введіть назву товару',
      pricePlaceholder: '0',
      skuPlaceholder: 'напр. WB-A1-001',
      topicGeneral: 'General English',
      topicGrammar: 'Grammar',
      topicVocabulary: 'Vocabulary',
      topicPronunciation: 'Pronunciation',
      topicBusiness: 'Business English',
      descriptionPlaceholder: 'Короткий опис товару',
      imagesLabel: 'Зображення товару ({{current}}/{{max}})',
      imageAlt: 'Фото {{n}}',
      newImageAlt: 'Нове фото {{n}}',
      imageInfo: 'JPEG, PNG, GIF, WebP (до 5 МБ кожне, максимум {{max}} фото)',
      specKeyPlaceholder: 'Назва (напр. Формат)',
      specValuePlaceholder: 'Значення (напр. A4)',
      featurePlaceholder: 'напр. Більше 100 вправ на закріплення матеріалу',
      save: 'Зберегти',
      cancel: 'Скасувати',
      edit: 'Редагувати',
      delete: 'Видалити',
      view: 'Переглянути',
      close: 'Закрити',
      categoryCount: '{{label}} ({{count}})',
      priceUAH: '{{price}} грн',
      ordersHint: 'Управління замовленнями з магазину',
      orderNumberCol: '№ замовлення',
      emailLabel: 'Email:',
      dateLocale: 'uk-UA',
    },
    reviews: {
      allReviews: 'Всі відгуки',
      allStudents: 'Всі учні',
      loading: 'Завантаження...',
      emptyReviews: 'Відгуків поки немає',
      teacherLabel: 'Вчитель: {{name}}',
      averageRating: 'Середній рейтинг',
      totalReviews: 'Всього відгуків',
      allReports: 'Всі звіти',
      thisWeek: 'Цього тижня',
      thisMonth: 'Цього місяця',
      allTeachers: 'Всі вчителі',
      allTypes: 'Всі типи',
      typeIndividual: 'Індивідуальне',
      typeGroup: 'Групове',
      typeClub: 'Заняття клубу',
      typeOther: 'Інше',
      emptyReports: 'Звітів поки немає',
      studentNotSpecified: 'Не вказано',
      moodExcellent: 'Відмінно',
      moodGood: 'Добре',
      moodNeutral: 'Нейтрально',
      presentStudents: 'Присутні учні:',
      lessonTopic: 'Тема уроку:',
      duration: 'Тривалість:',
      studentMood: 'Настрій учня:',
      lessonTopics: 'Теми уроку:',
      homework: 'Домашнє завдання:',
      studentProgress: 'Прогрес учня:',
      nextLessonPlan: 'План на наступний урок:',
      techIssues: 'Технічні проблеми:',
      presentationErrors: 'Помилки в презентації:',
      badgeTechIssue: 'Технічна проблема',
      badgePresentationIssue: 'Помилка в презентації',
      badgeTechAndPresentation: 'Технічні проблеми',
      notes: 'Нотатки:',
      reportsThisMonth: 'Звітів цього місяця',
      reportsOnTime: 'Звіти вчасно',
      reportsWithHomework: 'З домашнім завданням',
      reportsNeedAttention: 'Потребують уваги',
      allTickets: 'Всі звернення',
      ticketOpen: 'Відкриті',
      ticketResolved: 'Вирішені',
      emptyTickets: 'Немає звернень',
      createdOn: 'Створено: {{when}}',
      totalTickets: 'Всього звернень',
      openTickets: 'Відкриті',
      resolvedTickets: 'Вирішені',
      resolutionRate: 'Рівень вирішення',
      statusOpen: 'Відкрито',
      statusResolved: 'Вирішено',
      teacherRoleLabel: 'Вчитель',
      admin: 'Адмін',
      subTabReviews: 'Відгуки учнів',
      subTabReports: 'Звіти вчителів',
      subTabSupport: 'Техпідтримка',
      stars5: '5 зірок',
      stars4: '4 зірки',
      stars3: '3 зірки',
      stars2: '2 зірки',
      stars1: '1 зірка',
      teacherPrefix: 'Вчитель: {{name}}',
      distribution5: '5 зірок ({{percent}}%)',
      distribution4: '4 зірки ({{percent}}%)',
      lowRatings: '≤3 зірки',
      durationMinutes: '{{count}} хв',
      engagementLabel: 'Залученість: {{value}}/5',
      dateAtTime: '{{date}} о {{time}}',
      closeBtn: 'Закрити',
      ticketCreatedOn: 'Створено: {{when}}',
      markResolved: 'Позначити вирішеним',
      reopenTicket: 'Відкрити повторно',
      closeTicket: 'Закрити',
      replyPlaceholder: 'Введіть відповідь...',
      replyHint: 'Enter — надіслати, Shift+Enter — новий рядок',
      senderAdmin: 'Адмін',
    },
    books: {
      titleLabel: 'Назва',
      authorLabel: 'Автор',
      levelLabel: 'Рівень',
      languageLabel: 'Мова',
      publishedYear: 'Рік видання',
      coverLabel: 'Обкладинка (PNG/JPG, ~600×900)',
      genres: 'Жанри',
      genresHint: 'Можна обрати один або кілька жанрів.',
      annotation: 'Анотація (українською)',
      annotationPlaceholder: 'Коротко про що книга...',
      bookText: 'Текст книги',
      uploadTxt: 'Завантажити .txt',
      chaptersFound: 'Знайдено розділів: {{count}}',
      noChapters: 'Без розділів — буде один блок',
      chaptersNotFound: 'Розділи не знайдено',
      textPlaceholder: 'Вставте текст або завантажте .txt файл.\n\nРозділи розпізнаються автоматично, якщо починаються з:\n  CHAPTER I.   або   Chapter 1   (стиль Project Gutenberg)\n  ## Назва     (наш маркер)',
      chapterHint: 'Підтримуються заголовки CHAPTER I, Chapter 1 (Project Gutenberg) і ## Назва. Якщо в тексті немає маркерів — він зберігається як єдиний блок (підходить для коротких творів). Преамбула і ліцензія Project Gutenberg обрізаються автоматично.',
      cancel: 'Скасувати',
      saving: 'Збереження...',
      save: 'Зберегти',
      createBook: 'Створити книгу',
      changesSaved: 'Зміни збережено.',
      createdMessage: 'Книгу створено ({{chapters}} розд., {{words}} слів). Переклад слів обробляється у фоні — це займе кілька хвилин.',
      titleAuthorRequired: 'Заповніть назву і автора.',
      contentRequired: 'Завантажте або вставте текст книги.',
      fileTooLarge: 'Файл занадто великий (максимум 5 МБ).',
      fileReadError: 'Не вдалося прочитати файл.',
      removeCover: 'Видалити обкладинку',
      removeShort: 'Видалити',
      chaptersTitle: 'Текст розділів',
      chaptersHint: 'Розгорніть розділ, щоб виправити друкарську помилку або змінити слово. Нові слова перекладуться у фоні.',
      chaptersLoading: 'Завантаження…',
      chaptersEmpty: 'Розділів не знайдено.',
      unnamedChapter: 'Без назви',
      wordsCount: '{{count}} слів',
      saved: 'Збережено',
      collapse: 'Згорнути',
      edit: 'Редагувати',
      loadingText: 'Завантаження тексту…',
      chapterTitle: 'Назва розділу',
      chapterText: 'Текст розділу',
      saveChapter: 'Зберегти розділ',
      savingChapter: 'Збереження…',
      emptyChapter: 'Текст розділу не може бути порожнім.',
    },
  },
  en: {
    nav: {
      profile: 'Profile',
      overview: 'Overview',
      users: 'Users',
      finance: 'Finance',
      pricing: 'Pricing',
      products: 'Products',
      programs: 'Programs',
      studyPlan: 'Study plan',
      reviews: 'Reviews',
      settings: 'Settings',
      lessons: 'Lessons',
      sessions: 'Sessions',
      teacherLeaves: 'Leave',
      trialForms: 'Trial lessons',
      clubs: 'Clubs',
      courses: 'Courses',
      offers: 'Offers',
      promoCodes: 'Promo codes',
      stickers: 'Stickers',
      books: 'Books',
      kenSkins: 'Ken skins',
      chat: 'Chat',
      aiLesson: 'AI lesson',
      more: 'More',
      readerTitle: 'Reader — reading application',
    },
    aiLesson: {
      title: 'AI settings',
      description: 'Pick presentations and slides the AI should always use as style references. You won\'t have to re-select them on every generation.',
      templatesHeading: 'Reference templates',
      empty: 'No templates yet.',
      add: 'Add template',
      save: 'Save',
      delete: 'Delete',
      confirmDelete: 'Delete this template?',
      loadError: 'Failed to load templates',
      saveError: 'Failed to save template',
      deleteError: 'Failed to delete template',
    },
    overview: {
      students: 'Students',
      teachers: 'Teachers',
      admins: 'Admins',
      lessonsHeld: 'Lessons held',
      revenue: 'Revenue',
      thisMonth: '+{{count}} this month',
      revenueThisMonth: '+{{amount}} this month',
      loadError: 'Loading error',
      birthdays: 'Birthdays',
      birthdayToday: 'Today',
      birthdayTomorrow: 'Tomorrow',
      birthdayIntro: 'is the birthday of',
      promoCode: 'Promo code',
      promoCodeMeta: '(1 club lesson, 60 days)',
      kenSkin: 'Ken skin',
      bundlePending: 'The gift bundle will be sent by the next hourly scheduler run.',
      recentActivity: 'Recent activity',
      activityLoadError: 'Failed to load activity: {{error}}',
      loading: 'Loading…',
      noActivity: 'No activity yet',
      records: 'records',
      record: 'record',
      justNow: 'just now',
      minutesAgo: '{{count}} min ago',
      hoursAgo: '{{count}} h ago',
      daysAgo: '{{count}} d ago',
    },
    profileTab: {
      title: 'My profile',
      personalInfo: 'Personal information',
      permissions: 'My permissions',
      superAdmin: 'Super administrator',
      superAdminDesc: 'Full access to all platform features',
      noPermissions: 'No permissions assigned',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'New password must be at least 8 characters',
      passwordChangeError: 'Error changing password',
      connectionError: 'Connection error',
      passwordChanged: 'Password changed successfully',
      submitPassword: 'Change password',
      timezone: 'Timezone',
      saved: 'Saved',
      timezoneHelp: 'This timezone is used to display schedules and event times.',
      theme: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      themeHelp: 'The theme choice is saved only in this browser.',
      email: 'Email',
      nickname: 'Nickname',
      telegramTitle: 'Telegram notifications',
      telegramHelp: 'Receive Telegram alerts for events from the admin-panel tabs you have access to.',
      telegramConnect: 'Connect Telegram',
      telegramConnected: 'Telegram connected',
      telegramDisconnect: 'Disconnect',
      telegramOpenLink: 'Open bot in Telegram',
      telegramLinkHint: 'Link is valid for 15 min. Open it on a device with Telegram and press Start.',
      telegramError: 'Request failed',
    },
    settingsTab: {
      title: 'System settings',
      general: 'General settings',
      registration: 'New user registration',
      moderation: 'Content moderation',
      emailNotifications: 'Email notifications',
      enabled: 'Enabled',
      disabled: 'Disabled',
      platformTimezone: 'Platform timezone',
      platformTimezoneHelp: 'This timezone is used to display times in reviews, reports, and support tickets',
      timezoneSearchPlaceholder: 'Search country or city...',
      timezoneNotFound: 'Timezone not found',
      bankRequisites: 'Payment details',
      bankRequisitesHelp: 'Students will see these details when topping up their balance',
      cardNumber: 'Card number',
      cardholderName: 'Cardholder name (Latin)',
      bankName: 'Bank name',
      bankNamePlaceholder: 'PrivatBank / Monobank',
      additionalInfo: 'Additional information',
      additionalInfoPlaceholder: 'Payment purpose, notes for students...',
      saveRequisites: 'Save details',
      integrations: 'Integrations',
      livekit: 'LiveKit (video calls)',
      apiKeyConfigured: 'API key configured',
      stripe: 'Stripe (payments)',
      notConfigured: 'Not configured',
      configure: 'Configure',
      saveChanges: 'Save changes',
    },
    matchingWeights: {
      title: 'Program matching weights',
      help: 'Weights (in %) for automatic program matching for students. Sum must equal 100.',
      sum: 'Sum: {{sum}}%',
      sumError: 'Sum of weights must equal 100 (currently {{sum}})',
      saveError: 'Failed to save',
      saveWeights: 'Save weights',
      weightLevel: 'Level',
      weightAge: 'Age',
      weightTopics: 'Topics',
      weightLearningGoal: 'Learning goal',
      weightFrequency: 'Frequency',
      weightEnglishType: 'English type',
    },
    homework: {
      title: 'Homework',
      subtitle: 'Create interactive assignments and attach them to lessons',
      createButton: 'Create assignment',
      loading: 'Loading homework...',
      exercisesCount: '{{count}} exercises',
      points: 'Points: {{count}}',
      words: 'Words: {{count}}',
      updated: 'Updated: {{date}}',
      previewAsStudent: 'Preview as student',
      edit: 'Edit',
      delete: 'Delete',
      deleteTitle: 'Delete assignment?',
      deleteMessage: 'Delete this homework assignment?',
      empty: 'No homework',
      emptyDesc: 'Create your first interactive assignment for students',
    },
    repetitionGames: {
      title: 'Repetition games',
      subtitle: 'Create game-based exercises to review covered material',
      createButton: 'Add game',
      empty: 'No repetition games yet',
      emptyDesc: 'Click "Add game" to create your first one',
      preview: 'Preview',
      bind: 'Attach to lesson',
      unbind: 'Detach',
      bindTitle: 'Attach game to lessons',
      bindNoPrograms: 'No programs available to attach to',
      boundToCount_one: 'in {{count}} lesson',
      boundToCount_other: 'in {{count}} lessons',
    },
    moduleTests: {
      title: 'Module tests',
      subtitle: 'Create final tests for program modules to verify material mastery',
      createButton: 'Create test',
      loading: 'Loading module tests...',
      exercises: '{{count}} tasks',
      points: 'Points: {{count}}',
      passingScore: 'Passing: {{score}}%',
      timeLimit: 'Time: {{minutes}} min',
      updated: 'Updated: {{date}}',
      previewAsStudent: 'Preview as student',
      deleteTitle: 'Delete test?',
      deleteMessage: 'Delete this module test? This action cannot be undone.',
      empty: 'No module tests',
      emptyDesc: 'Create the first final test for a program module',
    },
    programs: {
      subTabs: {
        programs: 'Programs',
        presentations: 'Presentations',
        homework: 'Homework',
        repetitionGames: 'Repetition games',
        moduleTests: 'Module test',
      },
      title: 'Study programs',
      subtitle: 'Create programs with sequential lessons for students',
      createButton: 'Create program',
      copySuffix: '(copy)',
      moduleAndLessonCount: '{{modules}} modules · {{lessons}} lessons',
      duplicate: 'Duplicate',
      deleteTitle: 'Delete program?',
      deleteMessage: 'Delete this program? Existing assignments will not be affected.',
      deleteErrorTitle: 'Failed to delete program',
      deleteErrorMessage: 'Unknown error. The program may be referenced by scheduled lessons or other records.',
      empty: 'No programs',
      emptyDesc: 'Create your first study program for students',
    },
    stickersAndFrames: {
      stickers: 'Stickers',
      frames: 'Frames',
      photos: 'Photos',
    },
    imageCropper: {
      size: 'Size: {{w}} × {{h}} px',
      loading: 'Loading...',
      reset: 'Reset',
      cancel: 'Cancel',
      apply: 'Apply',
      cropFailed: 'Failed to crop the image. Try reloading the file.',
    },
    stickers: {
      title: 'Stickers',
      subtitle: 'Manage stickers for the presentation editor',
      addSticker: 'Add sticker',
      newSticker: 'New sticker',
      editSticker: 'Edit sticker',
      imageLabel: 'Sticker image',
      dropRelease: 'Release to upload',
      dropPrompt: 'Drag or click',
      allowedTypes: 'PNG, GIF, WebP (up to 5MB)',
      crop: 'Crop',
      stickerName: 'Sticker name',
      stickerNamePlaceholder: 'For example: Pizza',
      tags: 'Search tags',
      tagPlaceholder: 'Enter a tag and press Enter',
      tagHelp: 'Add several tags in different languages for better search (pizza, піца, food)',
      searchPlaceholder: 'Search by name or tag...',
      allStickers: 'All stickers ({{count}})',
      foundStickers: 'Found ({{count}})',
      empty: 'No stickers',
      emptyHint: 'Click "Add sticker" to create the first one',
      noSearchResults: 'Nothing found',
      noSearchResultsHint: 'Try a different search query',
      loadError: 'Failed to load stickers',
      formatError: 'Allowed formats: JPEG, PNG, GIF, WebP',
      sizeError: 'Maximum file size: 5MB',
      nameRequired: 'Enter a sticker name',
      imageRequired: 'Upload a sticker image',
      tagRequired: 'Add at least one search tag',
      created: 'Sticker created',
      updated: 'Sticker updated',
      deleted: 'Sticker deleted',
      saveError: 'Failed to save sticker',
      deleteError: 'Failed to delete sticker',
      deleteTitle: 'Delete sticker?',
      deleteMessage: 'Are you sure you want to delete the sticker "{{name}}"?',
    },
    frames: {
      title: 'Frames',
      subtitle: 'Decorative frames (phone, TV, tablet) for the presentation editor. Photos or videos can be placed inside.',
      addFrame: 'Add frame',
      newFrame: 'New frame',
      editFrame: 'Edit frame',
      imageLabel: 'Frame image (SVG with a transparent screen area)',
      dropRelease: 'Release to upload',
      dropPrompt: 'Drag or click',
      allowedTypes: 'SVG, PNG, WebP (up to 5MB)',
      crop: 'Crop',
      previewHelp: 'The red rectangle shows where the video/photo will be. Adjust the numbers on the right.',
      frameName: 'Frame name',
      frameNamePlaceholder: 'For example: iPhone',
      screenAreaLabel: 'Screen area (% of frame size)',
      xLeft: 'X (left)',
      yTop: 'Y (top)',
      width: 'Width',
      height: 'Height',
      radius: 'Radius',
      defaultsNote: 'Default for a typical smartphone: X=8, Y=6, W=84, H=88, R=6',
      allFrames: 'All frames ({{count}})',
      screenSize: 'screen {{width}}×{{height}}%',
      empty: 'No frames',
      emptyHint: 'Click "Add frame" to create the first one',
      loadError: 'Failed to load frames',
      nameRequired: 'Enter a frame name',
      imageRequired: 'Upload a frame image',
      formatError: 'Allowed formats: SVG, PNG, WebP, JPEG',
      sizeError: 'Maximum file size: 5MB',
      created: 'Frame created',
      updated: 'Frame updated',
      deleted: 'Frame deleted',
      saveError: 'Failed to save frame',
      deleteError: 'Failed to delete frame',
      deleteTitle: 'Delete frame?',
      deleteMessage: 'Are you sure you want to delete the frame "{{name}}"?',
      success: 'Success',
      shapeLabel: 'Screen shape',
      shapeRect: 'Rectangle',
      shapePerspective: 'Perspective (4 corners)',
      shapeHelp: 'Perspective is for frames drawn at an angle (e.g. a photo frame on a stand).',
      cornersHint: 'Drag the corner points on the preview so the photo fits exactly inside the frame.',
      cornerTL: 'Top-left',
      cornerTR: 'Top-right',
      cornerBR: 'Bottom-right',
      cornerBL: 'Bottom-left',
    },
    photos: {
      title: 'Photos',
      subtitle: 'Manage photos for the presentation editor',
      addPhoto: 'Add photo',
      newPhoto: 'New photo',
      editPhoto: 'Edit photo',
      imageLabel: 'Photo image',
      dropRelease: 'Release to upload',
      dropPrompt: 'Drag or click',
      allowedTypes: 'PNG, GIF, WebP, JPEG (up to 5MB)',
      crop: 'Crop',
      photoName: 'Photo name',
      photoNamePlaceholder: 'For example: Pizza',
      tags: 'Search tags',
      tagPlaceholder: 'Enter a tag and press Enter',
      tagHelp: 'Add several tags in different languages for better search (pizza, піца, food)',
      searchPlaceholder: 'Search by name or tag...',
      allPhotos: 'All photos ({{count}})',
      foundPhotos: 'Found ({{count}})',
      empty: 'No photos',
      emptyHint: 'Click "Add photo" to create the first one',
      noSearchResults: 'Nothing found',
      noSearchResultsHint: 'Try a different search query',
      loadError: 'Failed to load photos',
      formatError: 'Allowed formats: JPEG, PNG, GIF, WebP',
      sizeError: 'Maximum file size: 5MB',
      nameRequired: 'Enter a photo name',
      imageRequired: 'Upload a photo image',
      tagRequired: 'Add at least one search tag',
      created: 'Photo created',
      updated: 'Photo updated',
      deleted: 'Photo deleted',
      saveError: 'Failed to save photo',
      deleteError: 'Failed to delete photo',
      deleteTitle: 'Delete photo?',
      deleteMessage: 'Are you sure you want to delete the photo "{{name}}"?',
    },
    addAdmin: {
      title: 'Add administrator',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      firstNamePlaceholder: 'Alex',
      lastNamePlaceholder: 'Smith',
      emailPlaceholder: 'admin@example.com',
      phonePlaceholder: '+1 555 123 4567',
      permissions: 'Permissions',
      selectAll: 'Select all',
      clearAll: 'Clear',
      pickAtLeastOne: 'Pick at least one permission',
      info: '* After saving, the administrator will receive an email with a registration code, which they will use to create the account.',
      saveAndSend: 'Save and send',
      saving: 'Saving...',
      createError: 'Error creating invitation',
      invitationSent: 'Invitation sent!',
      emailSentTo: 'A registration code email has been sent to:',
      registrationCodeNote: 'Registration code (SMTP not configured):',
      assignedPermissions: 'Assigned permissions:',
    },
    addTeacher: {
      title: 'Add teacher',
      firstName: 'First name',
      lastName: 'Last name',
      firstNamePlaceholder: 'Maria',
      lastNamePlaceholder: 'Smith',
      emailPlaceholder: 'teacher@example.com',
      phonePlaceholder: '+1 555 123 4567',
      info: '* After saving, the teacher will receive an email with a registration code, which they will use to create the account.',
      sessionExpired: 'Your session has expired. Please reload the page and sign in again.',
      refreshPage: 'Reload page',
    },
    grantStars: {
      title: 'Grant stars',
      user: 'User',
      childBadge: 'child',
      starsCount: 'Number of stars',
      messageOptional: 'Message (optional)',
      messagePlaceholder: 'Message for the user...',
      searchPlaceholder: 'Search by name, nickname, or email...',
      nothingFound: 'Nothing found',
      noStudents: 'No students',
      submit: 'Grant stars',
      submitting: 'Granting...',
      error: 'Error granting stars',
      connectionError: 'Server connection error',
      successTitle: 'Stars granted!',
      newBalance: 'New balance: {{count}} stars',
      currentStars: 'Stars: {{count}}',
      currentStarsLoading: 'Stars: ...',
    },
    deductStars: {
      title: 'Deduct stars',
      submit: 'Deduct stars',
      submitting: 'Deducting...',
      error: 'Error deducting stars',
      successTitle: 'Stars deducted!',
    },
    tabs: {
      booksTitle: 'Books',
      booksSubtitle: 'Reader app library',
      booksRefresh: 'Refresh',
      booksAdd: 'Add book',
      booksEmpty: 'No books yet. Click "Add book" to start.',
      booksDeleteConfirm: 'Delete book?',
      booksRetranslateConfirm: 'Re-translate all words of the book "{{title}}"? This will take a few minutes.',
      booksDict: 'Book dictionary',
      booksRetranslate: 'Re-translate',
      booksColCover: 'Cover',
      booksColTitle: 'Title / Author',
      booksColLevel: 'Level',
      booksColGenre: 'Genre',
      booksColChapters: 'Chapters',
      booksColWords: 'Words',
      booksColStatus: 'Status',
      booksColActions: 'Actions',
      booksAddModal: 'Add book',
      booksEditModal: 'Edit book',
      booksStatusPending: 'Pending',
      booksStatusProcessing: 'Processing',
      booksStatusReady: 'Ready',
      booksStatusFailed: 'Failed',
      clubsScheduled: 'Scheduled clubs',
      clubsHistory: 'Club history',
      clubsPricing: 'Club pricing',
      clubsActiveSubscriptions: 'Active subscriptions ({{count}})',
      clubsBookings: 'Club bookings ({{count}})',
      clubsPresentations: 'Presentations for clubs',
      clubsUploadPresentation: 'Upload presentation',
      coursesTitle: 'Courses',
      coursesEmpty: 'No courses yet',
      coursesStartTest: 'Placement test',
      coursesStudentView: 'What the student sees',
      coursesProgressTable: 'Progress table',
      coursesYourProgress: 'Your progress',
      coursesMaterials: 'Course materials',
      coursesAddQuestions: 'Add questions to the test',
      coursesExercise: 'Exercise',
      coursesNotes: 'Notes',
      coursesVideo: 'Video',
      financeTopups: 'Balance top-ups',
      financeReceipt: 'Receipt',
      financeDecline: 'Payment decline',
      financePayouts: 'Teacher payroll',
      financePayoutTitle: 'Payout',
      financeIncome: 'Income and transactions',
      financeByServiceType: 'Charges by service type',
      financeTransactionHistory: 'Transaction history',
      financePenaltyList: 'Penalty list',
      financeTopFined: 'Teachers with the largest penalty amount',
      financeCancelPenalty: 'Cancel penalty?',
      kenSkinsTitle: 'Ken skins',
      kenSkinsEdit: 'Edit skin',
      kenSkinsNew: 'New skin',
      pricingTitle: 'Prices and rates',
      lessonsTitle: 'Lessons',
      lessonsScheduled: 'Scheduled lessons',
      lessonsHistory: 'Lesson history',
      lessonsSpecial: 'Special lessons',
      penaltiesTitle: 'Penalties',
      presentationsTitle: 'Presentations',
      presentationsCreate: 'Create presentation',
      productsTitle: 'Products',
      promoCodesTitle: 'Promo codes',
      reviewsTitle: 'Reviews and support',
      scheduleTitle: 'Schedule',
      specialLessonsTitle: 'Special lessons',
      specialOffersTitle: 'Special offers',
      teacherLeavesTitle: 'Teacher leave',
      paymentsTitle: 'Payments',
      bookDictionary: 'Book dictionary',
      replenishTitle: 'Replenish balance',
      deductTitle: 'Deduct from balance',
      replenishSuccess: 'Balance topped up!',
      deductSuccess: 'Balance deducted!',
      currencyUnit: 'UAH',
      newBalanceUah: 'New balance: {{amount}} UAH',
      amount: 'Amount (UAH)',
      amountPlaceholder: '100',
      messageOptional: 'Message (optional)',
      messagePlaceholder: 'Message for the user...',
      messageHelp: 'This message will appear as a pop-up for the user',
      replenishSubmit: 'Replenish balance',
      replenishSubmitting: 'Topping up...',
      deductSubmit: 'Deduct from balance',
      deductSubmitting: 'Deducting...',
      replenishError: 'Error topping up balance',
      deductError: 'Error deducting balance',
      balance: 'Balance',
      insufficientTitle: 'Insufficient balance',
      insufficientCurrent: 'Current balance: {{amount}} UAH.',
      insufficientAfter: 'After deduction it will be {{amount}} UAH (negative).',
      insufficientPrompt: 'Deduct anyway?',
      insufficientConfirm: 'Confirm',
    },
    users: {
      title: 'Platform users',
      searchPlaceholder: 'Search by name, email...',
      subTabs: {
        students: 'Students',
        teachers: 'Teachers',
        admins: 'Admins',
      },
      showArchived: 'Show archived',
      studentsRegistered: 'Registered students ({{count}})',
      telegramConnected: 'Telegram connected',
      studentsRegisteredFiltered: 'Registered students ({{filtered}} of {{total}})',
      teachersRegistered: 'Registered teachers ({{count}})',
      teachersRegisteredFiltered: 'Registered teachers ({{filtered}} of {{total}})',
      adminsRegistered: 'Registered administrators ({{count}})',
      adminsRegisteredFiltered: 'Registered administrators ({{filtered}} of {{total}})',
      addTeacher: '+ Add teacher',
      addAdmin: '+ Add administrator',
      loadingInvitations: 'Loading invitations...',
      pendingRegistration: 'Pending registration ({{count}})',
      colName: 'Name',
      colNickname: 'Nickname',
      colEmail: 'Email',
      colType: 'Type',
      colBalance: 'Balance',
      colStars: 'Stars',
      colLessons: 'Lessons',
      colStatus: 'Status',
      colActions: 'Actions',
      colPhone: 'Phone',
      colLevel: 'Level',
      colAuthor: 'Method author',
      colPermissions: 'Permissions',
      colTimeLeft: 'Time left',
      accountChild: 'Child',
      accountAdult: 'Adult',
      statusArchived: 'Archived',
      statusVerified: 'Verified',
      statusUnverified: 'Unverified',
      statusActive: 'Active',
      unarchive: 'Unarchive',
      archive: 'Archive',
      viewSchedule: 'View schedule',
      deleteUnverified: 'Delete unfinished registration',
      resend: 'Resend',
      cancelInvite: 'Cancel invitation',
      authorMethodBadge: 'Method author',
      pricePlaceholder: 'Price',
      priceTitle: 'Individual lesson price (UAH)',
      priceCurrency: 'UAH',
      priceValidation: 'Enter a valid individual lesson price',
      superBadge: 'Super',
      fullAccess: 'Full access',
      lessThanHour: 'less than an hour',
      dayShort: '{{count}} d.',
      hourShort: '{{count}} h.',
      studentsNotFound: 'No students found',
      teachersNotFound: 'No teachers found',
      adminsNotFound: 'No administrators found',
      studentsNotFoundQuery: 'No students found for query "{{query}}"',
      teachersNotFoundQuery: 'No teachers found for query "{{query}}"',
      adminsNotFoundQuery: 'No administrators found for query "{{query}}"',
      cancelInviteTitle: 'Cancel invitation?',
      cancelInviteMessage: 'Are you sure you want to cancel the invitation for {{name}} ({{email}})? The registration code will become invalid.',
      cancelInviteConfirm: 'Cancel invitation',
      cancelInviteBack: 'No, keep it',
      deleteUnverifiedTitle: 'Delete unfinished registration?',
      deleteUnverifiedMessage: 'Delete the entry "{{name}}" ({{email}})? The user has not confirmed their email. This action cannot be undone.',
      deleteUnverifiedConfirm: 'Delete',
      balanceUnit: 'UAH',
      report: {
        title: 'Student report',
        download: 'Download report',
        forStudent: 'Report for: {{name}}',
        presets: 'Quick presets',
        presetThisMonth: 'This month',
        presetLastMonth: 'Last month',
        presetLast3: 'Last 3 months',
        presetLast6: 'Last 6 months',
        presetAllTime: 'All time',
        startDate: 'From',
        endDate: 'To',
        language: 'Report language',
        languageUk: 'Ukrainian',
        languageEn: 'English',
        generating: 'Generating...',
        errorDates: 'Please pick valid dates',
        errorOrder: '"From" date must be before "To"',
        errorGenerate: 'Failed to generate the report. Please try again.',
      },
      freeze: {
        autoFrozenBadge: 'Frozen',
        autoFrozenTooltip: 'Learning auto-frozen after 3 consecutive lessons were cancelled for insufficient balance.',
        unfreezeAction: 'Unfreeze learning',
        unfreezeTitle: 'Unfreeze learning?',
        unfreezeMessage: 'Unfreeze learning for "{{name}}"? All frozen lessons will be removed — the student will need to pick a new schedule.',
        unfreezeConfirm: 'Unfreeze',
        unfreezeFailed: 'Failed to unfreeze. Please try again.',
      },
    },
    teacherSchedule: {
      title: 'Teacher schedule',
      close: 'Close',
      prevDay: 'Previous day',
      nextDay: 'Next day',
      pastDate: 'Past date',
      customSchedule: 'Custom schedule for this date',
      legendAvailable: 'Non-working',
      legendWorking: 'Working hours',
      legendBusy: 'Busy',
      legendPast: 'Past',
      tooltipBusyWith: 'Busy with {{name}}',
      daySunday: 'Sunday',
      dayMonday: 'Monday',
      dayTuesday: 'Tuesday',
      dayWednesday: 'Wednesday',
      dayThursday: 'Thursday',
      dayFriday: 'Friday',
      daySaturday: 'Saturday',
      monJan: 'Jan',
      monFeb: 'Feb',
      monMar: 'Mar',
      monApr: 'Apr',
      monMay: 'May',
      monJun: 'Jun',
      monJul: 'Jul',
      monAug: 'Aug',
      monSep: 'Sep',
      monOct: 'Oct',
      monNov: 'Nov',
      monDec: 'Dec',
    },
    common: {
      configuring: 'Configuring…',
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      saved: 'Saved',
      edit: 'Edit',
      delete: 'Delete',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
    },
    lessons: {
      daysOfWeek: {
        long: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        short: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      },
    },
    specialLessons: {
      subTabCategories: 'Categories',
      subTabPrograms: 'Assign to programs',
      subTabRepetition: 'Repetition lessons',
      errorTitle: 'Error',
      successTitle: 'Success',
      categoryRequired: 'Category name is required',
      categoryUpdated: 'Category updated',
      categoryCreated: 'Category created',
      sub: {
        categories: {
          addBtn: 'Add category',
          editTitle: 'Edit category',
          newTitle: 'New category',
          nameEnLabel: 'Name (EN)',
          nameEnPlaceholder: 'Birthday',
          nameUkLabel: 'Name (UA)',
          nameUkPlaceholder: 'День народження',
          iconLabel: 'Icon',
          iconNone: 'No icon',
          sortOrderLabel: 'Sort order',
          descriptionLabel: 'Description',
          descriptionPlaceholder: 'Category description...',
          save: 'Save',
          cancel: 'Cancel',
          empty: 'No categories yet. Add the first one!',
          statusActive: 'Active',
          statusInactive: 'Inactive',
          confirmDeleteTitle: 'Delete category?',
          confirmDeleteMessage: 'Are you sure you want to delete the category "{{name}}"?',
          deletedSuccess: 'Category deleted',
          iconLabels: {
            cake: 'Cake',
            ghost: 'Ghost',
            gift: 'Gift',
            egg: 'Egg',
            sparkles: 'Sparkles',
            heart: 'Heart',
            star: 'Star',
            tree: 'Tree',
            sun: 'Sun',
            snowflake: 'Snowflake',
          },
        },
        programs: {
          heading: 'Special lessons for programs',
          selectProgramLabel: 'Choose a program',
          selectProgramPlaceholder: '-- Choose a program --',
          noLevel: 'No level',
          addBtn: 'Add special lesson',
          formTitle: 'Add special lesson',
          presentationLabel: 'Presentation (type=special)',
          selectPresentationPlaceholder: '-- Choose a presentation --',
          slidesCount: '{{count}} slides',
          noSpecialPresentations: 'No presentations with type "special". Create them in the presentation editor.',
          categoryLabel: 'Category',
          selectCategoryPlaceholder: '-- Choose a category --',
          homeworkLabel: 'Homework (optional)',
          noHomework: '-- No homework --',
          titleLabel: 'Title (optional)',
          titlePlaceholder: 'Presentation title will be used if not specified',
          add: 'Add',
          cancel: 'Cancel',
          empty: 'No special lessons have been added to this program yet.',
          homeworkPrefix: 'HW',
          selectRequired: 'Choose a presentation and a category',
          addSuccess: 'Special lesson added to program',
          confirmRemoveTitle: 'Remove assignment?',
          confirmRemoveMessage: 'Are you sure you want to remove "{{title}}" from this program?',
          removeSuccess: 'Assignment removed',
        },
        repetition: {
          heading: 'Repetition lessons for programs',
          intro: 'Repetition lessons let the teacher assign a lesson to review material instead of the regular lesson. All subsequent lessons shift, and the skipped lesson is moved to the end.',
          selectProgramLabel: 'Choose a program',
          selectProgramPlaceholder: '-- Choose a program --',
          noLevel: 'No level',
          addBtn: 'Add repetition lesson',
          formTitle: 'Add repetition lesson',
          presentationLabel: 'Presentation',
          selectPresentationPlaceholder: '-- Choose a presentation --',
          slidesCount: '{{count}} slides',
          noPresentations: 'No presentations available.',
          titleLabel: 'Title (optional)',
          titlePlaceholder: 'Presentation title will be used if not specified',
          homeworkLabel: 'Homework (optional)',
          noHomework: '-- No homework --',
          add: 'Add',
          cancel: 'Cancel',
          empty: 'No repetition lessons have been added to this program yet.',
          homeworkPrefix: 'HW',
          selectRequired: 'Choose a presentation',
          addSuccess: 'Repetition lesson added to program',
          confirmRemoveTitle: 'Remove assignment?',
          confirmRemoveMessage: 'Are you sure you want to remove "{{title}}" from the repetition lessons?',
          removeSuccess: 'Assignment removed',
        },
      },
    },
    presentations: {
      requestEditTitle: 'Request edit access',
      requestPresentation: 'Presentation:',
      requestHelp: 'The teacher will get a notification and choose how long to grant access.',
      requestMessagePlaceholder: 'Explain why access is needed (optional)',
      cancel: 'Cancel',
      sendRequest: 'Send request',
      sendError: 'Failed to send request',
      newBase: 'New presentation',
      copySuffix: '(copy)',
      duplicateSuffix: '(duplicate)',
      loadError: 'Failed to load presentation',
      upload: 'Upload',
      create: 'Create',
      slidesCount: '{{count}} slides',
      updated: 'Updated: {{when}}',
      deletedByTeacher: 'Deleted by teacher',
      deletedByTeacherOn: 'Deleted {{when}}',
      accessUntil: 'Access until {{when}}',
      accessPermanent: 'Permanent access',
      save: 'Save',
      rename: 'Rename',
      needAccess: 'Another teacher\'s presentation — access needed',
      edit: 'Edit',
      awaiting: 'Waiting',
      requestAccessTooltip: 'Request edit access',
      access: 'Access',
      preview: 'Preview',
      loadingList: 'Loading presentations...',
      emptyTitle: 'No presentations',
      emptyDesc: 'Create your first presentation',
      deleteTitle: 'Delete presentation?',
      deleteMessage: 'Are you sure you want to delete this presentation?',
      uploadTitle: 'Upload presentation',
      uploadHelp: 'Upload a PDF file or export a presentation from Canva/PowerPoint as images. Each PDF page or image becomes a separate slide.',
      nameLabel: 'Presentation name',
      namePlaceholder: 'Uploaded presentation',
      slidesImages: 'Slide images',
      dropHere: 'Drop files here',
      selectedCount: '{{count}} files selected',
      moreFiles: 'and {{count}} more...',
      dragOrClick: 'Drag files here or click to select',
      allowedTypes: 'PDF, PNG, JPG, WebP (up to 50MB for PDF)',
      selectFilesError: 'Select files to upload',
      defaultTitle: 'Uploaded presentation',
      uploadError: 'Upload error',
      uploadPresentationError: 'Presentation upload error',
      uploading: 'Uploading...',
      searchPlaceholder: 'Search by presentation name...',
      noSearchResults: 'No presentations match your search',
      loadMore: 'Load more',
      loadingMore: 'Loading...',
      shownOfTotal: 'Showing {{shown}} of {{total}}',
      loadListError: 'Failed to load presentations',
      loadListErrorHint: 'Check your connection and try again',
      retry: 'Try again',
    },
    promoCodes: {
      usageOncePerUser: 'Once per user',
      usageSingleUse: 'Single use total',
      rewardBalance: 'Balance',
      rewardFreeLessons: 'Free lessons',
      rewardClubLessons: 'Free club',
      subtitle: 'Free lessons for students',
      createBtn: 'Create promo code',
      searchPlaceholder: 'Search by code…',
      onlyActive: 'Active only',
      colCode: 'Code',
      colLessons: 'Lessons',
      colType: 'Type',
      colRedemptions: 'Redemptions',
      colExpires: 'Expires',
      colCreated: 'Created',
      colStatus: 'Status',
      colActions: 'Actions',
      loading: 'Loading…',
      empty: 'No promo codes',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      delete: 'Delete',
      deactivate: 'Deactivate',
      deleteTitle: 'Delete promo code?',
      deactivateTitle: 'Deactivate promo code?',
      deleteConfirmUsed: 'Promo code {{code}} has been used ({{count}}). It will be deactivated, not deleted.',
      deleteConfirm: 'Are you sure you want to delete promo code {{code}}?',
      deleteError: 'Delete error',
      updateError: 'Update error',
      paginationRange: '{{from}}–{{to}} of {{total}}',
      back: 'Back',
      next: 'Next',
      createTitle: 'Create promo code',
      codeLabel: 'Code',
      generate: 'Generate',
      lessonsCount: 'Lessons count',
      rewardTypeLabel: 'Reward type',
      rewardBalanceTitle: 'Balance credit',
      rewardBalanceDesc: 'Credits N × lesson price UAH to balance. Can be spent on anything (lessons, shop, subscriptions).',
      rewardFreeLessonsTitle: 'Free lessons',
      rewardFreeLessonsDesc: 'Grants N free lessons — the next N lessons will be charged automatically without money on balance.',
      rewardClubLessonsTitle: 'Free club lessons',
      rewardClubLessonsDesc: 'Grants N free club lessons — the next N club sessions will be charged automatically without money on balance.',
      usageTypeLabel: 'Usage type',
      usageOncePerUserTitle: 'Once per user',
      usageOncePerUserDesc: 'Each user can redeem this code only once',
      usageSingleUseTitle: 'Single use total',
      usageSingleUseDesc: 'Only the first person to enter the code gets the bonus',
      validUntilLabel: 'Valid until',
      validUntilHint: '(optional)',
      validityForever: 'Forever',
      validityRange: 'Limited period',
      validFromLabel: 'Valid from',
      validToLabel: 'Valid until',
      validRangeError: 'Start date must be earlier than end date',
      descriptionLabel: 'Description',
      descriptionHint: '(for admin)',
      descriptionPlaceholder: 'For example: summer campaign 2026',
      cancel: 'Cancel',
      creating: 'Creating…',
      create: 'Create',
      codeMinError: 'Code must be at least 3 characters',
      lessonsMinError: 'Lessons count must be ≥ 1',
      createError: 'Create error',
      redemptionsTitle: 'Redemptions',
      redemptionsLoading: 'Loading…',
      redemptionsEmpty: 'No redemptions yet',
      redemptionUser: 'User',
      redemptionLessons: 'Lessons',
      redemptionAmount: 'Amount',
      redemptionDate: 'Date',
    },
    kenSkins: {
      subtitle: 'Avatar parts catalog. Manage what a child can unlock for free, and what for stars, money, or by task.',
      addSkin: 'Add skin',
      loading: 'Loading…',
      emptyCategory: 'No skins in this category',
      unlockFree: 'Free',
      unlockPoints: 'For stars',
      unlockMoney: 'For money',
      unlockTask: 'By task',
      unlockTaskShort: 'Task',
      stars: '{{count}} stars',
      uah: '{{count}} UAH',
      edit: 'Edit',
      delete: 'Delete',
      categoryLabel: 'Category',
      assetKeyLabel: 'Asset key',
      assetKeyHint: '(PNG file)',
      nameUkLabel: 'Name (UA)',
      descriptionLabel: 'Description',
      unlockLabel: 'How to unlock',
      pricePointsLabel: 'Price in stars',
      priceUahLabel: 'Price in UAH',
      taskTypeLabel: 'Task type',
      taskParamsLabel: 'Parameters',
      taskParamsHint: '(JSON, e.g. {"book_id":5})',
      taskDescLabel: 'Description for the child',
      taskDescHint: '(what to do)',
      taskDescPlaceholder: 'Read the book "Harry Potter"',
      previewTitle: 'Wardrobe preview',
      previewHint: 'Tile crop in the customizer. Empty fields = category default ({{scale}}× · Y {{offsetY}}%).',
      previewNeedAsset: 'set asset_key',
      tileImageLabel: 'Wardrobe image',
      tileImageHint: 'How the skin looks in the picker grid. If not set — falls back to the file at asset_key.',
      overlayImageLabel: 'On-Ken image',
      overlayImageHint: 'How the skin layers on the kangaroo. If not set — falls back to the file at asset_key.',
      uploadImage: 'Upload',
      uploading: 'Uploading…',
      removeImage: 'Remove',
      uploadError: 'Failed to upload image',
      zoom: 'Zoom (×)',
      offsetX: 'Offset X (%)',
      offsetY: 'Offset Y (%)',
      sortOrder: 'Sort order',
      activeLabel: 'Active (visible in the customizer)',
      cancel: 'Cancel',
      save: 'Save',
      taskManual: 'Manually granted by admin',
      taskReadBook: 'Read a book',
      taskJoinClub: 'Join a club',
      taskShop: 'Buy an item in the shop',
      taskTest: 'Pass a test',
      taskInvite: 'Invite a friend',
      errorTitle: 'Error',
      loadError: 'Failed to load skins',
      formValidation: 'Fill in asset_key and name',
      jsonInvalid: 'task_config must be valid JSON',
      saveError: 'Save error',
      saveFail: 'Failed to save',
      deleteTitle: 'Delete skin?',
      deleteMessage: 'Delete "{{name}}"? Students who already unlocked it will lose access.',
      deleteFail: 'Failed to delete',
    },
    pricing: {
      loadError: 'Failed to load settings',
      loadErrorPage: 'Failed to load current prices. Try refreshing the page.',
      saveError: 'Failed to save',
      saveErrorGeneric: 'Failed to save change',
      validationBadNumber: '"{{label}}": enter a valid number (≥ 0)',
      validationMax: '"{{label}}": maximum {{max}}',
      validationMin: '"{{label}}": minimum {{min}}',
      description: 'Changes take effect immediately for all new purchases and bookings. Prices in existing subscriptions and already-paid lessons are not recalculated.',
      matrixColLessonType: 'Lesson type',
      matrixHint: 'Hint: Intern is a trial period (the first lesson is free). Usually 0 is set for it, and higher levels increase progressively.',
      saved: 'Saved',
      save: 'Save',
      saveRow: 'Save row',
      saving: 'Saving...',
      currency: 'UAH',
      units: {
        uah: 'UAH',
        percent: '%',
        days: 'days',
      },
      sections: {
        lessons: {
          title: 'Lessons',
          description: 'Base lesson prices (UAH). Used when a course has no custom price.',
        },
        clubs: {
          title: 'Clubs and subscriptions',
          description: 'Base session price and discounts for 4- and 8-lesson bundles. Valid for 30 days from purchase.',
        },
        ai: {
          title: 'AI subscription (Ken)',
          description: 'Practice-with-Ken subscription: free trial, then monthly fee charged from balance.',
        },
        teacherRates: {
          title: 'Teacher rates',
          description: 'How much a teacher earns per lesson, depending on level. Intern = new teacher on trial (first lesson free). Then Junior → Middle → Senior → Lead.',
        },
        penalties: {
          title: 'Teacher penalties',
          description: 'Amount deducted from teacher payout when they no-show a lesson.',
        },
        referral: {
          title: 'Referral bonuses',
          description: 'When an invited student tops up their balance by the specified amount within N days of registration, both they and the referrer receive a bonus.',
        },
      },
      fields: {
        lesson_price_individual: 'Individual lesson',
        lesson_price_group: 'Group lesson',
        lesson_price_club: 'Club session (single)',
        club_session_base_price: 'Base session price in subscription',
        club_subscription_discount_4: '4-lesson bundle discount',
        club_subscription_discount_8: '8-lesson bundle discount',
        ai_subscription_price_uah: 'Subscription price',
        ai_subscription_duration_days: 'Subscription duration',
        ai_trial_days: 'Free trial period',
        teacher_cancelled_late_percent: 'Payment for late cancellation',
        penalty_individual_no_show: 'No-show on individual lesson',
        penalty_group_no_show: 'No-show on group lesson',
        penalty_club_no_show: 'No-show on club session',
        referral_min_topup: 'Minimum top-up by referred student',
        referral_bonus_amount: 'Bonus for both (referred and referrer)',
        referral_window_days: 'Activation window from registration',
        rateTypeIndividual: 'Individual lesson',
        rateTypeGroup: 'Group lesson',
        rateTypeClub: 'Club session',
      },
      requisites: {
        title: 'Payment details',
        notFilled: 'Not filled',
        help: 'Students will see these details when topping up their balance.',
        cardNumber: 'Card number',
        cardholderName: 'Cardholder name (Latin)',
        bankName: 'Bank name',
        additionalInfo: 'Additional information',
        additionalInfoPlaceholder: 'Payment purpose, notes for students...',
      },
    },
    schedule: {
      addLesson: 'Add lesson',
      editLesson: 'Edit lesson',
      newLesson: 'Add new lesson',
      student: 'Student',
      selectStudent: 'Select a student',
      teacher: 'Teacher',
      selectTeacher: 'Select a teacher',
      dateTime: 'Date and time',
      duration: 'Duration (minutes)',
      minutes: '{{count}} minutes',
      lessonType: 'Lesson type',
      typeIndividual: 'Individual',
      typeTrial: 'Trial',
      typeGroup: 'Group',
      program: 'Program (optional)',
      noProgram: 'No program',
      programLesson: 'Program lesson',
      selectLesson: 'Select a lesson',
      cancel: 'Cancel',
      saveChanges: 'Save changes',
      requiredFieldsError: 'Please fill in all required fields',
      error: 'Error',
      totalLessons: 'Total lessons',
      individualLessons: 'Individual',
      trialLessons: 'Trial',
      groupLessons: 'Group',
      colDateTime: 'Date and time',
      colStudent: 'Student',
      colTeacher: 'Teacher',
      colType: 'Type',
      colProgramLesson: 'Program / Lesson',
      colDuration: 'Duration',
      colActions: 'Actions',
      minutesShort: 'min',
      edit: 'Edit',
      delete: 'Delete',
      empty: 'No scheduled lessons',
      addFirst: 'Add the first lesson',
      deleteTitle: 'Delete lesson?',
      deleteMessage: 'Are you sure you want to delete this lesson?',
    },
    penalties: {
      lessonTypes: {
        individual: 'Individual',
        group: 'Group',
        club: 'Club',
      },
      statsTotal: 'Total penalties',
      statsActive: 'Active',
      statsWaived: 'Waived',
      statsActiveAmount: 'Active amount',
      currency: 'UAH',
      filters: 'Filters:',
      allTeachers: 'All teachers',
      allStatuses: 'All statuses',
      statusPending: 'Active',
      statusWaived: 'Waived',
      allTypes: 'All types',
      typeIndividual: 'Individual',
      typeGroup: 'Group',
      typeClub: 'Clubs',
      resetFilters: 'Reset filters',
      colDate: 'Date',
      colTeacher: 'Teacher',
      colType: 'Type',
      colReason: 'Reason',
      colStatus: 'Status',
      colAmount: 'Amount',
      colActions: 'Actions',
      loading: 'Loading...',
      empty: 'No penalties found',
      studentLabel: 'Student: {{name}}',
      statusActive: 'Active',
      statusWaivedBadge: 'Waived',
      waive: 'Waive',
      showing: 'Showing {{from}} - {{to}} of {{total}}',
      back: 'Back',
      next: 'Next',
      topTitle: 'Teachers with the largest penalty amount',
      penaltyCount: '({{count}} penalties)',
      confirmTitle: 'Waive penalty?',
      confirmMessage: 'Are you sure you want to waive the penalty',
      confirmForTeacher: 'for teacher',
      reasonLabel: 'Waiver reason *',
      reasonPlaceholder: 'Specify the reason for waiving the penalty...',
      cancel: 'Cancel',
      waiving: 'Waiving...',
      waivePenalty: 'Waive penalty',
      waiveReasonRequired: 'Specify the reason for waiving the penalty',
      waiveError: 'Error waiving the penalty',
    },
    payments: {
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      pendingCount: '{{count}} pending',
      requisites: 'Payment details',
      addRequisites: 'Add payment details',
      filterPending: 'Pending',
      filterApproved: 'Approved',
      filterRejected: 'Rejected',
      filterAll: 'All',
      loading: 'Loading...',
      emptyPending: 'No payments awaiting review',
      empty: 'No payments',
      colStudent: 'Student',
      colAmount: 'Amount',
      colDate: 'Date',
      colReceipt: 'Receipt',
      colStatus: 'Status',
      colActions: 'Actions',
      currencyUnit: 'UAH',
      editAmount: 'Edit amount',
      adjustedNote: '(adjusted: {{amount}} UAH)',
      view: 'View',
      approve: 'Approve',
      reject: 'Reject',
      receiptTitle: 'Receipt',
      declineTitle: 'Payment decline',
      declineHelp: 'Specify the rejection reason. The student will see this information.',
      declinePlaceholder: 'Rejection reason...',
      cancel: 'Cancel',
      requisitesTitle: 'Payment details',
      requisitesHelp: 'Students will see these details when topping up their balance',
      cardNumber: 'Card number',
      cardholderName: 'Cardholder name (Latin)',
      bankName: 'Bank name',
      additionalInfo: 'Additional information',
      additionalInfoPlaceholder: 'Payment purpose, notes for students...',
      saved: 'Saved',
      saving: 'Saving...',
      save: 'Save',
    },
    sessions: {
      title: 'Sessions',
      tabActive: 'Live',
      tabScheduled: 'Scheduled',
      tabHistory: 'History',
      selectDate: 'Date',
      emptyScheduled: 'No scheduled lessons on this day.',
      live: 'LIVE',
      inProgress: 'In progress',
      inRoom: 'in room',
      stillInRoom: 'still in room',
      noSessions: 'No sessions.',
      teacher: 'Teacher',
      student: 'Student',
      presentation: 'Presentation',
      noPresentation: 'not assigned',
      joinedAt: 'Joined',
      leftAt: 'Left',
      minutesShort: 'min',
      eventTimeline: 'Event timeline',
      eventJoined: 'joined',
      eventLeft: 'left',
      eventHeartbeat: 'online',
      showTimeline: 'Show timeline',
      hideTimeline: 'Hide timeline',
      loading: 'Loading…',
      loadingEvents: 'Loading events…',
      loadError: 'Failed to load sessions',
      emptyActive: 'No active sessions right now.',
      emptyHistory: 'No session history.',
      noEvents: 'No events.',
      refresh: 'Refresh',
      reschedule: 'Reschedule',
      cancel: 'Cancel',
      cancelConfirmTitle: 'Cancel lesson?',
      cancelConfirmMessage: 'Are you sure you want to cancel this lesson? Depending on the rules, the student will get a refund, a prepayment transfer, or a late-cancellation charge.',
      cancelReason: 'Cancelled by admin',
      cancelError: 'Failed to cancel lesson',
      cancelConfirmBtn: 'Cancel lesson',
      recordLesson: 'Record lesson',
      recordLessonHint: 'Recording is stored in Google Drive and shown in the History tab.',
      recordToggleError: 'Failed to update recording setting',
      watchRecording: 'Watch recording',
      watchRecordingPart: 'Recording — part {{n}}',
      recordingStatusStarting: 'Preparing recording…',
      recordingStatusRecording: 'Recording',
      recordingStatusUploading: 'Uploading to Drive…',
      recordingStatusFailed: 'Recording failed',
      recordingStatusWaiting: 'Recording waits for the lesson to end',
      groupAutoRecordHint: 'Group lessons are recorded automatically when any student of the group is absent.',
    },
    teacherLeaves: {
      types: {
        vacation: 'Vacation',
        sick: 'Sick leave',
        force_majeure: 'Force majeure',
        day_off: 'Day off',
      },
      statuses: {
        approved: 'Approved',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
      historyFilters: {
        all: 'All',
        approved: 'Approved',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
      lessonOutcome: {
        substitute: 'Substitute: {{name}}',
        pause: 'Paused',
        pending: 'Awaiting decision',
        completed: 'Conducted',
        cancelled: 'Cancelled',
      },
      hoursSpan: '1 d., hours',
      daysSpan: '{{count}} d.',
      reasonPrefix: 'Rejection reason: {{reason}}',
      submitted: 'Submitted: {{when}}',
      processed: 'Processed',
      approvedAt: 'Approved',
      rejectedAt: 'Rejected',
      approveBtn: 'Approve',
      rejectBtn: 'Reject',
      rejectReasonPlaceholder: 'Rejection reason (optional)',
      confirmReject: 'Confirm rejection',
      affectedLessonsPending: 'Lessons that will be affected',
      affectedLessonsDecided: 'Lessons and decisions',
      loading: 'Loading…',
      noLessonsInPeriod: 'No lessons in this period.',
      totalLabel: 'Total:',
      substituteLabel: 'Substitute:',
      pauseLabel: 'Paused:',
      pendingLabel: 'Pending:',
      completedLabel: 'Conducted:',
      confirmApproveTitle: 'Approve leave?',
      confirmApproveMessage: 'Approve leave for {{name}}?',
      confirmApproveConfirm: 'Approve',
      pendingCount: '{{count}} pending',
      noRequests: 'No new requests.',
      historyTitle: 'History',
      historyEmpty: 'History is empty.',
    },
    bookDictionary: {
      tabWords: 'Words',
      tabOccurrences: 'By occurrences',
      tabSentences: 'Sentences',
      filterAll: 'All',
      filterPending: 'Not approved',
      filterVerified: 'Approved',
      filterMissingTranslation: 'No translation',
      filterMissingIpa: 'No transcription',
      filterMissingAudio: 'No audio',
      resetAllTitle: 'Remove all overrides for this book',
      resetAll: 'Reset all ({{count}})',
      searchWord: 'Search by word...',
      searchInChapter: 'Search in chapter {{chapter}}...',
      searchSentence: 'Search sentence (en/uk)...',
      noWordsForFilter: 'No words match the selected filter.',
      noOccurrencesForFilter: 'No occurrences match the selected filter.',
      noSentencesForFilter: 'No sentences match the selected filter.',
      noOccurrencesBuilt: 'The occurrences table has not been built for this book yet. Try re-uploading the book or run "Refresh translation".',
      chapterLabel: 'Chapter:',
      chapterOption: '{{index}}. {{title}} ({{total}} words{{missing}})',
      chapterMissingSuffix: ', {{count}} without translation',
      chapterStats: 'In chapter: {{total}} words · {{missing}} without translation · {{verified}} approved',
      chapterCol: 'Chapter {{chapter}}',
      noTranslation: 'no translation',
      listen: 'Listen',
      verifiedShort: 'OK',
      approve: 'Approve',
      approvedTip: 'Approved — click to revoke',
      fieldTranslation: 'Translation',
      fieldTranslationOccurrence: 'Translation (this occurrence only)',
      fieldIpa: 'Transcription (IPA)',
      fieldPartOfSpeech: 'Part of speech',
      fieldAudio: 'Audio',
      fieldAudioUrl: 'Audio URL',
      fieldSentenceUk: 'Sentence translation (uk)',
      audioRemove: 'Remove',
      audioEmpty: 'no audio',
      audioUpload: 'Upload mp3',
      overrideBadge: 'Override for this book',
      overrideHint: 'Global translation (override will be created on save)',
      savedFlash: 'saved',
      resetOverrideTip: 'Remove override',
      resetOverride: 'Reset',
      save: 'Save',
      occurrenceScopeNote: 'Changes apply only to this specific occurrence',
      confirmResetAll: 'Reset all {{count}} overrides for this book? Words will revert to the global dictionary.',
      confirmResetWord: 'Reset override for "{{word}}"? The word will revert to the global translation.',
      confirmResetSentence: 'Reset override? The sentence will revert to the global translation.',
      paginationRange: '{{from}}–{{to}} of {{total}}',
    },
    clubsManager: {
      colName: 'Name',
      colType: 'Type',
      colLevels: 'Levels',
      colDateTime: 'Date & time',
      colTeacher: 'Teacher',
      colSeats: 'Seats',
      colReserve: 'Reserve',
      colActions: 'Actions',
      queueBadge: '{{count}} in queue',
      editTip: 'Edit',
      deleteTip: 'Delete',
      tabScheduled: 'Scheduled clubs',
      tabHistory: 'Clubs history',
      tabPresentations: 'Presentations',
      tabPricing: 'Pricing & subscriptions',
      tabBookings: 'Bookings',
      createClub: 'Create club',
      statScheduled: 'Scheduled',
      statReserve: 'On reserve',
      typeMovie: 'Movie Club',
      typeBook: 'Book Club',
      typeSpeaking: 'Speaking Club',
      typeGrammar: 'Grammar Club',
      typeGame: 'Game Club',
      emptyScheduled: 'No scheduled clubs',
      createFirstClub: 'Create the first club',
      statHeldClubs: 'Clubs held',
      statTotalParticipants: 'Total participants',
      statAvgOccupancy: 'Average occupancy',
      emptyHistory: 'Clubs history is empty',
      pricingSingle: 'Single session (any club)',
      pricingSub4Title: '4-session subscription',
      pricingSub8Title: '8-session subscription',
      pricingSubDuration: 'Validity: 30 days',
      currencyUah: 'UAH',
      savePricing: 'Save pricing',
      pricingSaved: 'Pricing updated!',
      activeSubscriptionsColStudent: 'Student',
      activeSubscriptionsColClubType: 'Club type',
      activeSubscriptionsColSessions: 'Sessions',
      activeSubscriptionsColTotal: 'Total cost',
      activeSubscriptionsStatusActive: 'Active',
      emptySubscriptions: 'No subscriptions yet',
      reservationsTitle: 'Reservations (queue)',
      reservationsColClub: 'Club',
      reservationsColClubDate: 'Club date',
      reservationsColPosition: 'Position',
      reservationsColPayment: 'Payment',
      reservationsColFrozen: 'Frozen',
      paymentSubscription: 'Subscription',
      paymentBalance: 'Balance',
      frozenSession: '1 session',
      emptyReservations: 'No active reservations',
      bookingsColStatus: 'Status',
      bookingsColAmount: 'Amount',
      bookingBooked: 'Booked',
      bookingCancelled: 'Cancelled',
      bookingCancelledLate: 'Late cancel',
      emptyBookings: 'No bookings yet',
      uploadPdf: 'Upload PDF',
      createPresentation: 'Create presentation',
      slidesCount: '{{count}} slides',
      renameTip: 'Rename',
      updatedOn: 'Updated: {{date}}',
      openInEditor: 'Open in editor',
      edit: 'Edit',
      preview: 'Preview',
      duplicateTip: 'Duplicate',
      copySuffix: '(copy)',
      emptyPresentations: 'No presentations yet',
      createFirstPresentation: 'Create your first presentation',
      editPresentation: 'Edit presentation',
      newPresentation: 'Create new presentation',
      presentationTitleLabel: 'Presentation title',
      presentationTitlePlaceholder: 'For example: Movie Club - Inception',
      presentationAfterCreateHint: 'After creating, you can add slides in the editor.',
      uploadTitle: 'Upload presentation',
      uploadTitleDefault: 'Club presentation',
      uploadDropText: 'Drop a PDF or images here',
      uploadClickText: 'or click to select files',
      uploadChoose: 'Choose files',
      uploadHint: 'Supported: PDF (up to 50MB), PNG, JPEG, WebP (up to 10MB each)',
      uploadClear: 'Clear',
      imagesCount: '{{count}} images',
      uploading: 'Uploading...',
      upload: 'Upload',
      editClub: 'Edit club',
      newClub: 'Create new club',
      formName: 'Name',
      formType: 'Type',
      formLevels: 'Levels',
      formAudience: 'Audience',
      audienceChild: 'Kids',
      audienceTeen: 'Teens',
      audienceAdult: 'Adults',
      formDescription: 'Description',
      formImage: 'Club image',
      formImageAspect: '(16:9)',
      formImageHint: 'Recommended 16:9 format (e.g. 1920x1080)',
      formImageReplace: 'Replace',
      formImageDelete: 'Remove image',
      formImageCta: 'Click to upload',
      formImageFormats: 'JPEG, PNG, GIF, WebP up to 10MB',
      formDateTime: 'Date & time',
      formTeacher: 'Teacher',
      teacherPlaceholderNoDate: 'Pick date & time first',
      teacherPlaceholderLoading: 'Loading...',
      teacherPlaceholderChoose: 'Choose teacher',
      teacherLoadError: 'Failed to load teachers: {{error}}',
      teacherNoAvailable: 'No teachers available at this time. Choose another time or configure teacher working hours.',
      teacherPickDateFirst: 'Pick date & time to see available teachers.',
      formMaxParticipants: 'Max participants',
      formDuration: 'Duration (min)',
      formPresentation: 'Presentation',
      formPresentationNone: 'No presentation',
      formPresentationOption: '{{title}} ({{count}} slides)',
      formPresentationSearch: 'Search by name...',
      formPresentationNoResults: 'No results',
      formPresentationLoading: 'Loading presentations...',
      formPresentationEmpty: 'No available presentations. Create one in the "Programs" tab.',
      cancel: 'Cancel',
      save: 'Save',
      create: 'Create',
      saveChanges: 'Save changes',
      levelPickRequired: 'Pick at least one level',
      requiredMark: '*',
      errorTitle: 'Error',
      successTitle: 'Success',
      errChooseTeacher: 'Choose a teacher for the club',
      errChooseLevel: 'Pick at least one level',
      errSaveClub: 'Failed to save the club',
      errClubGeneric: 'Failed to save the club. Check your server connection.',
      errImageFormat: 'Allowed formats: JPEG, PNG, GIF, WebP',
      errImageSize: 'Max file size: 10MB',
      errImageUpload: 'Failed to upload the image',
      errSelectFiles: 'Select files to upload',
      errUploadPresentation: 'Failed to upload presentation',
      errPresentationTitle: 'Enter presentation title',
      errSavePresentation: 'Failed to save presentation',
      errPresentationGeneric: 'Failed to save presentation',
      errDeletePresentation: 'Failed to delete presentation',
      confirmDeleteClubTitle: 'Delete club?',
      confirmDeleteClubMessage: 'Delete this club?',
      confirmDeletePresTitle: 'Delete presentation?',
      confirmDeletePresMessage: 'This action cannot be undone. All slides will be deleted.',
      presentationUpdated: 'Presentation updated',
      presentationCreated: 'Presentation created',
      presentationDeleted: 'Presentation deleted',
    },
    finance: {
      pendingBadge: '{{count}} pending',
      replenishBalance: 'Top up balance',
      deductFunds: 'Deduct funds',
      grantStars: 'Grant stars',
      deductStars: 'Deduct stars',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      filterPending: 'Pending',
      filterApproved: 'Approved',
      filterRejected: 'Rejected',
      filterDirect: 'Direct top-ups',
      filterDeductions: 'Deductions',
      filterAll: 'All',
      loading: 'Loading...',
      emptyDeductions: 'No deductions',
      emptyDeductionsHint: 'Direct admin deductions will appear here',
      emptyDirect: 'No direct top-ups',
      emptyDirectHint: 'Direct admin top-ups will appear here',
      emptyPending: 'No payments to review',
      emptyPayments: 'No payments',
      colStudent: 'Student',
      colAmount: 'Amount',
      colDate: 'Date',
      colAdmin: 'Admin',
      colMessage: 'Message',
      colReceipt: 'Receipt',
      colStatus: 'Status',
      colActions: 'Actions',
      currencyUah: 'UAH',
      showingRange: 'Showing {{from}} - {{to}} of {{total}}',
      prev: 'Back',
      next: 'Next',
      viewReceipt: 'View',
      editAmountTip: 'Edit amount',
      adjustedAmount: '(adjusted: {{amount}} UAH)',
      approve: 'Approve',
      reject: 'Reject',
      receiptTitle: 'Receipt',
      rejectTitle: 'Payment rejection',
      rejectHint: 'Please specify the reason for rejection. The student will see this.',
      rejectPlaceholder: 'Reason for rejection...',
      cancel: 'Cancel',
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      loadErrorStatus: 'Failed to load: {{status}}',
      loadErrorConn: 'Server connection error',
      salaryTotalEarned: 'Total earnings',
      salaryPaid: 'Paid out',
      salaryPending: 'Pending payout',
      salaryTeachers: 'Teachers',
      salaryPeriodMonth: '{{month}} {{year}}',
      salaryPaidThisMonth: 'This month',
      salaryPendingHint: 'For lessons conducted',
      salaryWithEarnings: 'With earnings',
      salaryColTeacher: 'Teacher',
      salaryColLessons: 'Lessons',
      salaryColEarned: 'Earned',
      salaryColPenalties: 'Penalties',
      salaryColToPay: 'To pay',
      salaryColStatus: 'Status',
      salaryColActions: 'Actions',
      salaryHours: '{{count}} h',
      salaryStatusPaid: 'Paid',
      salaryStatusPartial: 'Partial',
      salaryStatusPending: 'Pending',
      salaryPay: 'Pay out',
      lessonsIndShort: '{{count}} ind.',
      lessonsGrpShort: '{{count}} grp.',
      lessonsClubShort: '{{count}} club',
      salaryEmpty: 'No salary data',
      salaryEmptyHint: 'No lessons in this period',
      salaryExpandTitle: 'Show earnings history',
      salaryCollapseTitle: 'Hide earnings history',
      salaryBreakdownLessons: 'Lessons',
      salaryBreakdownPenalties: 'Penalties',
      salaryBreakdownEmpty: 'No details for this month',
      salaryBreakdownDate: 'Date',
      salaryBreakdownStudent: 'Student',
      salaryBreakdownType: 'Type',
      salaryBreakdownStatus: 'Status',
      salaryBreakdownAmount: 'Amount',
      salaryBreakdownReason: 'Reason',
      salaryLessonCatIndividual: 'Individual',
      salaryLessonCatGroup: 'Group',
      salaryLessonCatClub: 'Club',
      salaryLessonCatCancelledLate: 'Late cancellation',
      salaryLessonCatMissed: 'Student no-show',
      salaryLessonCatTeacherShort: 'Teacher late',
      salaryLessonCatBothNoShow: 'Nobody showed up',
      salaryLoadErrorBreakdown: 'Failed to load history',
      salaryPenaltyStatusPending: 'Pending',
      salaryPenaltyStatusDeducted: 'Deducted',
      salaryPenaltyStatusWaived: 'Waived',
      salaryBreakdownLoading: 'Loading...',
      payTitle: 'Salary payout',
      payTeacherLabel: 'Teacher:',
      payAmount: 'Amount to pay',
      payExpected: 'Expected: {{amount}} UAH',
      payMethod: 'Payment method',
      payMethodCash: 'Cash',
      payMethodCard: 'Card',
      payMethodBank: 'Bank transfer',
      payNotes: 'Note',
      payNotesPlaceholder: 'Optional',
      payReceipt: 'Receipt (transfer screenshot)',
      payReceiptUrlPlaceholder: 'Image URL or upload a file',
      payUpload: 'Upload file',
      payUploading: 'Uploading...',
      payView: 'View',
      payErrImageUpload: 'Image upload error',
      payErrSalary: 'Salary payout error',
      payConfirm: 'Confirm payout',
      rangeAllTime: 'All time',
      rangeYear: 'Year',
      rangeMonth: 'Month',
      statTopups: 'Topped up',
      statCharged: 'Charged',
      statPeriodBalance: 'Period balance',
      statTotalBalances: 'Total balances',
      statLessonsPurchases: 'Lessons, purchases',
      statPeriodBalanceHint: 'Top-ups - charges',
      statTotalBalancesHint: 'Current student balances',
      statPeriodAllTime: 'All time',
      statPeriodYear: '{{year}}',
      chargesByServices: 'Charges by service type',
      typeIndividual: 'Individual',
      typeGroup: 'Group',
      typeClubs: 'Clubs',
      typeCourses: 'Courses',
      typeShop: 'Shop',
      typeStars: 'Star purchases',
      typeSubscription: 'Subscription',
      txCount: '{{count}} transactions',
      historyTitle: 'Transaction history',
      typeAll: 'All types',
      typeTopup: 'Top-up',
      typeLessonPayment: 'Lesson payment',
      typePurchases: 'Purchases',
      typeBonuses: 'Bonuses',
      typeRefunds: 'Refunds',
      typeShopPurchase: 'Shop purchase',
      typeClubPayment: 'Club (subscription)',
      typeAiSubscription: 'Subscription',
      typeBonus: 'Bonus',
      typeRefund: 'Refund',
      typeGroupLesson: 'Group lesson',
      typeClubLesson: 'Club (session)',
      typeCourse: 'Course',
      typeIndividualLesson: 'Individual lesson',
      colType: 'Type',
      colDescription: 'Description',
      colReason: 'Reason',
      colLessonType: 'Type',
      colTeacher: 'Teacher',
      colTeacherPayoutStatus: 'Status',
      txEmpty: 'No transactions found',
      penTotalCount: 'Total penalties',
      penActive: 'Active',
      penWaived: 'Waived',
      penActiveAmount: 'Active amount',
      filtersLabel: 'Filters:',
      penAllTeachers: 'All teachers',
      penAllStatuses: 'All statuses',
      penStatusPending: 'Active',
      penStatusWaived: 'Waived',
      penTypeAll: 'All types',
      penTypeIndividual: 'Individual',
      penTypeGroup: 'Group',
      penTypeClub: 'Clubs',
      resetFilters: 'Reset filters',
      penListTitle: 'Penalty list',
      penColDate: 'Date',
      penColTeacher: 'Teacher',
      penColLessonType: 'Type',
      penColReason: 'Reason',
      penColStatus: 'Status',
      penColActions: 'Actions',
      penColSum: 'Amount',
      penStudentLabel: 'Student: {{name}}',
      penBadgeActive: 'Active',
      penBadgeWaived: 'Waived',
      penEmpty: 'No penalties found',
      penWaive: 'Waive',
      penTopTeachers: 'Teachers with the highest penalty totals',
      penTopCount: '({{count}} penalties)',
      penWaiveTitle: 'Waive penalty?',
      penWaiveConfirmMessage: 'Are you sure you want to waive the {{amount}} UAH penalty for {{name}}?',
      penWaiveReasonLabel: 'Reason for waiving *',
      penWaiveReasonPlaceholder: 'Enter the reason for waiving the penalty...',
      penWaiveReasonRequired: 'Enter the reason for waiving the penalty',
      penWaiveErr: 'Failed to waive penalty',
      penDismiss: 'Cancel',
      penWaiving: 'Waiving...',
      penWaiveSubmit: 'Waive penalty',
      lessonIndividual: 'Individual',
      lessonGroup: 'Group',
      lessonClub: 'Club',
    },
    courses: {
      stepTypeVideo: 'Video',
      stepTypeText: 'Notes',
      stepTypeExercise: 'Exercise',
      exerciseTest: 'Test (single correct)',
      exerciseMultiple: 'Multiple Choice (several correct)',
      exerciseInput: 'Type an answer',
      exerciseMatching: 'Matching',
      levelA1: 'A1 - Beginner',
      levelA2: 'A2 - Elementary',
      levelB1: 'B1 - Intermediate',
      levelB2: 'B2 - Upper-intermediate',
      levelC1: 'C1 - Advanced',
      levelC2: 'C2 - Proficient',
      successTitle: 'Success',
      errorTitle: 'Error',
      courseCreated: 'Course "{{name}}" created',
      courseCreateError: 'Failed to create course: {{error}}',
      // Course listing
      subtitle: 'Manage learning courses',
      createCourse: 'Create course',
      courseName: 'Course name',
      courseNamePlaceholder: 'Enter course name...',
      searchCourses: 'Search courses...',
      loadingCourses: 'Loading courses...',
      emptyCreateFirst: 'Create your first course to get started',
      priceGrn: '{{price}} UAH',
      duplicateCourse: 'Duplicate course',
      deleteCourse: 'Delete course',
      published: 'Published',
      draft: 'Draft',
      // Course editor
      editingCourse: 'Editing course',
      tabDetails: 'Course details',
      tabLanding: 'Landing page',
      tabMaterials: 'Course materials',
      courseCover: 'Course cover',
      courseCoverAlt: 'Course cover',
      remove: 'Remove',
      change: 'Change',
      uploadImageHint: 'Click to upload an image',
      uploadImageFormats: 'PNG, JPG up to 5MB, 40:23 ratio',
      courseDescription: 'Course description',
      courseDescriptionPlaceholder: 'Enter course description...',
      courseLevel: 'Course level',
      priceUAH: 'Course price (UAH)',
      preview: 'Preview',
      unpublish: 'Unpublish',
      publish: 'Publish course',
      // Initial test section
      initialTest: 'Initial test',
      initialTestDescription: 'The placement test is automatically pulled from the course materials',
      testModeNMT: 'NMT',
      testModeNormal: 'Normal',
      questionsCount: '{{count}} questions',
      pointsCount: '{{count}} points',
      questionsPointsInfo: '{{questions}} questions · {{points}} points',
      edit: 'Edit',
      testNotCreated: 'Test not created',
      createInitialTestPrompt: 'Create the initial test for the course',
      createTest: 'Create test',
      // Landing tab
      whatStudentSees: 'What the student sees',
      landingInfoDescription: 'Information displayed on the course landing page for the student',
      levelLabel: 'Level: {{level}}',
      notSpecified: 'Not specified',
      courseProgress: 'Course progress',
      initialTestResult: 'Initial test result',
      notPassed: 'Not passed',
      blocksCount: 'Number of blocks',
      totalLessonsCount: 'Total number of lessons',
      progressTable: 'Progress table',
      courseStructureDescription: 'Course structure with student completion marks',
      colBlock: 'Block',
      colLessons: 'Lessons',
      colStatus: 'Status',
      lessonsCount: '{{count}} lessons',
      plusTest: '+ test',
      notStarted: 'Not started',
      addBlocksHint: 'Add blocks and lessons in the "Course materials" tab',
      initialTestNMT: 'Initial test (NMT)',
      initialTestOptional: 'Optional. Test for determining students\' starting level.',
      withInitialTest: 'Add test',
      withoutInitialTest: 'Without test',
      noInitialTest: 'Course without initial test',
      changeInitialTestChoice: 'Change',
      deleteInitialTest: 'Delete test',
      deleteInitialTestTitle: 'Delete initial test?',
      deleteInitialTestMessage: 'All questions will be removed. The course will remain without an initial test.',
      create: 'Create',
      // Materials tab / blocks
      addBlock: 'Add block',
      blockName: 'Block name',
      blockNamePlaceholder: 'Enter block name...',
      save: 'Save',
      cancel: 'Cancel',
      editName: 'Edit name',
      deleteBlock: 'Delete block',
      subBlocksCountOne: '{{count}} sub-block',
      subBlocksCountFew: '{{count}} sub-blocks',
      subBlocksCountMany: '{{count}} sub-blocks',
      addLesson: 'Add lesson',
      addSubBlock: 'Add sub-block',
      subBlockName: 'Sub-block name',
      subBlockNamePlaceholder: 'Enter sub-block name...',
      lessonName: 'Lesson name',
      lessonNamePlaceholder: 'Enter lesson name...',
      subBlocksLabel: 'Sub-blocks',
      lessonsInBlockLabel: 'Block lessons',
      deleteSubBlock: 'Delete sub-block',
      noLessonsInSubBlock: 'No lessons in this sub-block yet',
      deleteLesson: 'Delete lesson',
      stepsCount: '{{count}} steps',
      questionsCountShort: '{{count}} questions',
      noLessonsInBlock: 'No lessons or sub-blocks in this block yet',
      courseMaterialsTitle: 'Course materials',
      courseMaterialsWillBeHere: 'Course materials will appear here',
      // Preview / lesson viewing
      previewCourse: 'Course preview',
      studentCabinet: '• Student cabinet',
      home: 'Home',
      videoLabel: 'Video',
      notesLabel: 'Notes',
      exerciseLabel: 'Exercise',
      videoNotAdded: 'No video added',
      videoUrlLabel: 'Video: {{url}}',
      notesEmpty: 'Notes are empty',
      optionN: 'Option {{n}}',
      enterYourAnswer: 'Enter your answer...',
      correctAnswer: 'Correct answer:',
      leftPart: 'Left part {{n}}',
      rightPart: 'Right part {{n}}',
      resultLabel: 'Result:',
      tryAgain: 'Try again',
      checkAnswer: 'Check answer',
      lessonNoMaterials: 'This lesson has no materials yet',
      prevStep: 'Previous step',
      nextStep: 'Next step',
      yourProgress: 'Your progress',
      selectLesson: 'Select a lesson to view',
      loadingCourse: 'Loading course...',
      // Lesson/step editor
      editingTest: 'Edit test',
      editingLesson: 'Edit lesson',
      testQuestions: 'Test questions',
      lessonSteps: 'Lesson steps',
      addQuestion: 'Add question',
      addStep: 'Add step',
      selectStepType: 'Select step type:',
      questionN: 'Question {{n}}',
      questionNShort: 'Question {{n}}',
      duplicateQuestion: 'Duplicate question',
      deleteQuestion: 'Delete question',
      videoName: 'Video name',
      videoNamePlaceholder: 'Enter video name...',
      video: 'Video',
      videoUploaded: 'Video uploaded',
      uploadVideo: 'Upload video',
      videoFormats: 'MP4, WebM (up to 500MB)',
      videoSaveError: 'Error saving video. Please try again.',
      notesText: 'Notes text',
      notesTextPlaceholder: 'Enter notes text...',
      notesFormattingHint: 'Formatting supported: **bold**, *italic*, - lists',
      exerciseType: 'Exercise type',
      exerciseContext: 'Material for questions',
      exerciseContextHint: 'Add text, image, audio or video that students will use to answer the questions.',
      exerciseContextText: 'Text',
      exerciseContextImage: 'Image',
      exerciseContextAudio: 'Audio',
      exerciseContextVideo: 'Video',
      exerciseContextTextPlaceholder: 'Enter text (e.g. article or dialogue) that the questions will be based on...',
      exerciseContextUploadImage: 'Upload image',
      exerciseContextUploadAudio: 'Upload audio',
      exerciseContextImageUploaded: 'Image uploaded',
      exerciseContextAudioUploaded: 'Audio uploaded',
      exerciseContextRemove: 'Remove material',
      enterQuestion: 'Enter question...',
      answerOptions: 'Answer options',
      addOption: '+ Add option',
      correctAnswerLabel: 'Correct answer',
      enterCorrectAnswer: 'Enter correct answer...',
      matchingPairs: 'Matching pairs',
      leftPartLabel: 'Left part',
      rightPartLabel: 'Right part',
      addPair: '+ Add pair',
      noQuestionsInTest: 'This test has no questions yet',
      noStepsInLesson: 'This lesson has no steps yet',
      addFirstQuestion: 'Add first question',
      addFirstStep: 'Add first step',
      backToList: 'Back to list',
      // Initial test editor (NMT)
      initialTestModeLabel: 'Placement test • Mode: {{mode}}',
      saveTest: 'Save test',
      testDisplayMode: 'Test display mode:',
      normalMode: 'Normal',
      normalModeDescription: 'Sequential question view',
      nmtMode: 'NMT',
      nmtModeDescription: 'Question navigation on top',
      addQuestionLabel: 'Add question:',
      singleAnswer: 'Single answer',
      multipleAnswers: 'Multiple answers',
      matching: 'Matching',
      fillBlank: 'Fill blank',
      readingWithText: 'Reading (with text)',
      withImages: 'With images',
      qTypeSingle: 'Single answer',
      qTypeMultiple: 'Multiple answers',
      qTypeMatching: 'Matching',
      qTypeFillBlank: 'Fill blank',
      qTypeReading: 'Reading',
      qTypeImage: 'With images',
      pointsShort: 'points',
      readingTextLabel: 'Reading text',
      readingTextPlaceholder: 'Enter reading text...',
      imageForQuestion: 'Image for question',
      optional: '(optional)',
      clickToUpload: 'Click to upload',
      questionLabel: 'Question',
      questionPlaceholder: 'Enter question text...',
      optionLetter: 'Option {{letter}}',
      fillBlankHint: 'Use ___ in the question to mark the blank',
      addQuestionsToTest: 'Add questions to the test',
      selectQuestionTypeHint: 'Select a question type above to build an NMT-format test',
      // Delete confirmations
      deleteBlockTitle: 'Delete block?',
      deleteBlockMessage: 'Are you sure you want to delete the block "{{name}}"? All lessons in this block will also be deleted.',
      deleteCourseTitle: 'Delete course?',
      deleteCourseMessage: 'Are you sure you want to delete the course "{{name}}"? This action cannot be undone.',
      deleteLessonTitle: 'Delete lesson?',
      deleteLessonMessage: 'Are you sure you want to delete the lesson "{{name}}"? This action cannot be undone.',
      confirmDelete: 'Delete',
      // Initial defaults
      initialTestDefault: 'Initial test',
      testDefault: 'Test',
    },
    overviewMonths: {
      m0: 'January', m1: 'February', m2: 'March', m3: 'April', m4: 'May', m5: 'June',
      m6: 'July', m7: 'August', m8: 'September', m9: 'October', m10: 'November', m11: 'December',
    },
    lessonsTab: {
      subTabConsultations: 'Requests',
      subTabIndividual: 'Individual lessons',
      subTabGroup: 'Group lessons',
      subTabCancelled: 'Cancelled (balance)',
      cancelledTitle: 'Cancelled due to balance',
      cancelledSubtitle: 'Lessons auto-cancelled 4 hours before start due to insufficient balance. Restore so the lesson takes place — the balance will go further into the minus.',
      cancelledEmpty: 'No upcoming lessons cancelled due to balance.',
      colLessonDate: 'Lesson date & time',
      colBalance: 'Student balance',
      colReason: 'Reason',
      reasonInsufficientBalance: 'Insufficient balance',
      reasonNegativeBalance: 'Debt (negative balance)',
      reasonCourseSuspended: 'Course suspended',
      restore: 'Restore',
      restoreConfirmTitle: 'Restore lesson?',
      restoreConfirmMessage: 'Restore the cancelled lesson for {{student}} on {{date}}? The student\'s balance will go further into the minus when the lesson completes.',
      restoreSuccessMessage: 'Lesson restored. Student and teacher have been notified.',
      restoreError: 'Failed to restore lesson',
      manageLessonsTitle: 'Manage series lessons',
      manageLessonsHint: 'Change a future lesson\'s time. Student and teacher will be notified in-app and via Telegram.',
      loadLessonsError: 'Failed to load lessons',
      seriesScheduleTitle: 'Current series schedule',
      seriesScheduleHintDays: 'Change the day and/or time for every future lesson in a slot, or add / remove days. The lesson count stays the same — future lessons are redistributed over the new schedule.',
      addDayBtn: 'Add day',
      removeDayBtn: 'Remove',
      addDayHint: 'The new day is added to the weekly schedule. Remaining lessons are redistributed, so the series ends sooner.',
      addDayDayLabel: 'Weekday:',
      addDaySelectDay: 'Select a day',
      addDayTimeLabel: 'Time (teacher working hours):',
      addDaySaveBtn: 'Add day',
      removeDayConfirmTitle: 'Remove this day from the schedule?',
      removeDayConfirmMessage: 'Lessons on {{day}} at {{time}} will no longer be scheduled. Future lessons will be redistributed over the remaining days, so the series ends later. Student and teacher will be notified.',
      weeklySlotsSuccess: 'Series schedule updated. Lessons moved: {{count}}. Last lesson: {{last}}. Student and teacher have been notified.',
      weeklySlotsError: 'Failed to change series days',
      seriesScheduleHint: 'Change the time of every future lesson in this series on the same weekday at once.',
      currentSlotTime: 'Time: {{time}}',
      changeSeriesTime: 'Change day / time',
      changeSlotSuccess: 'Series schedule updated. {{count}} lesson(s) moved. Student and teacher have been notified.',
      changeSlotError: 'Failed to update series schedule',
      changeTime: 'Change time',
      saveNewTime: 'Save',
      changeTimeSuccess: 'Lesson time updated. Student and teacher have been notified.',
      changeTimeError: 'Failed to update lesson time',
      addExtraTitle: 'Extra lesson',
      addExtraHint: 'Insert a one-off lesson into the series. The program will grow by +1 lesson and numbering will shift accordingly.',
      addExtraBtn: 'Add lesson',
      addExtraDateLabel: 'Date:',
      addExtraTimeLabel: 'Pick a free slot in the teacher\'s schedule:',
      addExtraLoadingSlots: 'Loading teacher schedule…',
      addExtraNoAvailability: 'Teacher has no working hours on this day.',
      addExtraSlotBusy: 'Slot is busy',
      addExtraFreeLabel: 'Free lesson (do not charge student\'s balance)',
      addExtraSaveBtn: 'Add',
      addExtraSuccess: 'Extra lesson added. Student and teacher have been notified.',
      addExtraError: 'Failed to add lesson',
      notEditable: 'Not editable',
      emptyLessons: 'No lessons in this series',
      lessonStatus_scheduled: 'Scheduled',
      lessonStatus_completed: 'Completed',
      lessonStatus_cancelled: 'Cancelled',
      lessonStatus_pending: 'Pending',
      lessonStatus_teacher_leave_skip: 'Skipped (teacher leave)',
      lessonStatus_vacation_skip: 'Skipped (vacation)',
      consultationsTitle: 'Consultation requests',
      consultationsSubtitle: 'Trial lesson and consultation requests',
      statAll: 'All',
      statNew: 'New',
      statContacted: 'Contacted',
      statScheduled: 'Scheduled',
      statCompleted: 'Completed',
      statNoResponse: 'No response',
      statusNew: 'New',
      statusContacted: 'Contacted',
      statusScheduled: 'Scheduled',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      statusNoResponse: 'No response',
      preferredTime: 'Preferred time:',
      scheduledOn: 'Scheduled: {{date}} at {{time}}',
      teacherLabel: 'Teacher: {{name}}',
      notesLabel: 'Notes:',
      createdOn: 'Created: {{when}}',
      titleMarkContacted: 'Mark as "Contacted"',
      titleAssignTeacher: 'Assign a teacher',
      titleMarkCompleted: 'Mark as completed',
      titleNoResponse: 'No response',
      titleDelete: 'Delete',
      emptyConsultations: 'No consultation requests',
      emptyConsultationsHint: 'New requests from the sign-up form will appear here',
      assignTitle: 'Assign a teacher',
      childLabel: 'Child: {{name}}',
      teacher: 'Teacher',
      selectTeacher: 'Select a teacher',
      date: 'Date',
      time: 'Time',
      cancel: 'Cancel',
      assignBtn: 'Assign',
      individualTitle: 'Individual lessons',
      individualSubtitle: 'Manage individual lesson series',
      createSeries: 'Create series',
      createTrial: 'Trial lesson',
      modalCreateTrial: 'Schedule a trial lesson',
      trialHint: 'One-off lesson, free for the student. Choose the teacher payment mode below.',
      trialTeacherPaymentLabel: 'Teacher payment',
      trialTeacherPaidStandard: 'Standard rate (paid as a regular individual lesson)',
      trialTeacherPaidFree: 'Free (lesson is excluded from the payout)',
      trialPickDateFirst: 'Pick a date and time first',
      trialTeacherHint: 'Only teachers who work at this time and have no other lesson on this exact date are shown',
      presentation: 'Presentation',
      searchPresentation: 'Search a presentation...',
      untitledPresentation: 'Untitled',
      createTrialBtn: 'Create trial',
      trialCreatedMessage: 'Trial lesson scheduled',
      createTrialError: 'Failed to create trial lesson',
      trialHomework: 'Homework',
      trialHomeworkNone: 'No homework',
      trialHomeworkHint: 'Sent automatically once the lesson is completed',
      trialGames: 'Repetition games',
      trialGamesSearch: 'Search a game...',
      trialGamesNone: 'No games found',
      trialGamesAllAdded: 'All available games are already added',
      trialGamesHint: 'Unlock for the student in the chosen order once the lesson is completed',
      trialGameUntitled: 'Untitled',
      trialGameMoveUp: 'Move up',
      trialGameMoveDown: 'Move down',
      trialGameRemove: 'Remove',
      statActiveSeries: 'Active series',
      statPendingPayment: 'Awaiting payment',
      statTotalStudents: 'Total students',
      statInvolvedTeachers: 'Teachers involved',
      statPaused: 'Paused',
      colStudent: 'Student',
      colTeacher: 'Teacher',
      colProgram: 'Program',
      colSchedule: 'Schedule',
      colProgress: 'Progress',
      colStatus: 'Status',
      colPayment: 'Payment',
      colActions: 'Actions',
      paid: 'Paid',
      pending: 'Pending',
      payFromBalance: 'Pay from balance',
      confirmWithoutPayment: 'Confirm without payment',
      cancelSeriesTitle: 'Cancel series?',
      cancelSeriesMessage: 'Cancel this lesson series?',
      confirmSeriesPaid: 'Confirm series with payment?',
      confirmSeriesFree: 'Confirm series without payment?',
      confirmSeriesPaidMessage: 'Payment will be deducted from the student\'s balance. The series will be activated and lessons generated in the schedule.',
      confirmSeriesFreeMessage: 'The series will be activated and lessons generated in the schedule. No payment will be deducted from the student\'s balance.',
      seriesCreatedMessage: 'Series created! Generated {{count}} lessons in the schedule.',
      seriesConfirmedMessage: 'Series confirmed! Generated {{count}} lessons.',
      awaitingPaymentTitle: 'Awaiting payment',
      awaitingPaymentMessage: 'Series created, but lessons were NOT added to the schedule!\n\nStudent balance is insufficient (need {{price}} UAH).\n\nThe student was notified to top up. The series will be cancelled after 24 hours without payment.',
      createSeriesError: 'Failed to create series',
      confirmSeriesError: 'Failed to confirm series',
      errorTitle: 'Error',
      successTitle: 'Success',
      emptySeries: 'No lesson series created',
      createFirstSeries: 'Create the first series',
      groupTitle: 'Group lessons',
      groupSubtitle: 'Manage study groups',
      createGroup: 'Create group',
      statForming: 'Forming',
      statActive: 'Active',
      statCompletedGroups: 'Completed',
      statusActive: 'Active',
      statusForming: 'Forming',
      statusPaused: 'Paused',
      statusCompletedBadge: 'Completed',
      statusCancelledBadge: 'Cancelled',
      groupProgram: 'Program:',
      groupStart: 'Start date:',
      groupStudents: 'Students:',
      groupSchedule: 'Schedule:',
      groupTeacherLabel: 'Teacher:',
      addStudentTitle: 'Add student',
      startGroupTitle: 'Start group',
      cancelTitle: 'Cancel',
      emptyGroups: 'No groups created',
      createFirstGroup: 'Create the first group',
      cancelGroupTitle: 'Cancel group?',
      cancelGroupMessage: 'Cancel this group?',
      startGroupConfirmTitle: 'Start group?',
      startGroupConfirmMessage: 'Start the group and generate lessons?',
      startGroupError: 'Failed to start group',
      groupStarted: 'Group started!',
      removeStudentTitle: 'Remove student?',
      removeStudentMessage: 'Remove the student from the group?',
      addStudentError: 'Failed to add student',
      createGroupError: 'Failed to create group',
      scheduleLabel: 'Lesson schedule',
      addDay: 'Add day',
      slotDuration: '(60 min)',
      searchingTeachers: 'Searching available teachers...',
      noAvailableTeachers: 'No teachers available for the selected time. Change the schedule.',
      teacherHint: 'Only teachers available for the selected time are shown',
      modalCreateSeries: 'Create individual lesson series',
      student: 'Student',
      searchStudent: 'Search a student...',
      studentsNotFound: 'No students found. Try a different search.',
      program: 'Program',
      selectProgram: 'Select a program',
      programOption: '{{title}} — {{count}} lessons',
      startDate: 'Start date',
      lessonsCount: 'Number of lessons',
      lessonsCountHint: 'Determined by the program',
      customPrice: 'Price per lesson (UAH)',
      customPricePlaceholder: 'Default',
      customPriceHint: 'If left blank, the default price from settings is used. When set, this price is fixed for this program and student.',
      notes: 'Notes',
      notesPlaceholder: 'Additional information...',
      addBackdated: 'Add backdated',
      addBackdatedHint: 'Create lessons with a past date (for recording already-conducted classes)',
      skipFirstLessonPrepayment: 'Skip prepayment',
      skipFirstLessonPrepaymentHint: 'Lessons appear in the schedule immediately without prepayment. Lesson 1 is charged after completion, same as all other lessons.',
      makeFirstLessonFree: 'First lesson free',
      makeFirstLessonFreeHint: 'The first lesson of the series is a gift — not charged before or after it happens. Subsequent lessons are billed normally.',
      creating: 'Creating...',
      createSeriesBtn: 'Create series',
      modalCreateGroup: 'Create group',
      groupName: 'Group name',
      groupNamePlaceholder: 'For example: B1 Evening group',
      groupStartDate: 'Start date',
      groupStartDateHint: 'Classes will appear in students\' calendars from this date',
      maxStudents: 'Max. students',
      studentsOptional: 'Students (optional)',
      searchStudents: 'Search students...',
      studentsNotFoundShort: 'No students found',
      studentsHint: 'You can add students now or later. Max: {{max}} students',
      limitTitle: 'Limit',
      maxStudentsError: 'Maximum number of students in the group: {{max}}',
      createGroupBtn: 'Create group',
      addStudentModalTitle: 'Add student to group',
      addStudentSearch: 'Search a student...',
      addStudentEmpty: 'No students found. Try a different search query.',
      statusUpdated: 'Status updated',
      statusUpdateError: 'Failed to update status',
      deleteConsultationTitle: 'Delete request?',
      deleteConsultationMessage: 'This action cannot be undone.',
      consultationDeleted: 'Request deleted',
      assignTeacherError: 'Failed to assign teacher',
      assignFieldsError: 'Fill in all fields',
      assignSuccess: 'Teacher assigned, consultation added to schedule',
      yearsShort: 'y.o.',
      atTime: 'at',
      expiresUntil: 'until',
      lessonsSuffix: 'lessons',
    },
    specialOffers: {
      newOffer: 'New offer',
      editOffer: 'Edit offer',
      tabActive: 'Active',
      tabScheduled: 'Scheduled',
      tabArchive: 'Archive',
      tabStats: 'Analytics',
      tabPromoCodes: 'Promo codes',
      offerTitle: 'Offer title',
      offerTitlePlaceholder: 'For example: 20% off the first lesson',
      description: 'Description',
      descriptionPlaceholder: 'Detailed description of the offer...',
      image: 'Image',
      imageRecommended: 'Recommended size: 1920 × 1080 px (16:9)',
      dropRelease: 'Release to upload',
      imageSize: '1920 × 1080 px',
      ctaButton: 'Call-to-action button',
      ctaText: 'Button text',
      ctaAction: 'Button action',
      linkUrl: 'Link URL',
      courseId: 'Course ID',
      productIdOpt: 'Product ID (optional)',
      selectClubs: 'Select clubs',
      allClubs: 'All clubs',
      ctaLink: 'Link',
      ctaTopup: 'Top up balance',
      ctaBookLesson: 'Book a lesson',
      ctaShop: 'Shop',
      ctaCourse: 'Course',
      ctaClub: 'Club',
      ctaFreeClub: 'Free club enrollment',
      ctaDiscountedClub: 'Discounted club enrollment',
      targetAll: 'All users',
      targetSpecific: 'Specific users',
      targetByLevel: 'By language level',
      targetNew: 'New users',
      targetActive: 'Active users',
      targetInactive: 'Inactive users',
      targetHighSpenders: 'High spenders',
      targetProductPreference: 'By preferences',
      targetNoClubSub: 'Users without a club subscription',
      deleteConfirmTitle: 'Delete offer?',
      deleteConfirmMessage: 'Are you sure you want to delete "{{title}}"?',
      titleRequired: 'Enter an offer title',
      clubsRequired: 'Select clubs for free enrollment or pick "All clubs"',
      clubsDiscountedRequired: 'Select clubs for discounted enrollment or pick "All clubs"',
      discountTypeRequired: 'Choose a discount type',
      discountValueRange: 'Enter a discount percent from 1 to 99',
      levelRequired: 'Select at least one language level',
      uploadFailed: 'Failed to upload image',
      saveFailed: 'Failed to save offer',
      created: 'Offer created',
      updated: 'Offer updated',
      deleted: 'Offer deleted',
      deleteFailed: 'Failed to delete',
      errorTitle: 'Error',
      successTitle: 'Success',
      previewTitleFallback: 'Offer title',
      previewDescFallback: 'Offer description',
      defaultCta: 'Learn more',
      loadingClubs: 'Loading clubs...',
      allAvailableClubs: 'All available clubs',
      clubsCountShort: '{{count}} clubs',
      noClubsAfter: 'No available clubs after {{date}}',
      freeLabel: 'Free',
      selectedClubsCount: 'Clubs selected: {{count}}',
      userCanChooseAnyFree: 'The user can pick any available club for free',
      userCanChooseAny: 'The user can pick any available club',
      discountType: 'Discount type',
      freeFullDiscount: 'Free (100%)',
      percentDiscount: 'Percent discount',
      percentDiscountShort: '% off',
      currencyUah: 'UAH',
      countdownTimer: 'Countdown timer',
      fixedDate: 'Fixed date',
      personalized: 'Personalized',
      minutesFromFirstView: 'minutes from first view',
      effectsConfetti: 'Effects (confetti)',
      confettiHint: 'A confetti animation will play on first display',
      targetAudience: 'Target audience',
      searchUsersPlaceholder: 'Search users...',
      chooseLanguageLevels: 'Choose language levels:',
      chooseAtLeastOneLevel: 'Choose at least one level',
      selectedPrefix: 'Selected:',
      uniqueUsers: 'Unique users',
      viewsStat: 'Views',
      modalViewsStat: 'Modal views',
      clicksStat: 'Clicks',
      ctrTotal: 'CTR (overall)',
      ctrModal: 'CTR (modal)',
      statsByDays: 'Stats by day',
      viewsLabel: 'Views',
      clicksLabel: 'Clicks',
      chooseOfferForStats: 'Choose an offer to view its stats',
      required: '*',
      registeredWithinLast: 'Registered within the last',
      daysUnit: 'days',
      minimum: 'Minimum',
      lessonsWithin30: 'lessons in the last 30 days',
      inactiveMoreThan: 'Inactive for more than',
      spentMoreThan: 'Spent more than',
      currency: 'UAH',
      validityPeriod: 'Validity period',
      startLabel: 'Start',
      endOptional: 'End (optional)',
      priority: 'Priority',
      activeLabel: 'Active',
      previewBtn: 'Preview',
      saveChanges: 'Save changes',
      createBtn: 'Create',
      emptyActive: 'No active offers',
      emptyScheduled: 'No scheduled offers',
      emptyArchive: 'Archive is empty',
      startsAt: 'Starts: {{when}}',
      endsAt: 'Ends: {{when}}',
      offerActive: 'Active',
      offerInactive: 'Inactive',
      timerTag: 'Timer',
      effectsTag: 'Effects',
      previewTooltip: 'Preview',
      analyticsTooltip: 'Analytics',
      editTooltip: 'Edit',
      deleteTooltip: 'Delete',
      pickAnother: 'Pick another offer',
    },
    products: {
      catalog: 'Catalog',
      orders: 'Orders',
      newProduct: 'New product',
      editProduct: 'Edit product',
      name: 'Product name',
      price: 'Price (UAH)',
      sku: 'Product code (SKU)',
      category: 'Category',
      catWorkbook: 'Workbook',
      catFlashcards: 'Flashcards',
      catMerch: 'Merch',
      topic: 'Topic / Purpose',
      noTopic: 'No topic',
      description: 'Description',
      availability: 'Availability',
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      addImage: 'Add',
      features: 'Specs',
      addFeature: 'Add spec',
      productPerks: 'Product perks',
      productPerksHint: 'List of benefits shown on the product page',
      addPerk: 'Add perk',
      colName: 'Name',
      colDescription: 'Description',
      colPrice: 'Price',
      colStatus: 'Status',
      colActions: 'Actions',
      emptyProducts: 'No products',
      emptyProductsHint: 'Add the first product to the catalog',
      ordersTitle: 'Orders',
      allStatuses: 'All statuses',
      statusNew: 'New',
      statusProcessing: 'Processing',
      statusShipped: 'Shipped',
      statusDelivered: 'Delivered',
      statusCancelled: 'Cancelled',
      statusNewBadge: 'New',
      statusProcessingBadge: 'Processing',
      statusShippedBadge: 'Shipped',
      statusDeliveredBadge: 'Delivered',
      statusCancelledBadge: 'Cancelled',
      statNew: 'New',
      statProcessing: 'Processing',
      statShipped: 'Shipped',
      statDelivered: 'Delivered',
      statTotal: 'Total',
      colCustomer: 'Customer',
      colDelivery: 'Delivery address',
      colProducts: 'Products',
      colTotal: 'Amount',
      colDate: 'Date',
      emptyOrders: 'No orders',
      emptyOrdersHint: 'Shop orders will appear here',
      orderNumber: 'Order #{{id}}',
      customerInfo: 'Customer info',
      nameLabel: 'Name:',
      phoneLabel: 'Phone:',
      cityLabel: 'City:',
      deliveryLabel: 'Delivery',
      deliveryMethod: 'Method:',
      deliveryBranch: 'Address/Branch:',
      novaPoshta: 'Nova Poshta',
      ukrPoshta: 'Ukrposhta',
      pickup: 'Pickup',
      payment: 'Payment',
      paidFromBalance: 'Paid from balance',
      cashOnDelivery: 'Cash on delivery',
      paid: 'Paid',
      itemsLabel: 'Items',
      total: 'Total:',
      commentLabel: 'Comment',
      inStockShort: 'In stock',
      outOfStockShort: 'Out',
      limitTitle: 'Limit',
      maxImages: 'Maximum {{max}} images',
      moreAllowed: 'You can add {{n}} more images (max {{max}})',
      errorTitle: 'Error',
      successTitle: 'Success',
      formValidation: 'Fill in the product name and price',
      imageUploadError: 'Image upload error',
      saveError: 'Failed to save product',
      deleteTitle: 'Delete product?',
      deleteMessage: 'Are you sure you want to delete this product?',
      deleteError: 'Failed to delete product',
      statusUpdateError: 'Failed to update order status',
      loading: 'Loading...',
      productsHint: 'Manage shop products: workbooks, flashcards, merch',
      addProduct: 'Add product',
      namePlaceholder: 'Enter product name',
      pricePlaceholder: '0',
      skuPlaceholder: 'e.g. WB-A1-001',
      topicGeneral: 'General English',
      topicGrammar: 'Grammar',
      topicVocabulary: 'Vocabulary',
      topicPronunciation: 'Pronunciation',
      topicBusiness: 'Business English',
      descriptionPlaceholder: 'Short product description',
      imagesLabel: 'Product images ({{current}}/{{max}})',
      imageAlt: 'Photo {{n}}',
      newImageAlt: 'New photo {{n}}',
      imageInfo: 'JPEG, PNG, GIF, WebP (up to 5 MB each, max {{max}} photos)',
      specKeyPlaceholder: 'Name (e.g. Format)',
      specValuePlaceholder: 'Value (e.g. A4)',
      featurePlaceholder: 'e.g. More than 100 practice exercises',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      close: 'Close',
      categoryCount: '{{label}} ({{count}})',
      priceUAH: '{{price}} UAH',
      ordersHint: 'Manage shop orders',
      orderNumberCol: 'Order #',
      emailLabel: 'Email:',
      dateLocale: 'en-US',
    },
    reviews: {
      allReviews: 'All reviews',
      allStudents: 'All students',
      loading: 'Loading...',
      emptyReviews: 'No reviews yet',
      teacherLabel: 'Teacher: {{name}}',
      averageRating: 'Average rating',
      totalReviews: 'Total reviews',
      allReports: 'All reports',
      thisWeek: 'This week',
      thisMonth: 'This month',
      allTeachers: 'All teachers',
      allTypes: 'All types',
      typeIndividual: 'Individual',
      typeGroup: 'Group',
      typeClub: 'Club lesson',
      typeOther: 'Other',
      emptyReports: 'No reports yet',
      studentNotSpecified: 'Not specified',
      moodExcellent: 'Excellent',
      moodGood: 'Good',
      moodNeutral: 'Neutral',
      presentStudents: 'Present students:',
      lessonTopic: 'Lesson topic:',
      duration: 'Duration:',
      studentMood: 'Student mood:',
      lessonTopics: 'Lesson topics:',
      homework: 'Homework:',
      studentProgress: 'Student progress:',
      nextLessonPlan: 'Plan for next lesson:',
      techIssues: 'Technical issues:',
      presentationErrors: 'Presentation errors:',
      badgeTechIssue: 'Technical issue',
      badgePresentationIssue: 'Presentation error',
      badgeTechAndPresentation: 'Tech & presentation issues',
      notes: 'Notes:',
      reportsThisMonth: 'Reports this month',
      reportsOnTime: 'Reports on time',
      reportsWithHomework: 'With homework',
      reportsNeedAttention: 'Need attention',
      allTickets: 'All tickets',
      ticketOpen: 'Open',
      ticketResolved: 'Resolved',
      emptyTickets: 'No tickets',
      createdOn: 'Created: {{when}}',
      totalTickets: 'Total tickets',
      openTickets: 'Open',
      resolvedTickets: 'Resolved',
      resolutionRate: 'Resolution rate',
      statusOpen: 'Open',
      statusResolved: 'Resolved',
      teacherRoleLabel: 'Teacher',
      admin: 'Admin',
      subTabReviews: 'Student reviews',
      subTabReports: 'Teacher reports',
      subTabSupport: 'Tech support',
      stars5: '5 stars',
      stars4: '4 stars',
      stars3: '3 stars',
      stars2: '2 stars',
      stars1: '1 star',
      teacherPrefix: 'Teacher: {{name}}',
      distribution5: '5 stars ({{percent}}%)',
      distribution4: '4 stars ({{percent}}%)',
      lowRatings: '≤3 stars',
      durationMinutes: '{{count}} min',
      engagementLabel: 'Engagement: {{value}}/5',
      dateAtTime: '{{date}} at {{time}}',
      closeBtn: 'Close',
      ticketCreatedOn: 'Created: {{when}}',
      markResolved: 'Mark as resolved',
      reopenTicket: 'Reopen',
      closeTicket: 'Close',
      replyPlaceholder: 'Type your reply...',
      replyHint: 'Enter — send, Shift+Enter — new line',
      senderAdmin: 'Admin',
    },
    books: {
      titleLabel: 'Title',
      authorLabel: 'Author',
      levelLabel: 'Level',
      languageLabel: 'Language',
      publishedYear: 'Published year',
      coverLabel: 'Cover (PNG/JPG, ~600×900)',
      genres: 'Genres',
      genresHint: 'You can pick one or several genres.',
      annotation: 'Annotation (Ukrainian)',
      annotationPlaceholder: 'Briefly what the book is about...',
      bookText: 'Book text',
      uploadTxt: 'Upload .txt',
      chaptersFound: 'Chapters found: {{count}}',
      noChapters: 'No chapters — will be one block',
      chaptersNotFound: 'No chapters detected',
      textPlaceholder: 'Paste the text or upload a .txt file.\n\nChapters are detected automatically if they start with:\n  CHAPTER I.   or   Chapter 1   (Project Gutenberg style)\n  ## Title     (our marker)',
      chapterHint: 'Supported headers: CHAPTER I, Chapter 1 (Project Gutenberg) and ## Title. If no markers are found — the text is stored as a single block (suitable for short works). Project Gutenberg preamble and license are trimmed automatically.',
      cancel: 'Cancel',
      saving: 'Saving...',
      save: 'Save',
      createBook: 'Create book',
      changesSaved: 'Changes saved.',
      createdMessage: 'Book created ({{chapters}} chapters, {{words}} words). Word translation runs in the background — it will take a few minutes.',
      titleAuthorRequired: 'Fill in the title and author.',
      contentRequired: 'Upload or paste the book text.',
      fileTooLarge: 'File is too large (max 5 MB).',
      fileReadError: 'Failed to read the file.',
      removeCover: 'Remove cover',
      removeShort: 'Remove',
      chaptersTitle: 'Chapter texts',
      chaptersHint: 'Expand a chapter to fix a typo or change a word. New words will be translated in the background.',
      chaptersLoading: 'Loading…',
      chaptersEmpty: 'No chapters found.',
      unnamedChapter: 'Untitled',
      wordsCount: '{{count}} words',
      saved: 'Saved',
      collapse: 'Collapse',
      edit: 'Edit',
      loadingText: 'Loading text…',
      chapterTitle: 'Chapter title',
      chapterText: 'Chapter text',
      saveChapter: 'Save chapter',
      savingChapter: 'Saving…',
      emptyChapter: 'Chapter text cannot be empty.',
    },
  },
};

export default dict;
